export const COLOR_TRANSPARENT = "eon-transparent";
export const COLOR_WHITE = "eon-white";
export const COLOR_SYSTEM_SUCCESS_LIGHT = "eon-system-success-light";
export const COLOR_SYSTEM_SUCCESS = "eon-system-success";
export const COLOR_SYSTEM_SUCCESS_DARK = "eon-system-success-dark";
export const COLOR_SYSTEM_WARNING_LIGHT = "eon-system-warning-light";
export const COLOR_SYSTEM_WARNING = "eon-system-warning";
export const COLOR_SYSTEM_WARNING_DARK = "eon-system-warning-dark";
export const COLOR_SYSTEM_ERROR_LIGHT = "eon-system-error-light";
export const COLOR_SYSTEM_ERROR = "eon-system-error";
export const COLOR_SYSTEM_ERROR_DARK = "eon-system-error-dark";
export const COLOR_SYSTEM_HIGHLIGHT_LIGHT = "eon-system-highlight-light";
export const COLOR_SYSTEM_HIGHLIGHT = "eon-system-highlight";
export const COLOR_SYSTEM_HIGHLIGHT_DARK = "eon-system-highlight-dark";
export const COLOR_GREY100 = "eon-grey100";
export const COLOR_GREY200 = "eon-grey200";
export const COLOR_GREY300 = "eon-grey300";
export const COLOR_GREY400 = "eon-grey400";
export const COLOR_GREY500 = "eon-grey500";
export const COLOR_GREY600 = "eon-grey600";
export const COLOR_GREY700 = "eon-grey700";
export const COLOR_GREY800 = "eon-grey800";
export const COLOR_GREY900 = "eon-grey900";

export const COLOR_BLUE = "eon-blue";
export const COLOR_DARKBLUE = "eon-darkblue";
export const COLOR_BLUE_ACTIVE = "eon-blue-active";
export const COLOR_GREEN = "eon-green";
export const COLOR_ORANGE = "eon-orange";
export const COLOR_ORANGE_ACTIVE = "eon-orange-active";
export const COLOR_TEAL = "eon-teal";
export const COLOR_TEAL_ACTIVE = "eon-teal-active";
export const COLOR_TURQUOISE = "eon-turquoise";
export const COLOR_TURQUOISE_ACTIVE = "eon-turquoise-active";
export const COLOR_LIGHTTEAL = "eon-lightteal";
export const COLOR_MIDDLETEAL = "eon-middleteal";
export const COLOR_LIGHTBLUE = "eon-lightblue";
export const COLOR_MIDDLEBLUE = "eon-middleblue";
export const COLOR_BLUE_BORDER = "eon-blue-border";
export const COLOR_RED = "eon-red";
export const COLOR_YELLOW = "eon-yellow";
export const COLOR_LIGHTTURQUOISE = "eon-lightturquoise";
export const COLOR_MIDDLETURQUOISE = "eon-middleturquoise";
export const COLOR_GREEN_BORDER = "eon-green-border";
export const COLOR_GREEN_ACTIVE = "eon-green-active";
export const COLOR_LIGHTGREEN = "eon-lightgreen";
export const COLOR_MIDDLEGREEN = "eon-middlegreen";
export const COLOR_LIGHTORANGE = "eon-lightorange";
export const COLOR_MIDDLEORANGE = "eon-middleorange";
export const COLOR_BRIGHT = "eon-bright";
export const COLOR_DARK = "eon-dark";
export const COLOR_LIGHT_GREY = "eon-light-grey";
export const COLOR_TRANSPARENT_GREEN = "eon-transparent-green";
export const COLOR_TRANSPARENT_RED = "eon-transparent-red";
export const COLOR_TRANSPARENT_YELLOW = "eon-transparent-yellow";
export const COLOR_TRANSPARENT_BLUE = "eon-transparent-blue";
export const COLOR_BLACK = "eon-black";
export const COLOR_BLUE_FONT = "eon-blue-font";
export const COLOR_DARKBLUE_FONT = "eon-darkblue-font";
export const COLOR_BLUE_ACTIVE_FONT = "eon-blue-active-font";
export const COLOR_GREEN_FONT = "eon-green-font";
export const COLOR_ORANGE_FONT = "eon-orange-font";
export const COLOR_ORANGE_ACTIVE_FONT = "eon-orange-active-font";
export const COLOR_TEAL_FONT = "eon-teal-font";
export const COLOR_TEAL_ACTIVE_FONT = "eon-teal-active-font";
export const COLOR_TURQUOISE_FONT = "eon-turquoise-font";
export const COLOR_TURQUOISE_ACTIVE_FONT = "eon-turquoise-active-font";
export const COLOR_LIGHTTEAL_FONT = "eon-lightteal-font";
export const COLOR_MIDDLETEAL_FONT = "eon-middleteal-font";
export const COLOR_LIGHTBLUE_FONT = "eon-lightblue-font";
export const COLOR_MIDDLEBLUE_FONT = "eon-middleblue-font";
export const COLOR_BLUE_BORDER_FONT = "eon-blue-border-font";
export const COLOR_RED_FONT = "eon-red-font";
export const COLOR_YELLOW_FONT = "eon-yellow-font";
export const COLOR_LIGHTTURQUOISE_FONT = "eon-lightturquoise-font";
export const COLOR_MIDDLETURQUOISE_FONT = "eon-middleturquoise-font";
export const COLOR_GREEN_BORDER_FONT = "eon-green-border-font";
export const COLOR_GREEN_ACTIVE_FONT = "eon-green-active-font";
export const COLOR_LIGHTGREEN_FONT = "eon-lightgreen-font";
export const COLOR_MIDDLEGREEN_FONT = "eon-middlegreen-font";
export const COLOR_LIGHTORANGE_FONT = "eon-lightorange-font";
export const COLOR_MIDDLEORANGE_FONT = "eon-middleorange-font";
export const COLOR_BRIGHT_FONT = "eon-bright-font";
export const COLOR_DARK_FONT = "eon-dark-font";
export const COLOR_LIGHT_GREY_FONT = "eon-light-grey-font";
export const COLOR_TRANSPARENT_GREEN_FONT = "eon-transparent-green-font";
export const COLOR_TRANSPARENT_RED_FONT = "eon-transparent-red-font";
export const COLOR_TRANSPARENT_YELLOW_FONT = "eon-transparent-yellow-font";
export const COLOR_TRANSPARENT_BLUE_FONT = "eon-transparent-blue-font";
export const COLOR_WHITE_FONT = "eon-white-font";
export const COLOR_BLACK_FONT = "eon-black-font";
export const COLOR_BRIGHT_BLUE = "eon-bright-blue";
export const COLOR_LIGHTER_BLUE = "eon-lighter-blue";
export const COLOR_BRIGHT_YELLOW = "eon-bright-yellow";
export const COLOR_BASE_GREY = "eon-base-grey";
export const COLOR_MIDDLE_GREY = "eon-middle-grey";
export const COLOR_DARK_GREY = "eon-dark-grey";
export const COLOR_BRIGHT_TABBAR_COLOR = "eon-bright-tabbar-color";
export const COLOR_DARK_TABBAR_COLOR = "eon-dark-tabbar-color";
export const COLOR_TAB_BORDER_COLOR = "eon-tab-border-color";
export const COLOR_BLUE_SHADE_1 = "eon-blue-shade-1";
export const COLOR_BLUE_SHADE_2 = "eon-blue-shade-2";
export const COLOR_BLUE_TINT_1 = "eon-blue-tint-1";
export const COLOR_BLUE_TINT_2 = "eon-blue-tint-2";
export const COLOR_BLUE_5 = "eon-blue-5";
export const COLOR_BLUE_10 = "eon-blue-10";
export const COLOR_BLUE_15 = "eon-blue-15";
export const COLOR_BLUE_20 = "eon-blue-20";
export const COLOR_BLUE_25 = "eon-blue-25";
export const COLOR_BLUE_30 = "eon-blue-30";
export const COLOR_BLUE_35 = "eon-blue-35";
export const COLOR_BLUE_40 = "eon-blue-40";
export const COLOR_BLUE_45 = "eon-blue-45";
export const COLOR_BLUE_50 = "eon-blue-50";
export const COLOR_BLUE_55 = "eon-blue-55";
export const COLOR_BLUE_60 = "eon-blue-60";
export const COLOR_BLUE_65 = "eon-blue-65";
export const COLOR_BLUE_70 = "eon-blue-70";
export const COLOR_BLUE_75 = "eon-blue-75";
export const COLOR_BLUE_80 = "eon-blue-80";
export const COLOR_BLUE_85 = "eon-blue-85";
export const COLOR_BLUE_90 = "eon-blue-90";
export const COLOR_BLUE_95 = "eon-blue-95";
export const COLOR_BLUE_OPACITY_5 = "eon-blue-opacity-5";
export const COLOR_BLUE_OPACITY_10 = "eon-blue-opacity-10";
export const COLOR_BLUE_OPACITY_15 = "eon-blue-opacity-15";
export const COLOR_BLUE_OPACITY_20 = "eon-blue-opacity-20";
export const COLOR_BLUE_OPACITY_25 = "eon-blue-opacity-25";
export const COLOR_BLUE_OPACITY_30 = "eon-blue-opacity-30";
export const COLOR_BLUE_OPACITY_35 = "eon-blue-opacity-35";
export const COLOR_BLUE_OPACITY_40 = "eon-blue-opacity-40";
export const COLOR_BLUE_OPACITY_45 = "eon-blue-opacity-45";
export const COLOR_BLUE_OPACITY_50 = "eon-blue-opacity-50";
export const COLOR_BLUE_OPACITY_55 = "eon-blue-opacity-55";
export const COLOR_BLUE_OPACITY_60 = "eon-blue-opacity-60";
export const COLOR_BLUE_OPACITY_65 = "eon-blue-opacity-65";
export const COLOR_BLUE_OPACITY_70 = "eon-blue-opacity-70";
export const COLOR_BLUE_OPACITY_75 = "eon-blue-opacity-75";
export const COLOR_BLUE_OPACITY_80 = "eon-blue-opacity-80";
export const COLOR_BLUE_OPACITY_85 = "eon-blue-opacity-85";
export const COLOR_BLUE_OPACITY_90 = "eon-blue-opacity-90";
export const COLOR_BLUE_OPACITY_95 = "eon-blue-opacity-95";
export const COLOR_DARKBLUE_SHADE_1 = "eon-darkblue-shade-1";
export const COLOR_DARKBLUE_SHADE_2 = "eon-darkblue-shade-2";
export const COLOR_DARKBLUE_TINT_1 = "eon-darkblue-tint-1";
export const COLOR_DARKBLUE_TINT_2 = "eon-darkblue-tint-2";
export const COLOR_DARKBLUE_5 = "eon-darkblue-5";
export const COLOR_DARKBLUE_10 = "eon-darkblue-10";
export const COLOR_DARKBLUE_15 = "eon-darkblue-15";
export const COLOR_DARKBLUE_20 = "eon-darkblue-20";
export const COLOR_DARKBLUE_25 = "eon-darkblue-25";
export const COLOR_DARKBLUE_30 = "eon-darkblue-30";
export const COLOR_DARKBLUE_35 = "eon-darkblue-35";
export const COLOR_DARKBLUE_40 = "eon-darkblue-40";
export const COLOR_DARKBLUE_45 = "eon-darkblue-45";
export const COLOR_DARKBLUE_50 = "eon-darkblue-50";
export const COLOR_DARKBLUE_55 = "eon-darkblue-55";
export const COLOR_DARKBLUE_60 = "eon-darkblue-60";
export const COLOR_DARKBLUE_65 = "eon-darkblue-65";
export const COLOR_DARKBLUE_70 = "eon-darkblue-70";
export const COLOR_DARKBLUE_75 = "eon-darkblue-75";
export const COLOR_DARKBLUE_80 = "eon-darkblue-80";
export const COLOR_DARKBLUE_85 = "eon-darkblue-85";
export const COLOR_DARKBLUE_90 = "eon-darkblue-90";
export const COLOR_DARKBLUE_95 = "eon-darkblue-95";
export const COLOR_DARKBLUE_OPACITY_5 = "eon-darkblue-opacity-5";
export const COLOR_DARKBLUE_OPACITY_10 = "eon-darkblue-opacity-10";
export const COLOR_DARKBLUE_OPACITY_15 = "eon-darkblue-opacity-15";
export const COLOR_DARKBLUE_OPACITY_20 = "eon-darkblue-opacity-20";
export const COLOR_DARKBLUE_OPACITY_25 = "eon-darkblue-opacity-25";
export const COLOR_DARKBLUE_OPACITY_30 = "eon-darkblue-opacity-30";
export const COLOR_DARKBLUE_OPACITY_35 = "eon-darkblue-opacity-35";
export const COLOR_DARKBLUE_OPACITY_40 = "eon-darkblue-opacity-40";
export const COLOR_DARKBLUE_OPACITY_45 = "eon-darkblue-opacity-45";
export const COLOR_DARKBLUE_OPACITY_50 = "eon-darkblue-opacity-50";
export const COLOR_DARKBLUE_OPACITY_55 = "eon-darkblue-opacity-55";
export const COLOR_DARKBLUE_OPACITY_60 = "eon-darkblue-opacity-60";
export const COLOR_DARKBLUE_OPACITY_65 = "eon-darkblue-opacity-65";
export const COLOR_DARKBLUE_OPACITY_70 = "eon-darkblue-opacity-70";
export const COLOR_DARKBLUE_OPACITY_75 = "eon-darkblue-opacity-75";
export const COLOR_DARKBLUE_OPACITY_80 = "eon-darkblue-opacity-80";
export const COLOR_DARKBLUE_OPACITY_85 = "eon-darkblue-opacity-85";
export const COLOR_DARKBLUE_OPACITY_90 = "eon-darkblue-opacity-90";
export const COLOR_DARKBLUE_OPACITY_95 = "eon-darkblue-opacity-95";
export const COLOR_BLUE_ACTIVE_SHADE_1 = "eon-blue-active-shade-1";
export const COLOR_BLUE_ACTIVE_SHADE_2 = "eon-blue-active-shade-2";
export const COLOR_BLUE_ACTIVE_TINT_1 = "eon-blue-active-tint-1";
export const COLOR_BLUE_ACTIVE_TINT_2 = "eon-blue-active-tint-2";
export const COLOR_BLUE_ACTIVE_5 = "eon-blue-active-5";
export const COLOR_BLUE_ACTIVE_10 = "eon-blue-active-10";
export const COLOR_BLUE_ACTIVE_15 = "eon-blue-active-15";
export const COLOR_BLUE_ACTIVE_20 = "eon-blue-active-20";
export const COLOR_BLUE_ACTIVE_25 = "eon-blue-active-25";
export const COLOR_BLUE_ACTIVE_30 = "eon-blue-active-30";
export const COLOR_BLUE_ACTIVE_35 = "eon-blue-active-35";
export const COLOR_BLUE_ACTIVE_40 = "eon-blue-active-40";
export const COLOR_BLUE_ACTIVE_45 = "eon-blue-active-45";
export const COLOR_BLUE_ACTIVE_50 = "eon-blue-active-50";
export const COLOR_BLUE_ACTIVE_55 = "eon-blue-active-55";
export const COLOR_BLUE_ACTIVE_60 = "eon-blue-active-60";
export const COLOR_BLUE_ACTIVE_65 = "eon-blue-active-65";
export const COLOR_BLUE_ACTIVE_70 = "eon-blue-active-70";
export const COLOR_BLUE_ACTIVE_75 = "eon-blue-active-75";
export const COLOR_BLUE_ACTIVE_80 = "eon-blue-active-80";
export const COLOR_BLUE_ACTIVE_85 = "eon-blue-active-85";
export const COLOR_BLUE_ACTIVE_90 = "eon-blue-active-90";
export const COLOR_BLUE_ACTIVE_95 = "eon-blue-active-95";
export const COLOR_BLUE_ACTIVE_OPACITY_5 = "eon-blue-active-opacity-5";
export const COLOR_BLUE_ACTIVE_OPACITY_10 = "eon-blue-active-opacity-10";
export const COLOR_BLUE_ACTIVE_OPACITY_15 = "eon-blue-active-opacity-15";
export const COLOR_BLUE_ACTIVE_OPACITY_20 = "eon-blue-active-opacity-20";
export const COLOR_BLUE_ACTIVE_OPACITY_25 = "eon-blue-active-opacity-25";
export const COLOR_BLUE_ACTIVE_OPACITY_30 = "eon-blue-active-opacity-30";
export const COLOR_BLUE_ACTIVE_OPACITY_35 = "eon-blue-active-opacity-35";
export const COLOR_BLUE_ACTIVE_OPACITY_40 = "eon-blue-active-opacity-40";
export const COLOR_BLUE_ACTIVE_OPACITY_45 = "eon-blue-active-opacity-45";
export const COLOR_BLUE_ACTIVE_OPACITY_50 = "eon-blue-active-opacity-50";
export const COLOR_BLUE_ACTIVE_OPACITY_55 = "eon-blue-active-opacity-55";
export const COLOR_BLUE_ACTIVE_OPACITY_60 = "eon-blue-active-opacity-60";
export const COLOR_BLUE_ACTIVE_OPACITY_65 = "eon-blue-active-opacity-65";
export const COLOR_BLUE_ACTIVE_OPACITY_70 = "eon-blue-active-opacity-70";
export const COLOR_BLUE_ACTIVE_OPACITY_75 = "eon-blue-active-opacity-75";
export const COLOR_BLUE_ACTIVE_OPACITY_80 = "eon-blue-active-opacity-80";
export const COLOR_BLUE_ACTIVE_OPACITY_85 = "eon-blue-active-opacity-85";
export const COLOR_BLUE_ACTIVE_OPACITY_90 = "eon-blue-active-opacity-90";
export const COLOR_BLUE_ACTIVE_OPACITY_95 = "eon-blue-active-opacity-95";
export const COLOR_GREEN_SHADE_1 = "eon-green-shade-1";
export const COLOR_GREEN_SHADE_2 = "eon-green-shade-2";
export const COLOR_GREEN_TINT_1 = "eon-green-tint-1";
export const COLOR_GREEN_TINT_2 = "eon-green-tint-2";
export const COLOR_GREEN_5 = "eon-green-5";
export const COLOR_GREEN_10 = "eon-green-10";
export const COLOR_GREEN_15 = "eon-green-15";
export const COLOR_GREEN_20 = "eon-green-20";
export const COLOR_GREEN_25 = "eon-green-25";
export const COLOR_GREEN_30 = "eon-green-30";
export const COLOR_GREEN_35 = "eon-green-35";
export const COLOR_GREEN_40 = "eon-green-40";
export const COLOR_GREEN_45 = "eon-green-45";
export const COLOR_GREEN_50 = "eon-green-50";
export const COLOR_GREEN_55 = "eon-green-55";
export const COLOR_GREEN_60 = "eon-green-60";
export const COLOR_GREEN_65 = "eon-green-65";
export const COLOR_GREEN_70 = "eon-green-70";
export const COLOR_GREEN_75 = "eon-green-75";
export const COLOR_GREEN_80 = "eon-green-80";
export const COLOR_GREEN_85 = "eon-green-85";
export const COLOR_GREEN_90 = "eon-green-90";
export const COLOR_GREEN_95 = "eon-green-95";
export const COLOR_GREEN_OPACITY_5 = "eon-green-opacity-5";
export const COLOR_GREEN_OPACITY_10 = "eon-green-opacity-10";
export const COLOR_GREEN_OPACITY_15 = "eon-green-opacity-15";
export const COLOR_GREEN_OPACITY_20 = "eon-green-opacity-20";
export const COLOR_GREEN_OPACITY_25 = "eon-green-opacity-25";
export const COLOR_GREEN_OPACITY_30 = "eon-green-opacity-30";
export const COLOR_GREEN_OPACITY_35 = "eon-green-opacity-35";
export const COLOR_GREEN_OPACITY_40 = "eon-green-opacity-40";
export const COLOR_GREEN_OPACITY_45 = "eon-green-opacity-45";
export const COLOR_GREEN_OPACITY_50 = "eon-green-opacity-50";
export const COLOR_GREEN_OPACITY_55 = "eon-green-opacity-55";
export const COLOR_GREEN_OPACITY_60 = "eon-green-opacity-60";
export const COLOR_GREEN_OPACITY_65 = "eon-green-opacity-65";
export const COLOR_GREEN_OPACITY_70 = "eon-green-opacity-70";
export const COLOR_GREEN_OPACITY_75 = "eon-green-opacity-75";
export const COLOR_GREEN_OPACITY_80 = "eon-green-opacity-80";
export const COLOR_GREEN_OPACITY_85 = "eon-green-opacity-85";
export const COLOR_GREEN_OPACITY_90 = "eon-green-opacity-90";
export const COLOR_GREEN_OPACITY_95 = "eon-green-opacity-95";
export const COLOR_ORANGE_SHADE_1 = "eon-orange-shade-1";
export const COLOR_ORANGE_SHADE_2 = "eon-orange-shade-2";
export const COLOR_ORANGE_TINT_1 = "eon-orange-tint-1";
export const COLOR_ORANGE_TINT_2 = "eon-orange-tint-2";
export const COLOR_ORANGE_5 = "eon-orange-5";
export const COLOR_ORANGE_10 = "eon-orange-10";
export const COLOR_ORANGE_15 = "eon-orange-15";
export const COLOR_ORANGE_20 = "eon-orange-20";
export const COLOR_ORANGE_25 = "eon-orange-25";
export const COLOR_ORANGE_30 = "eon-orange-30";
export const COLOR_ORANGE_35 = "eon-orange-35";
export const COLOR_ORANGE_40 = "eon-orange-40";
export const COLOR_ORANGE_45 = "eon-orange-45";
export const COLOR_ORANGE_50 = "eon-orange-50";
export const COLOR_ORANGE_55 = "eon-orange-55";
export const COLOR_ORANGE_60 = "eon-orange-60";
export const COLOR_ORANGE_65 = "eon-orange-65";
export const COLOR_ORANGE_70 = "eon-orange-70";
export const COLOR_ORANGE_75 = "eon-orange-75";
export const COLOR_ORANGE_80 = "eon-orange-80";
export const COLOR_ORANGE_85 = "eon-orange-85";
export const COLOR_ORANGE_90 = "eon-orange-90";
export const COLOR_ORANGE_95 = "eon-orange-95";
export const COLOR_ORANGE_OPACITY_5 = "eon-orange-opacity-5";
export const COLOR_ORANGE_OPACITY_10 = "eon-orange-opacity-10";
export const COLOR_ORANGE_OPACITY_15 = "eon-orange-opacity-15";
export const COLOR_ORANGE_OPACITY_20 = "eon-orange-opacity-20";
export const COLOR_ORANGE_OPACITY_25 = "eon-orange-opacity-25";
export const COLOR_ORANGE_OPACITY_30 = "eon-orange-opacity-30";
export const COLOR_ORANGE_OPACITY_35 = "eon-orange-opacity-35";
export const COLOR_ORANGE_OPACITY_40 = "eon-orange-opacity-40";
export const COLOR_ORANGE_OPACITY_45 = "eon-orange-opacity-45";
export const COLOR_ORANGE_OPACITY_50 = "eon-orange-opacity-50";
export const COLOR_ORANGE_OPACITY_55 = "eon-orange-opacity-55";
export const COLOR_ORANGE_OPACITY_60 = "eon-orange-opacity-60";
export const COLOR_ORANGE_OPACITY_65 = "eon-orange-opacity-65";
export const COLOR_ORANGE_OPACITY_70 = "eon-orange-opacity-70";
export const COLOR_ORANGE_OPACITY_75 = "eon-orange-opacity-75";
export const COLOR_ORANGE_OPACITY_80 = "eon-orange-opacity-80";
export const COLOR_ORANGE_OPACITY_85 = "eon-orange-opacity-85";
export const COLOR_ORANGE_OPACITY_90 = "eon-orange-opacity-90";
export const COLOR_ORANGE_OPACITY_95 = "eon-orange-opacity-95";
export const COLOR_ORANGE_ACTIVE_SHADE_1 = "eon-orange-active-shade-1";
export const COLOR_ORANGE_ACTIVE_SHADE_2 = "eon-orange-active-shade-2";
export const COLOR_ORANGE_ACTIVE_TINT_1 = "eon-orange-active-tint-1";
export const COLOR_ORANGE_ACTIVE_TINT_2 = "eon-orange-active-tint-2";
export const COLOR_ORANGE_ACTIVE_5 = "eon-orange-active-5";
export const COLOR_ORANGE_ACTIVE_10 = "eon-orange-active-10";
export const COLOR_ORANGE_ACTIVE_15 = "eon-orange-active-15";
export const COLOR_ORANGE_ACTIVE_20 = "eon-orange-active-20";
export const COLOR_ORANGE_ACTIVE_25 = "eon-orange-active-25";
export const COLOR_ORANGE_ACTIVE_30 = "eon-orange-active-30";
export const COLOR_ORANGE_ACTIVE_35 = "eon-orange-active-35";
export const COLOR_ORANGE_ACTIVE_40 = "eon-orange-active-40";
export const COLOR_ORANGE_ACTIVE_45 = "eon-orange-active-45";
export const COLOR_ORANGE_ACTIVE_50 = "eon-orange-active-50";
export const COLOR_ORANGE_ACTIVE_55 = "eon-orange-active-55";
export const COLOR_ORANGE_ACTIVE_60 = "eon-orange-active-60";
export const COLOR_ORANGE_ACTIVE_65 = "eon-orange-active-65";
export const COLOR_ORANGE_ACTIVE_70 = "eon-orange-active-70";
export const COLOR_ORANGE_ACTIVE_75 = "eon-orange-active-75";
export const COLOR_ORANGE_ACTIVE_80 = "eon-orange-active-80";
export const COLOR_ORANGE_ACTIVE_85 = "eon-orange-active-85";
export const COLOR_ORANGE_ACTIVE_90 = "eon-orange-active-90";
export const COLOR_ORANGE_ACTIVE_95 = "eon-orange-active-95";
export const COLOR_ORANGE_ACTIVE_OPACITY_5 = "eon-orange-active-opacity-5";
export const COLOR_ORANGE_ACTIVE_OPACITY_10 = "eon-orange-active-opacity-10";
export const COLOR_ORANGE_ACTIVE_OPACITY_15 = "eon-orange-active-opacity-15";
export const COLOR_ORANGE_ACTIVE_OPACITY_20 = "eon-orange-active-opacity-20";
export const COLOR_ORANGE_ACTIVE_OPACITY_25 = "eon-orange-active-opacity-25";
export const COLOR_ORANGE_ACTIVE_OPACITY_30 = "eon-orange-active-opacity-30";
export const COLOR_ORANGE_ACTIVE_OPACITY_35 = "eon-orange-active-opacity-35";
export const COLOR_ORANGE_ACTIVE_OPACITY_40 = "eon-orange-active-opacity-40";
export const COLOR_ORANGE_ACTIVE_OPACITY_45 = "eon-orange-active-opacity-45";
export const COLOR_ORANGE_ACTIVE_OPACITY_50 = "eon-orange-active-opacity-50";
export const COLOR_ORANGE_ACTIVE_OPACITY_55 = "eon-orange-active-opacity-55";
export const COLOR_ORANGE_ACTIVE_OPACITY_60 = "eon-orange-active-opacity-60";
export const COLOR_ORANGE_ACTIVE_OPACITY_65 = "eon-orange-active-opacity-65";
export const COLOR_ORANGE_ACTIVE_OPACITY_70 = "eon-orange-active-opacity-70";
export const COLOR_ORANGE_ACTIVE_OPACITY_75 = "eon-orange-active-opacity-75";
export const COLOR_ORANGE_ACTIVE_OPACITY_80 = "eon-orange-active-opacity-80";
export const COLOR_ORANGE_ACTIVE_OPACITY_85 = "eon-orange-active-opacity-85";
export const COLOR_ORANGE_ACTIVE_OPACITY_90 = "eon-orange-active-opacity-90";
export const COLOR_ORANGE_ACTIVE_OPACITY_95 = "eon-orange-active-opacity-95";
export const COLOR_TEAL_SHADE_1 = "eon-teal-shade-1";
export const COLOR_TEAL_SHADE_2 = "eon-teal-shade-2";
export const COLOR_TEAL_TINT_1 = "eon-teal-tint-1";
export const COLOR_TEAL_TINT_2 = "eon-teal-tint-2";
export const COLOR_TEAL_5 = "eon-teal-5";
export const COLOR_TEAL_10 = "eon-teal-10";
export const COLOR_TEAL_15 = "eon-teal-15";
export const COLOR_TEAL_20 = "eon-teal-20";
export const COLOR_TEAL_25 = "eon-teal-25";
export const COLOR_TEAL_30 = "eon-teal-30";
export const COLOR_TEAL_35 = "eon-teal-35";
export const COLOR_TEAL_40 = "eon-teal-40";
export const COLOR_TEAL_45 = "eon-teal-45";
export const COLOR_TEAL_50 = "eon-teal-50";
export const COLOR_TEAL_55 = "eon-teal-55";
export const COLOR_TEAL_60 = "eon-teal-60";
export const COLOR_TEAL_65 = "eon-teal-65";
export const COLOR_TEAL_70 = "eon-teal-70";
export const COLOR_TEAL_75 = "eon-teal-75";
export const COLOR_TEAL_80 = "eon-teal-80";
export const COLOR_TEAL_85 = "eon-teal-85";
export const COLOR_TEAL_90 = "eon-teal-90";
export const COLOR_TEAL_95 = "eon-teal-95";
export const COLOR_TEAL_OPACITY_5 = "eon-teal-opacity-5";
export const COLOR_TEAL_OPACITY_10 = "eon-teal-opacity-10";
export const COLOR_TEAL_OPACITY_15 = "eon-teal-opacity-15";
export const COLOR_TEAL_OPACITY_20 = "eon-teal-opacity-20";
export const COLOR_TEAL_OPACITY_25 = "eon-teal-opacity-25";
export const COLOR_TEAL_OPACITY_30 = "eon-teal-opacity-30";
export const COLOR_TEAL_OPACITY_35 = "eon-teal-opacity-35";
export const COLOR_TEAL_OPACITY_40 = "eon-teal-opacity-40";
export const COLOR_TEAL_OPACITY_45 = "eon-teal-opacity-45";
export const COLOR_TEAL_OPACITY_50 = "eon-teal-opacity-50";
export const COLOR_TEAL_OPACITY_55 = "eon-teal-opacity-55";
export const COLOR_TEAL_OPACITY_60 = "eon-teal-opacity-60";
export const COLOR_TEAL_OPACITY_65 = "eon-teal-opacity-65";
export const COLOR_TEAL_OPACITY_70 = "eon-teal-opacity-70";
export const COLOR_TEAL_OPACITY_75 = "eon-teal-opacity-75";
export const COLOR_TEAL_OPACITY_80 = "eon-teal-opacity-80";
export const COLOR_TEAL_OPACITY_85 = "eon-teal-opacity-85";
export const COLOR_TEAL_OPACITY_90 = "eon-teal-opacity-90";
export const COLOR_TEAL_OPACITY_95 = "eon-teal-opacity-95";
export const COLOR_TEAL_ACTIVE_SHADE_1 = "eon-teal-active-shade-1";
export const COLOR_TEAL_ACTIVE_SHADE_2 = "eon-teal-active-shade-2";
export const COLOR_TEAL_ACTIVE_TINT_1 = "eon-teal-active-tint-1";
export const COLOR_TEAL_ACTIVE_TINT_2 = "eon-teal-active-tint-2";
export const COLOR_TEAL_ACTIVE_5 = "eon-teal-active-5";
export const COLOR_TEAL_ACTIVE_10 = "eon-teal-active-10";
export const COLOR_TEAL_ACTIVE_15 = "eon-teal-active-15";
export const COLOR_TEAL_ACTIVE_20 = "eon-teal-active-20";
export const COLOR_TEAL_ACTIVE_25 = "eon-teal-active-25";
export const COLOR_TEAL_ACTIVE_30 = "eon-teal-active-30";
export const COLOR_TEAL_ACTIVE_35 = "eon-teal-active-35";
export const COLOR_TEAL_ACTIVE_40 = "eon-teal-active-40";
export const COLOR_TEAL_ACTIVE_45 = "eon-teal-active-45";
export const COLOR_TEAL_ACTIVE_50 = "eon-teal-active-50";
export const COLOR_TEAL_ACTIVE_55 = "eon-teal-active-55";
export const COLOR_TEAL_ACTIVE_60 = "eon-teal-active-60";
export const COLOR_TEAL_ACTIVE_65 = "eon-teal-active-65";
export const COLOR_TEAL_ACTIVE_70 = "eon-teal-active-70";
export const COLOR_TEAL_ACTIVE_75 = "eon-teal-active-75";
export const COLOR_TEAL_ACTIVE_80 = "eon-teal-active-80";
export const COLOR_TEAL_ACTIVE_85 = "eon-teal-active-85";
export const COLOR_TEAL_ACTIVE_90 = "eon-teal-active-90";
export const COLOR_TEAL_ACTIVE_95 = "eon-teal-active-95";
export const COLOR_TEAL_ACTIVE_OPACITY_5 = "eon-teal-active-opacity-5";
export const COLOR_TEAL_ACTIVE_OPACITY_10 = "eon-teal-active-opacity-10";
export const COLOR_TEAL_ACTIVE_OPACITY_15 = "eon-teal-active-opacity-15";
export const COLOR_TEAL_ACTIVE_OPACITY_20 = "eon-teal-active-opacity-20";
export const COLOR_TEAL_ACTIVE_OPACITY_25 = "eon-teal-active-opacity-25";
export const COLOR_TEAL_ACTIVE_OPACITY_30 = "eon-teal-active-opacity-30";
export const COLOR_TEAL_ACTIVE_OPACITY_35 = "eon-teal-active-opacity-35";
export const COLOR_TEAL_ACTIVE_OPACITY_40 = "eon-teal-active-opacity-40";
export const COLOR_TEAL_ACTIVE_OPACITY_45 = "eon-teal-active-opacity-45";
export const COLOR_TEAL_ACTIVE_OPACITY_50 = "eon-teal-active-opacity-50";
export const COLOR_TEAL_ACTIVE_OPACITY_55 = "eon-teal-active-opacity-55";
export const COLOR_TEAL_ACTIVE_OPACITY_60 = "eon-teal-active-opacity-60";
export const COLOR_TEAL_ACTIVE_OPACITY_65 = "eon-teal-active-opacity-65";
export const COLOR_TEAL_ACTIVE_OPACITY_70 = "eon-teal-active-opacity-70";
export const COLOR_TEAL_ACTIVE_OPACITY_75 = "eon-teal-active-opacity-75";
export const COLOR_TEAL_ACTIVE_OPACITY_80 = "eon-teal-active-opacity-80";
export const COLOR_TEAL_ACTIVE_OPACITY_85 = "eon-teal-active-opacity-85";
export const COLOR_TEAL_ACTIVE_OPACITY_90 = "eon-teal-active-opacity-90";
export const COLOR_TEAL_ACTIVE_OPACITY_95 = "eon-teal-active-opacity-95";
export const COLOR_TURQUOISE_SHADE_1 = "eon-turquoise-shade-1";
export const COLOR_TURQUOISE_SHADE_2 = "eon-turquoise-shade-2";
export const COLOR_TURQUOISE_TINT_1 = "eon-turquoise-tint-1";
export const COLOR_TURQUOISE_TINT_2 = "eon-turquoise-tint-2";
export const COLOR_TURQUOISE_5 = "eon-turquoise-5";
export const COLOR_TURQUOISE_10 = "eon-turquoise-10";
export const COLOR_TURQUOISE_15 = "eon-turquoise-15";
export const COLOR_TURQUOISE_20 = "eon-turquoise-20";
export const COLOR_TURQUOISE_25 = "eon-turquoise-25";
export const COLOR_TURQUOISE_30 = "eon-turquoise-30";
export const COLOR_TURQUOISE_35 = "eon-turquoise-35";
export const COLOR_TURQUOISE_40 = "eon-turquoise-40";
export const COLOR_TURQUOISE_45 = "eon-turquoise-45";
export const COLOR_TURQUOISE_50 = "eon-turquoise-50";
export const COLOR_TURQUOISE_55 = "eon-turquoise-55";
export const COLOR_TURQUOISE_60 = "eon-turquoise-60";
export const COLOR_TURQUOISE_65 = "eon-turquoise-65";
export const COLOR_TURQUOISE_70 = "eon-turquoise-70";
export const COLOR_TURQUOISE_75 = "eon-turquoise-75";
export const COLOR_TURQUOISE_80 = "eon-turquoise-80";
export const COLOR_TURQUOISE_85 = "eon-turquoise-85";
export const COLOR_TURQUOISE_90 = "eon-turquoise-90";
export const COLOR_TURQUOISE_95 = "eon-turquoise-95";
export const COLOR_TURQUOISE_OPACITY_5 = "eon-turquoise-opacity-5";
export const COLOR_TURQUOISE_OPACITY_10 = "eon-turquoise-opacity-10";
export const COLOR_TURQUOISE_OPACITY_15 = "eon-turquoise-opacity-15";
export const COLOR_TURQUOISE_OPACITY_20 = "eon-turquoise-opacity-20";
export const COLOR_TURQUOISE_OPACITY_25 = "eon-turquoise-opacity-25";
export const COLOR_TURQUOISE_OPACITY_30 = "eon-turquoise-opacity-30";
export const COLOR_TURQUOISE_OPACITY_35 = "eon-turquoise-opacity-35";
export const COLOR_TURQUOISE_OPACITY_40 = "eon-turquoise-opacity-40";
export const COLOR_TURQUOISE_OPACITY_45 = "eon-turquoise-opacity-45";
export const COLOR_TURQUOISE_OPACITY_50 = "eon-turquoise-opacity-50";
export const COLOR_TURQUOISE_OPACITY_55 = "eon-turquoise-opacity-55";
export const COLOR_TURQUOISE_OPACITY_60 = "eon-turquoise-opacity-60";
export const COLOR_TURQUOISE_OPACITY_65 = "eon-turquoise-opacity-65";
export const COLOR_TURQUOISE_OPACITY_70 = "eon-turquoise-opacity-70";
export const COLOR_TURQUOISE_OPACITY_75 = "eon-turquoise-opacity-75";
export const COLOR_TURQUOISE_OPACITY_80 = "eon-turquoise-opacity-80";
export const COLOR_TURQUOISE_OPACITY_85 = "eon-turquoise-opacity-85";
export const COLOR_TURQUOISE_OPACITY_90 = "eon-turquoise-opacity-90";
export const COLOR_TURQUOISE_OPACITY_95 = "eon-turquoise-opacity-95";
export const COLOR_TURQUOISE_ACTIVE_SHADE_1 = "eon-turquoise-active-shade-1";
export const COLOR_TURQUOISE_ACTIVE_SHADE_2 = "eon-turquoise-active-shade-2";
export const COLOR_TURQUOISE_ACTIVE_TINT_1 = "eon-turquoise-active-tint-1";
export const COLOR_TURQUOISE_ACTIVE_TINT_2 = "eon-turquoise-active-tint-2";
export const COLOR_TURQUOISE_ACTIVE_5 = "eon-turquoise-active-5";
export const COLOR_TURQUOISE_ACTIVE_10 = "eon-turquoise-active-10";
export const COLOR_TURQUOISE_ACTIVE_15 = "eon-turquoise-active-15";
export const COLOR_TURQUOISE_ACTIVE_20 = "eon-turquoise-active-20";
export const COLOR_TURQUOISE_ACTIVE_25 = "eon-turquoise-active-25";
export const COLOR_TURQUOISE_ACTIVE_30 = "eon-turquoise-active-30";
export const COLOR_TURQUOISE_ACTIVE_35 = "eon-turquoise-active-35";
export const COLOR_TURQUOISE_ACTIVE_40 = "eon-turquoise-active-40";
export const COLOR_TURQUOISE_ACTIVE_45 = "eon-turquoise-active-45";
export const COLOR_TURQUOISE_ACTIVE_50 = "eon-turquoise-active-50";
export const COLOR_TURQUOISE_ACTIVE_55 = "eon-turquoise-active-55";
export const COLOR_TURQUOISE_ACTIVE_60 = "eon-turquoise-active-60";
export const COLOR_TURQUOISE_ACTIVE_65 = "eon-turquoise-active-65";
export const COLOR_TURQUOISE_ACTIVE_70 = "eon-turquoise-active-70";
export const COLOR_TURQUOISE_ACTIVE_75 = "eon-turquoise-active-75";
export const COLOR_TURQUOISE_ACTIVE_80 = "eon-turquoise-active-80";
export const COLOR_TURQUOISE_ACTIVE_85 = "eon-turquoise-active-85";
export const COLOR_TURQUOISE_ACTIVE_90 = "eon-turquoise-active-90";
export const COLOR_TURQUOISE_ACTIVE_95 = "eon-turquoise-active-95";
export const COLOR_TURQUOISE_ACTIVE_OPACITY_5 = "eon-turquoise-active-opacity-5";
export const COLOR_TURQUOISE_ACTIVE_OPACITY_10 = "eon-turquoise-active-opacity-10";
export const COLOR_TURQUOISE_ACTIVE_OPACITY_15 = "eon-turquoise-active-opacity-15";
export const COLOR_TURQUOISE_ACTIVE_OPACITY_20 = "eon-turquoise-active-opacity-20";
export const COLOR_TURQUOISE_ACTIVE_OPACITY_25 = "eon-turquoise-active-opacity-25";
export const COLOR_TURQUOISE_ACTIVE_OPACITY_30 = "eon-turquoise-active-opacity-30";
export const COLOR_TURQUOISE_ACTIVE_OPACITY_35 = "eon-turquoise-active-opacity-35";
export const COLOR_TURQUOISE_ACTIVE_OPACITY_40 = "eon-turquoise-active-opacity-40";
export const COLOR_TURQUOISE_ACTIVE_OPACITY_45 = "eon-turquoise-active-opacity-45";
export const COLOR_TURQUOISE_ACTIVE_OPACITY_50 = "eon-turquoise-active-opacity-50";
export const COLOR_TURQUOISE_ACTIVE_OPACITY_55 = "eon-turquoise-active-opacity-55";
export const COLOR_TURQUOISE_ACTIVE_OPACITY_60 = "eon-turquoise-active-opacity-60";
export const COLOR_TURQUOISE_ACTIVE_OPACITY_65 = "eon-turquoise-active-opacity-65";
export const COLOR_TURQUOISE_ACTIVE_OPACITY_70 = "eon-turquoise-active-opacity-70";
export const COLOR_TURQUOISE_ACTIVE_OPACITY_75 = "eon-turquoise-active-opacity-75";
export const COLOR_TURQUOISE_ACTIVE_OPACITY_80 = "eon-turquoise-active-opacity-80";
export const COLOR_TURQUOISE_ACTIVE_OPACITY_85 = "eon-turquoise-active-opacity-85";
export const COLOR_TURQUOISE_ACTIVE_OPACITY_90 = "eon-turquoise-active-opacity-90";
export const COLOR_TURQUOISE_ACTIVE_OPACITY_95 = "eon-turquoise-active-opacity-95";
export const COLOR_LIGHTTEAL_SHADE_1 = "eon-lightteal-shade-1";
export const COLOR_LIGHTTEAL_SHADE_2 = "eon-lightteal-shade-2";
export const COLOR_LIGHTTEAL_TINT_1 = "eon-lightteal-tint-1";
export const COLOR_LIGHTTEAL_TINT_2 = "eon-lightteal-tint-2";
export const COLOR_LIGHTTEAL_5 = "eon-lightteal-5";
export const COLOR_LIGHTTEAL_10 = "eon-lightteal-10";
export const COLOR_LIGHTTEAL_15 = "eon-lightteal-15";
export const COLOR_LIGHTTEAL_20 = "eon-lightteal-20";
export const COLOR_LIGHTTEAL_25 = "eon-lightteal-25";
export const COLOR_LIGHTTEAL_30 = "eon-lightteal-30";
export const COLOR_LIGHTTEAL_35 = "eon-lightteal-35";
export const COLOR_LIGHTTEAL_40 = "eon-lightteal-40";
export const COLOR_LIGHTTEAL_45 = "eon-lightteal-45";
export const COLOR_LIGHTTEAL_50 = "eon-lightteal-50";
export const COLOR_LIGHTTEAL_55 = "eon-lightteal-55";
export const COLOR_LIGHTTEAL_60 = "eon-lightteal-60";
export const COLOR_LIGHTTEAL_65 = "eon-lightteal-65";
export const COLOR_LIGHTTEAL_70 = "eon-lightteal-70";
export const COLOR_LIGHTTEAL_75 = "eon-lightteal-75";
export const COLOR_LIGHTTEAL_80 = "eon-lightteal-80";
export const COLOR_LIGHTTEAL_85 = "eon-lightteal-85";
export const COLOR_LIGHTTEAL_90 = "eon-lightteal-90";
export const COLOR_LIGHTTEAL_95 = "eon-lightteal-95";
export const COLOR_LIGHTTEAL_OPACITY_5 = "eon-lightteal-opacity-5";
export const COLOR_LIGHTTEAL_OPACITY_10 = "eon-lightteal-opacity-10";
export const COLOR_LIGHTTEAL_OPACITY_15 = "eon-lightteal-opacity-15";
export const COLOR_LIGHTTEAL_OPACITY_20 = "eon-lightteal-opacity-20";
export const COLOR_LIGHTTEAL_OPACITY_25 = "eon-lightteal-opacity-25";
export const COLOR_LIGHTTEAL_OPACITY_30 = "eon-lightteal-opacity-30";
export const COLOR_LIGHTTEAL_OPACITY_35 = "eon-lightteal-opacity-35";
export const COLOR_LIGHTTEAL_OPACITY_40 = "eon-lightteal-opacity-40";
export const COLOR_LIGHTTEAL_OPACITY_45 = "eon-lightteal-opacity-45";
export const COLOR_LIGHTTEAL_OPACITY_50 = "eon-lightteal-opacity-50";
export const COLOR_LIGHTTEAL_OPACITY_55 = "eon-lightteal-opacity-55";
export const COLOR_LIGHTTEAL_OPACITY_60 = "eon-lightteal-opacity-60";
export const COLOR_LIGHTTEAL_OPACITY_65 = "eon-lightteal-opacity-65";
export const COLOR_LIGHTTEAL_OPACITY_70 = "eon-lightteal-opacity-70";
export const COLOR_LIGHTTEAL_OPACITY_75 = "eon-lightteal-opacity-75";
export const COLOR_LIGHTTEAL_OPACITY_80 = "eon-lightteal-opacity-80";
export const COLOR_LIGHTTEAL_OPACITY_85 = "eon-lightteal-opacity-85";
export const COLOR_LIGHTTEAL_OPACITY_90 = "eon-lightteal-opacity-90";
export const COLOR_LIGHTTEAL_OPACITY_95 = "eon-lightteal-opacity-95";
export const COLOR_MIDDLETEAL_SHADE_1 = "eon-middleteal-shade-1";
export const COLOR_MIDDLETEAL_SHADE_2 = "eon-middleteal-shade-2";
export const COLOR_MIDDLETEAL_TINT_1 = "eon-middleteal-tint-1";
export const COLOR_MIDDLETEAL_TINT_2 = "eon-middleteal-tint-2";
export const COLOR_MIDDLETEAL_5 = "eon-middleteal-5";
export const COLOR_MIDDLETEAL_10 = "eon-middleteal-10";
export const COLOR_MIDDLETEAL_15 = "eon-middleteal-15";
export const COLOR_MIDDLETEAL_20 = "eon-middleteal-20";
export const COLOR_MIDDLETEAL_25 = "eon-middleteal-25";
export const COLOR_MIDDLETEAL_30 = "eon-middleteal-30";
export const COLOR_MIDDLETEAL_35 = "eon-middleteal-35";
export const COLOR_MIDDLETEAL_40 = "eon-middleteal-40";
export const COLOR_MIDDLETEAL_45 = "eon-middleteal-45";
export const COLOR_MIDDLETEAL_50 = "eon-middleteal-50";
export const COLOR_MIDDLETEAL_55 = "eon-middleteal-55";
export const COLOR_MIDDLETEAL_60 = "eon-middleteal-60";
export const COLOR_MIDDLETEAL_65 = "eon-middleteal-65";
export const COLOR_MIDDLETEAL_70 = "eon-middleteal-70";
export const COLOR_MIDDLETEAL_75 = "eon-middleteal-75";
export const COLOR_MIDDLETEAL_80 = "eon-middleteal-80";
export const COLOR_MIDDLETEAL_85 = "eon-middleteal-85";
export const COLOR_MIDDLETEAL_90 = "eon-middleteal-90";
export const COLOR_MIDDLETEAL_95 = "eon-middleteal-95";
export const COLOR_MIDDLETEAL_OPACITY_5 = "eon-middleteal-opacity-5";
export const COLOR_MIDDLETEAL_OPACITY_10 = "eon-middleteal-opacity-10";
export const COLOR_MIDDLETEAL_OPACITY_15 = "eon-middleteal-opacity-15";
export const COLOR_MIDDLETEAL_OPACITY_20 = "eon-middleteal-opacity-20";
export const COLOR_MIDDLETEAL_OPACITY_25 = "eon-middleteal-opacity-25";
export const COLOR_MIDDLETEAL_OPACITY_30 = "eon-middleteal-opacity-30";
export const COLOR_MIDDLETEAL_OPACITY_35 = "eon-middleteal-opacity-35";
export const COLOR_MIDDLETEAL_OPACITY_40 = "eon-middleteal-opacity-40";
export const COLOR_MIDDLETEAL_OPACITY_45 = "eon-middleteal-opacity-45";
export const COLOR_MIDDLETEAL_OPACITY_50 = "eon-middleteal-opacity-50";
export const COLOR_MIDDLETEAL_OPACITY_55 = "eon-middleteal-opacity-55";
export const COLOR_MIDDLETEAL_OPACITY_60 = "eon-middleteal-opacity-60";
export const COLOR_MIDDLETEAL_OPACITY_65 = "eon-middleteal-opacity-65";
export const COLOR_MIDDLETEAL_OPACITY_70 = "eon-middleteal-opacity-70";
export const COLOR_MIDDLETEAL_OPACITY_75 = "eon-middleteal-opacity-75";
export const COLOR_MIDDLETEAL_OPACITY_80 = "eon-middleteal-opacity-80";
export const COLOR_MIDDLETEAL_OPACITY_85 = "eon-middleteal-opacity-85";
export const COLOR_MIDDLETEAL_OPACITY_90 = "eon-middleteal-opacity-90";
export const COLOR_MIDDLETEAL_OPACITY_95 = "eon-middleteal-opacity-95";
export const COLOR_LIGHTBLUE_SHADE_1 = "eon-lightblue-shade-1";
export const COLOR_LIGHTBLUE_SHADE_2 = "eon-lightblue-shade-2";
export const COLOR_LIGHTBLUE_TINT_1 = "eon-lightblue-tint-1";
export const COLOR_LIGHTBLUE_TINT_2 = "eon-lightblue-tint-2";
export const COLOR_LIGHTBLUE_5 = "eon-lightblue-5";
export const COLOR_LIGHTBLUE_10 = "eon-lightblue-10";
export const COLOR_LIGHTBLUE_15 = "eon-lightblue-15";
export const COLOR_LIGHTBLUE_20 = "eon-lightblue-20";
export const COLOR_LIGHTBLUE_25 = "eon-lightblue-25";
export const COLOR_LIGHTBLUE_30 = "eon-lightblue-30";
export const COLOR_LIGHTBLUE_35 = "eon-lightblue-35";
export const COLOR_LIGHTBLUE_40 = "eon-lightblue-40";
export const COLOR_LIGHTBLUE_45 = "eon-lightblue-45";
export const COLOR_LIGHTBLUE_50 = "eon-lightblue-50";
export const COLOR_LIGHTBLUE_55 = "eon-lightblue-55";
export const COLOR_LIGHTBLUE_60 = "eon-lightblue-60";
export const COLOR_LIGHTBLUE_65 = "eon-lightblue-65";
export const COLOR_LIGHTBLUE_70 = "eon-lightblue-70";
export const COLOR_LIGHTBLUE_75 = "eon-lightblue-75";
export const COLOR_LIGHTBLUE_80 = "eon-lightblue-80";
export const COLOR_LIGHTBLUE_85 = "eon-lightblue-85";
export const COLOR_LIGHTBLUE_90 = "eon-lightblue-90";
export const COLOR_LIGHTBLUE_95 = "eon-lightblue-95";
export const COLOR_LIGHTBLUE_OPACITY_5 = "eon-lightblue-opacity-5";
export const COLOR_LIGHTBLUE_OPACITY_10 = "eon-lightblue-opacity-10";
export const COLOR_LIGHTBLUE_OPACITY_15 = "eon-lightblue-opacity-15";
export const COLOR_LIGHTBLUE_OPACITY_20 = "eon-lightblue-opacity-20";
export const COLOR_LIGHTBLUE_OPACITY_25 = "eon-lightblue-opacity-25";
export const COLOR_LIGHTBLUE_OPACITY_30 = "eon-lightblue-opacity-30";
export const COLOR_LIGHTBLUE_OPACITY_35 = "eon-lightblue-opacity-35";
export const COLOR_LIGHTBLUE_OPACITY_40 = "eon-lightblue-opacity-40";
export const COLOR_LIGHTBLUE_OPACITY_45 = "eon-lightblue-opacity-45";
export const COLOR_LIGHTBLUE_OPACITY_50 = "eon-lightblue-opacity-50";
export const COLOR_LIGHTBLUE_OPACITY_55 = "eon-lightblue-opacity-55";
export const COLOR_LIGHTBLUE_OPACITY_60 = "eon-lightblue-opacity-60";
export const COLOR_LIGHTBLUE_OPACITY_65 = "eon-lightblue-opacity-65";
export const COLOR_LIGHTBLUE_OPACITY_70 = "eon-lightblue-opacity-70";
export const COLOR_LIGHTBLUE_OPACITY_75 = "eon-lightblue-opacity-75";
export const COLOR_LIGHTBLUE_OPACITY_80 = "eon-lightblue-opacity-80";
export const COLOR_LIGHTBLUE_OPACITY_85 = "eon-lightblue-opacity-85";
export const COLOR_LIGHTBLUE_OPACITY_90 = "eon-lightblue-opacity-90";
export const COLOR_LIGHTBLUE_OPACITY_95 = "eon-lightblue-opacity-95";
export const COLOR_MIDDLEBLUE_SHADE_1 = "eon-middleblue-shade-1";
export const COLOR_MIDDLEBLUE_SHADE_2 = "eon-middleblue-shade-2";
export const COLOR_MIDDLEBLUE_TINT_1 = "eon-middleblue-tint-1";
export const COLOR_MIDDLEBLUE_TINT_2 = "eon-middleblue-tint-2";
export const COLOR_MIDDLEBLUE_5 = "eon-middleblue-5";
export const COLOR_MIDDLEBLUE_10 = "eon-middleblue-10";
export const COLOR_MIDDLEBLUE_15 = "eon-middleblue-15";
export const COLOR_MIDDLEBLUE_20 = "eon-middleblue-20";
export const COLOR_MIDDLEBLUE_25 = "eon-middleblue-25";
export const COLOR_MIDDLEBLUE_30 = "eon-middleblue-30";
export const COLOR_MIDDLEBLUE_35 = "eon-middleblue-35";
export const COLOR_MIDDLEBLUE_40 = "eon-middleblue-40";
export const COLOR_MIDDLEBLUE_45 = "eon-middleblue-45";
export const COLOR_MIDDLEBLUE_50 = "eon-middleblue-50";
export const COLOR_MIDDLEBLUE_55 = "eon-middleblue-55";
export const COLOR_MIDDLEBLUE_60 = "eon-middleblue-60";
export const COLOR_MIDDLEBLUE_65 = "eon-middleblue-65";
export const COLOR_MIDDLEBLUE_70 = "eon-middleblue-70";
export const COLOR_MIDDLEBLUE_75 = "eon-middleblue-75";
export const COLOR_MIDDLEBLUE_80 = "eon-middleblue-80";
export const COLOR_MIDDLEBLUE_85 = "eon-middleblue-85";
export const COLOR_MIDDLEBLUE_90 = "eon-middleblue-90";
export const COLOR_MIDDLEBLUE_95 = "eon-middleblue-95";
export const COLOR_MIDDLEBLUE_OPACITY_5 = "eon-middleblue-opacity-5";
export const COLOR_MIDDLEBLUE_OPACITY_10 = "eon-middleblue-opacity-10";
export const COLOR_MIDDLEBLUE_OPACITY_15 = "eon-middleblue-opacity-15";
export const COLOR_MIDDLEBLUE_OPACITY_20 = "eon-middleblue-opacity-20";
export const COLOR_MIDDLEBLUE_OPACITY_25 = "eon-middleblue-opacity-25";
export const COLOR_MIDDLEBLUE_OPACITY_30 = "eon-middleblue-opacity-30";
export const COLOR_MIDDLEBLUE_OPACITY_35 = "eon-middleblue-opacity-35";
export const COLOR_MIDDLEBLUE_OPACITY_40 = "eon-middleblue-opacity-40";
export const COLOR_MIDDLEBLUE_OPACITY_45 = "eon-middleblue-opacity-45";
export const COLOR_MIDDLEBLUE_OPACITY_50 = "eon-middleblue-opacity-50";
export const COLOR_MIDDLEBLUE_OPACITY_55 = "eon-middleblue-opacity-55";
export const COLOR_MIDDLEBLUE_OPACITY_60 = "eon-middleblue-opacity-60";
export const COLOR_MIDDLEBLUE_OPACITY_65 = "eon-middleblue-opacity-65";
export const COLOR_MIDDLEBLUE_OPACITY_70 = "eon-middleblue-opacity-70";
export const COLOR_MIDDLEBLUE_OPACITY_75 = "eon-middleblue-opacity-75";
export const COLOR_MIDDLEBLUE_OPACITY_80 = "eon-middleblue-opacity-80";
export const COLOR_MIDDLEBLUE_OPACITY_85 = "eon-middleblue-opacity-85";
export const COLOR_MIDDLEBLUE_OPACITY_90 = "eon-middleblue-opacity-90";
export const COLOR_MIDDLEBLUE_OPACITY_95 = "eon-middleblue-opacity-95";
export const COLOR_BLUE_BORDER_SHADE_1 = "eon-blue-border-shade-1";
export const COLOR_BLUE_BORDER_SHADE_2 = "eon-blue-border-shade-2";
export const COLOR_BLUE_BORDER_TINT_1 = "eon-blue-border-tint-1";
export const COLOR_BLUE_BORDER_TINT_2 = "eon-blue-border-tint-2";
export const COLOR_BLUE_BORDER_5 = "eon-blue-border-5";
export const COLOR_BLUE_BORDER_10 = "eon-blue-border-10";
export const COLOR_BLUE_BORDER_15 = "eon-blue-border-15";
export const COLOR_BLUE_BORDER_20 = "eon-blue-border-20";
export const COLOR_BLUE_BORDER_25 = "eon-blue-border-25";
export const COLOR_BLUE_BORDER_30 = "eon-blue-border-30";
export const COLOR_BLUE_BORDER_35 = "eon-blue-border-35";
export const COLOR_BLUE_BORDER_40 = "eon-blue-border-40";
export const COLOR_BLUE_BORDER_45 = "eon-blue-border-45";
export const COLOR_BLUE_BORDER_50 = "eon-blue-border-50";
export const COLOR_BLUE_BORDER_55 = "eon-blue-border-55";
export const COLOR_BLUE_BORDER_60 = "eon-blue-border-60";
export const COLOR_BLUE_BORDER_65 = "eon-blue-border-65";
export const COLOR_BLUE_BORDER_70 = "eon-blue-border-70";
export const COLOR_BLUE_BORDER_75 = "eon-blue-border-75";
export const COLOR_BLUE_BORDER_80 = "eon-blue-border-80";
export const COLOR_BLUE_BORDER_85 = "eon-blue-border-85";
export const COLOR_BLUE_BORDER_90 = "eon-blue-border-90";
export const COLOR_BLUE_BORDER_95 = "eon-blue-border-95";
export const COLOR_BLUE_BORDER_OPACITY_5 = "eon-blue-border-opacity-5";
export const COLOR_BLUE_BORDER_OPACITY_10 = "eon-blue-border-opacity-10";
export const COLOR_BLUE_BORDER_OPACITY_15 = "eon-blue-border-opacity-15";
export const COLOR_BLUE_BORDER_OPACITY_20 = "eon-blue-border-opacity-20";
export const COLOR_BLUE_BORDER_OPACITY_25 = "eon-blue-border-opacity-25";
export const COLOR_BLUE_BORDER_OPACITY_30 = "eon-blue-border-opacity-30";
export const COLOR_BLUE_BORDER_OPACITY_35 = "eon-blue-border-opacity-35";
export const COLOR_BLUE_BORDER_OPACITY_40 = "eon-blue-border-opacity-40";
export const COLOR_BLUE_BORDER_OPACITY_45 = "eon-blue-border-opacity-45";
export const COLOR_BLUE_BORDER_OPACITY_50 = "eon-blue-border-opacity-50";
export const COLOR_BLUE_BORDER_OPACITY_55 = "eon-blue-border-opacity-55";
export const COLOR_BLUE_BORDER_OPACITY_60 = "eon-blue-border-opacity-60";
export const COLOR_BLUE_BORDER_OPACITY_65 = "eon-blue-border-opacity-65";
export const COLOR_BLUE_BORDER_OPACITY_70 = "eon-blue-border-opacity-70";
export const COLOR_BLUE_BORDER_OPACITY_75 = "eon-blue-border-opacity-75";
export const COLOR_BLUE_BORDER_OPACITY_80 = "eon-blue-border-opacity-80";
export const COLOR_BLUE_BORDER_OPACITY_85 = "eon-blue-border-opacity-85";
export const COLOR_BLUE_BORDER_OPACITY_90 = "eon-blue-border-opacity-90";
export const COLOR_BLUE_BORDER_OPACITY_95 = "eon-blue-border-opacity-95";
export const COLOR_RED_SHADE_1 = "eon-red-shade-1";
export const COLOR_RED_SHADE_2 = "eon-red-shade-2";
export const COLOR_RED_TINT_1 = "eon-red-tint-1";
export const COLOR_RED_TINT_2 = "eon-red-tint-2";
export const COLOR_RED_5 = "eon-red-5";
export const COLOR_RED_10 = "eon-red-10";
export const COLOR_RED_15 = "eon-red-15";
export const COLOR_RED_20 = "eon-red-20";
export const COLOR_RED_25 = "eon-red-25";
export const COLOR_RED_30 = "eon-red-30";
export const COLOR_RED_35 = "eon-red-35";
export const COLOR_RED_40 = "eon-red-40";
export const COLOR_RED_45 = "eon-red-45";
export const COLOR_RED_50 = "eon-red-50";
export const COLOR_RED_55 = "eon-red-55";
export const COLOR_RED_60 = "eon-red-60";
export const COLOR_RED_65 = "eon-red-65";
export const COLOR_RED_70 = "eon-red-70";
export const COLOR_RED_75 = "eon-red-75";
export const COLOR_RED_80 = "eon-red-80";
export const COLOR_RED_85 = "eon-red-85";
export const COLOR_RED_90 = "eon-red-90";
export const COLOR_RED_95 = "eon-red-95";
export const COLOR_RED_OPACITY_5 = "eon-red-opacity-5";
export const COLOR_RED_OPACITY_10 = "eon-red-opacity-10";
export const COLOR_RED_OPACITY_15 = "eon-red-opacity-15";
export const COLOR_RED_OPACITY_20 = "eon-red-opacity-20";
export const COLOR_RED_OPACITY_25 = "eon-red-opacity-25";
export const COLOR_RED_OPACITY_30 = "eon-red-opacity-30";
export const COLOR_RED_OPACITY_35 = "eon-red-opacity-35";
export const COLOR_RED_OPACITY_40 = "eon-red-opacity-40";
export const COLOR_RED_OPACITY_45 = "eon-red-opacity-45";
export const COLOR_RED_OPACITY_50 = "eon-red-opacity-50";
export const COLOR_RED_OPACITY_55 = "eon-red-opacity-55";
export const COLOR_RED_OPACITY_60 = "eon-red-opacity-60";
export const COLOR_RED_OPACITY_65 = "eon-red-opacity-65";
export const COLOR_RED_OPACITY_70 = "eon-red-opacity-70";
export const COLOR_RED_OPACITY_75 = "eon-red-opacity-75";
export const COLOR_RED_OPACITY_80 = "eon-red-opacity-80";
export const COLOR_RED_OPACITY_85 = "eon-red-opacity-85";
export const COLOR_RED_OPACITY_90 = "eon-red-opacity-90";
export const COLOR_RED_OPACITY_95 = "eon-red-opacity-95";
export const COLOR_YELLOW_SHADE_1 = "eon-yellow-shade-1";
export const COLOR_YELLOW_SHADE_2 = "eon-yellow-shade-2";
export const COLOR_YELLOW_TINT_1 = "eon-yellow-tint-1";
export const COLOR_YELLOW_TINT_2 = "eon-yellow-tint-2";
export const COLOR_YELLOW_5 = "eon-yellow-5";
export const COLOR_YELLOW_10 = "eon-yellow-10";
export const COLOR_YELLOW_15 = "eon-yellow-15";
export const COLOR_YELLOW_20 = "eon-yellow-20";
export const COLOR_YELLOW_25 = "eon-yellow-25";
export const COLOR_YELLOW_30 = "eon-yellow-30";
export const COLOR_YELLOW_35 = "eon-yellow-35";
export const COLOR_YELLOW_40 = "eon-yellow-40";
export const COLOR_YELLOW_45 = "eon-yellow-45";
export const COLOR_YELLOW_50 = "eon-yellow-50";
export const COLOR_YELLOW_55 = "eon-yellow-55";
export const COLOR_YELLOW_60 = "eon-yellow-60";
export const COLOR_YELLOW_65 = "eon-yellow-65";
export const COLOR_YELLOW_70 = "eon-yellow-70";
export const COLOR_YELLOW_75 = "eon-yellow-75";
export const COLOR_YELLOW_80 = "eon-yellow-80";
export const COLOR_YELLOW_85 = "eon-yellow-85";
export const COLOR_YELLOW_90 = "eon-yellow-90";
export const COLOR_YELLOW_95 = "eon-yellow-95";
export const COLOR_YELLOW_OPACITY_5 = "eon-yellow-opacity-5";
export const COLOR_YELLOW_OPACITY_10 = "eon-yellow-opacity-10";
export const COLOR_YELLOW_OPACITY_15 = "eon-yellow-opacity-15";
export const COLOR_YELLOW_OPACITY_20 = "eon-yellow-opacity-20";
export const COLOR_YELLOW_OPACITY_25 = "eon-yellow-opacity-25";
export const COLOR_YELLOW_OPACITY_30 = "eon-yellow-opacity-30";
export const COLOR_YELLOW_OPACITY_35 = "eon-yellow-opacity-35";
export const COLOR_YELLOW_OPACITY_40 = "eon-yellow-opacity-40";
export const COLOR_YELLOW_OPACITY_45 = "eon-yellow-opacity-45";
export const COLOR_YELLOW_OPACITY_50 = "eon-yellow-opacity-50";
export const COLOR_YELLOW_OPACITY_55 = "eon-yellow-opacity-55";
export const COLOR_YELLOW_OPACITY_60 = "eon-yellow-opacity-60";
export const COLOR_YELLOW_OPACITY_65 = "eon-yellow-opacity-65";
export const COLOR_YELLOW_OPACITY_70 = "eon-yellow-opacity-70";
export const COLOR_YELLOW_OPACITY_75 = "eon-yellow-opacity-75";
export const COLOR_YELLOW_OPACITY_80 = "eon-yellow-opacity-80";
export const COLOR_YELLOW_OPACITY_85 = "eon-yellow-opacity-85";
export const COLOR_YELLOW_OPACITY_90 = "eon-yellow-opacity-90";
export const COLOR_YELLOW_OPACITY_95 = "eon-yellow-opacity-95";
export const COLOR_LIGHTTURQUOISE_SHADE_1 = "eon-lightturquoise-shade-1";
export const COLOR_LIGHTTURQUOISE_SHADE_2 = "eon-lightturquoise-shade-2";
export const COLOR_LIGHTTURQUOISE_TINT_1 = "eon-lightturquoise-tint-1";
export const COLOR_LIGHTTURQUOISE_TINT_2 = "eon-lightturquoise-tint-2";
export const COLOR_LIGHTTURQUOISE_5 = "eon-lightturquoise-5";
export const COLOR_LIGHTTURQUOISE_10 = "eon-lightturquoise-10";
export const COLOR_LIGHTTURQUOISE_15 = "eon-lightturquoise-15";
export const COLOR_LIGHTTURQUOISE_20 = "eon-lightturquoise-20";
export const COLOR_LIGHTTURQUOISE_25 = "eon-lightturquoise-25";
export const COLOR_LIGHTTURQUOISE_30 = "eon-lightturquoise-30";
export const COLOR_LIGHTTURQUOISE_35 = "eon-lightturquoise-35";
export const COLOR_LIGHTTURQUOISE_40 = "eon-lightturquoise-40";
export const COLOR_LIGHTTURQUOISE_45 = "eon-lightturquoise-45";
export const COLOR_LIGHTTURQUOISE_50 = "eon-lightturquoise-50";
export const COLOR_LIGHTTURQUOISE_55 = "eon-lightturquoise-55";
export const COLOR_LIGHTTURQUOISE_60 = "eon-lightturquoise-60";
export const COLOR_LIGHTTURQUOISE_65 = "eon-lightturquoise-65";
export const COLOR_LIGHTTURQUOISE_70 = "eon-lightturquoise-70";
export const COLOR_LIGHTTURQUOISE_75 = "eon-lightturquoise-75";
export const COLOR_LIGHTTURQUOISE_80 = "eon-lightturquoise-80";
export const COLOR_LIGHTTURQUOISE_85 = "eon-lightturquoise-85";
export const COLOR_LIGHTTURQUOISE_90 = "eon-lightturquoise-90";
export const COLOR_LIGHTTURQUOISE_95 = "eon-lightturquoise-95";
export const COLOR_LIGHTTURQUOISE_OPACITY_5 = "eon-lightturquoise-opacity-5";
export const COLOR_LIGHTTURQUOISE_OPACITY_10 = "eon-lightturquoise-opacity-10";
export const COLOR_LIGHTTURQUOISE_OPACITY_15 = "eon-lightturquoise-opacity-15";
export const COLOR_LIGHTTURQUOISE_OPACITY_20 = "eon-lightturquoise-opacity-20";
export const COLOR_LIGHTTURQUOISE_OPACITY_25 = "eon-lightturquoise-opacity-25";
export const COLOR_LIGHTTURQUOISE_OPACITY_30 = "eon-lightturquoise-opacity-30";
export const COLOR_LIGHTTURQUOISE_OPACITY_35 = "eon-lightturquoise-opacity-35";
export const COLOR_LIGHTTURQUOISE_OPACITY_40 = "eon-lightturquoise-opacity-40";
export const COLOR_LIGHTTURQUOISE_OPACITY_45 = "eon-lightturquoise-opacity-45";
export const COLOR_LIGHTTURQUOISE_OPACITY_50 = "eon-lightturquoise-opacity-50";
export const COLOR_LIGHTTURQUOISE_OPACITY_55 = "eon-lightturquoise-opacity-55";
export const COLOR_LIGHTTURQUOISE_OPACITY_60 = "eon-lightturquoise-opacity-60";
export const COLOR_LIGHTTURQUOISE_OPACITY_65 = "eon-lightturquoise-opacity-65";
export const COLOR_LIGHTTURQUOISE_OPACITY_70 = "eon-lightturquoise-opacity-70";
export const COLOR_LIGHTTURQUOISE_OPACITY_75 = "eon-lightturquoise-opacity-75";
export const COLOR_LIGHTTURQUOISE_OPACITY_80 = "eon-lightturquoise-opacity-80";
export const COLOR_LIGHTTURQUOISE_OPACITY_85 = "eon-lightturquoise-opacity-85";
export const COLOR_LIGHTTURQUOISE_OPACITY_90 = "eon-lightturquoise-opacity-90";
export const COLOR_LIGHTTURQUOISE_OPACITY_95 = "eon-lightturquoise-opacity-95";
export const COLOR_MIDDLETURQUOISE_SHADE_1 = "eon-middleturquoise-shade-1";
export const COLOR_MIDDLETURQUOISE_SHADE_2 = "eon-middleturquoise-shade-2";
export const COLOR_MIDDLETURQUOISE_TINT_1 = "eon-middleturquoise-tint-1";
export const COLOR_MIDDLETURQUOISE_TINT_2 = "eon-middleturquoise-tint-2";
export const COLOR_MIDDLETURQUOISE_5 = "eon-middleturquoise-5";
export const COLOR_MIDDLETURQUOISE_10 = "eon-middleturquoise-10";
export const COLOR_MIDDLETURQUOISE_15 = "eon-middleturquoise-15";
export const COLOR_MIDDLETURQUOISE_20 = "eon-middleturquoise-20";
export const COLOR_MIDDLETURQUOISE_25 = "eon-middleturquoise-25";
export const COLOR_MIDDLETURQUOISE_30 = "eon-middleturquoise-30";
export const COLOR_MIDDLETURQUOISE_35 = "eon-middleturquoise-35";
export const COLOR_MIDDLETURQUOISE_40 = "eon-middleturquoise-40";
export const COLOR_MIDDLETURQUOISE_45 = "eon-middleturquoise-45";
export const COLOR_MIDDLETURQUOISE_50 = "eon-middleturquoise-50";
export const COLOR_MIDDLETURQUOISE_55 = "eon-middleturquoise-55";
export const COLOR_MIDDLETURQUOISE_60 = "eon-middleturquoise-60";
export const COLOR_MIDDLETURQUOISE_65 = "eon-middleturquoise-65";
export const COLOR_MIDDLETURQUOISE_70 = "eon-middleturquoise-70";
export const COLOR_MIDDLETURQUOISE_75 = "eon-middleturquoise-75";
export const COLOR_MIDDLETURQUOISE_80 = "eon-middleturquoise-80";
export const COLOR_MIDDLETURQUOISE_85 = "eon-middleturquoise-85";
export const COLOR_MIDDLETURQUOISE_90 = "eon-middleturquoise-90";
export const COLOR_MIDDLETURQUOISE_95 = "eon-middleturquoise-95";
export const COLOR_MIDDLETURQUOISE_OPACITY_5 = "eon-middleturquoise-opacity-5";
export const COLOR_MIDDLETURQUOISE_OPACITY_10 = "eon-middleturquoise-opacity-10";
export const COLOR_MIDDLETURQUOISE_OPACITY_15 = "eon-middleturquoise-opacity-15";
export const COLOR_MIDDLETURQUOISE_OPACITY_20 = "eon-middleturquoise-opacity-20";
export const COLOR_MIDDLETURQUOISE_OPACITY_25 = "eon-middleturquoise-opacity-25";
export const COLOR_MIDDLETURQUOISE_OPACITY_30 = "eon-middleturquoise-opacity-30";
export const COLOR_MIDDLETURQUOISE_OPACITY_35 = "eon-middleturquoise-opacity-35";
export const COLOR_MIDDLETURQUOISE_OPACITY_40 = "eon-middleturquoise-opacity-40";
export const COLOR_MIDDLETURQUOISE_OPACITY_45 = "eon-middleturquoise-opacity-45";
export const COLOR_MIDDLETURQUOISE_OPACITY_50 = "eon-middleturquoise-opacity-50";
export const COLOR_MIDDLETURQUOISE_OPACITY_55 = "eon-middleturquoise-opacity-55";
export const COLOR_MIDDLETURQUOISE_OPACITY_60 = "eon-middleturquoise-opacity-60";
export const COLOR_MIDDLETURQUOISE_OPACITY_65 = "eon-middleturquoise-opacity-65";
export const COLOR_MIDDLETURQUOISE_OPACITY_70 = "eon-middleturquoise-opacity-70";
export const COLOR_MIDDLETURQUOISE_OPACITY_75 = "eon-middleturquoise-opacity-75";
export const COLOR_MIDDLETURQUOISE_OPACITY_80 = "eon-middleturquoise-opacity-80";
export const COLOR_MIDDLETURQUOISE_OPACITY_85 = "eon-middleturquoise-opacity-85";
export const COLOR_MIDDLETURQUOISE_OPACITY_90 = "eon-middleturquoise-opacity-90";
export const COLOR_MIDDLETURQUOISE_OPACITY_95 = "eon-middleturquoise-opacity-95";
export const COLOR_GREEN_BORDER_SHADE_1 = "eon-green-border-shade-1";
export const COLOR_GREEN_BORDER_SHADE_2 = "eon-green-border-shade-2";
export const COLOR_GREEN_BORDER_TINT_1 = "eon-green-border-tint-1";
export const COLOR_GREEN_BORDER_TINT_2 = "eon-green-border-tint-2";
export const COLOR_GREEN_BORDER_5 = "eon-green-border-5";
export const COLOR_GREEN_BORDER_10 = "eon-green-border-10";
export const COLOR_GREEN_BORDER_15 = "eon-green-border-15";
export const COLOR_GREEN_BORDER_20 = "eon-green-border-20";
export const COLOR_GREEN_BORDER_25 = "eon-green-border-25";
export const COLOR_GREEN_BORDER_30 = "eon-green-border-30";
export const COLOR_GREEN_BORDER_35 = "eon-green-border-35";
export const COLOR_GREEN_BORDER_40 = "eon-green-border-40";
export const COLOR_GREEN_BORDER_45 = "eon-green-border-45";
export const COLOR_GREEN_BORDER_50 = "eon-green-border-50";
export const COLOR_GREEN_BORDER_55 = "eon-green-border-55";
export const COLOR_GREEN_BORDER_60 = "eon-green-border-60";
export const COLOR_GREEN_BORDER_65 = "eon-green-border-65";
export const COLOR_GREEN_BORDER_70 = "eon-green-border-70";
export const COLOR_GREEN_BORDER_75 = "eon-green-border-75";
export const COLOR_GREEN_BORDER_80 = "eon-green-border-80";
export const COLOR_GREEN_BORDER_85 = "eon-green-border-85";
export const COLOR_GREEN_BORDER_90 = "eon-green-border-90";
export const COLOR_GREEN_BORDER_95 = "eon-green-border-95";
export const COLOR_GREEN_BORDER_OPACITY_5 = "eon-green-border-opacity-5";
export const COLOR_GREEN_BORDER_OPACITY_10 = "eon-green-border-opacity-10";
export const COLOR_GREEN_BORDER_OPACITY_15 = "eon-green-border-opacity-15";
export const COLOR_GREEN_BORDER_OPACITY_20 = "eon-green-border-opacity-20";
export const COLOR_GREEN_BORDER_OPACITY_25 = "eon-green-border-opacity-25";
export const COLOR_GREEN_BORDER_OPACITY_30 = "eon-green-border-opacity-30";
export const COLOR_GREEN_BORDER_OPACITY_35 = "eon-green-border-opacity-35";
export const COLOR_GREEN_BORDER_OPACITY_40 = "eon-green-border-opacity-40";
export const COLOR_GREEN_BORDER_OPACITY_45 = "eon-green-border-opacity-45";
export const COLOR_GREEN_BORDER_OPACITY_50 = "eon-green-border-opacity-50";
export const COLOR_GREEN_BORDER_OPACITY_55 = "eon-green-border-opacity-55";
export const COLOR_GREEN_BORDER_OPACITY_60 = "eon-green-border-opacity-60";
export const COLOR_GREEN_BORDER_OPACITY_65 = "eon-green-border-opacity-65";
export const COLOR_GREEN_BORDER_OPACITY_70 = "eon-green-border-opacity-70";
export const COLOR_GREEN_BORDER_OPACITY_75 = "eon-green-border-opacity-75";
export const COLOR_GREEN_BORDER_OPACITY_80 = "eon-green-border-opacity-80";
export const COLOR_GREEN_BORDER_OPACITY_85 = "eon-green-border-opacity-85";
export const COLOR_GREEN_BORDER_OPACITY_90 = "eon-green-border-opacity-90";
export const COLOR_GREEN_BORDER_OPACITY_95 = "eon-green-border-opacity-95";
export const COLOR_GREEN_ACTIVE_SHADE_1 = "eon-green-active-shade-1";
export const COLOR_GREEN_ACTIVE_SHADE_2 = "eon-green-active-shade-2";
export const COLOR_GREEN_ACTIVE_TINT_1 = "eon-green-active-tint-1";
export const COLOR_GREEN_ACTIVE_TINT_2 = "eon-green-active-tint-2";
export const COLOR_GREEN_ACTIVE_5 = "eon-green-active-5";
export const COLOR_GREEN_ACTIVE_10 = "eon-green-active-10";
export const COLOR_GREEN_ACTIVE_15 = "eon-green-active-15";
export const COLOR_GREEN_ACTIVE_20 = "eon-green-active-20";
export const COLOR_GREEN_ACTIVE_25 = "eon-green-active-25";
export const COLOR_GREEN_ACTIVE_30 = "eon-green-active-30";
export const COLOR_GREEN_ACTIVE_35 = "eon-green-active-35";
export const COLOR_GREEN_ACTIVE_40 = "eon-green-active-40";
export const COLOR_GREEN_ACTIVE_45 = "eon-green-active-45";
export const COLOR_GREEN_ACTIVE_50 = "eon-green-active-50";
export const COLOR_GREEN_ACTIVE_55 = "eon-green-active-55";
export const COLOR_GREEN_ACTIVE_60 = "eon-green-active-60";
export const COLOR_GREEN_ACTIVE_65 = "eon-green-active-65";
export const COLOR_GREEN_ACTIVE_70 = "eon-green-active-70";
export const COLOR_GREEN_ACTIVE_75 = "eon-green-active-75";
export const COLOR_GREEN_ACTIVE_80 = "eon-green-active-80";
export const COLOR_GREEN_ACTIVE_85 = "eon-green-active-85";
export const COLOR_GREEN_ACTIVE_90 = "eon-green-active-90";
export const COLOR_GREEN_ACTIVE_95 = "eon-green-active-95";
export const COLOR_GREEN_ACTIVE_OPACITY_5 = "eon-green-active-opacity-5";
export const COLOR_GREEN_ACTIVE_OPACITY_10 = "eon-green-active-opacity-10";
export const COLOR_GREEN_ACTIVE_OPACITY_15 = "eon-green-active-opacity-15";
export const COLOR_GREEN_ACTIVE_OPACITY_20 = "eon-green-active-opacity-20";
export const COLOR_GREEN_ACTIVE_OPACITY_25 = "eon-green-active-opacity-25";
export const COLOR_GREEN_ACTIVE_OPACITY_30 = "eon-green-active-opacity-30";
export const COLOR_GREEN_ACTIVE_OPACITY_35 = "eon-green-active-opacity-35";
export const COLOR_GREEN_ACTIVE_OPACITY_40 = "eon-green-active-opacity-40";
export const COLOR_GREEN_ACTIVE_OPACITY_45 = "eon-green-active-opacity-45";
export const COLOR_GREEN_ACTIVE_OPACITY_50 = "eon-green-active-opacity-50";
export const COLOR_GREEN_ACTIVE_OPACITY_55 = "eon-green-active-opacity-55";
export const COLOR_GREEN_ACTIVE_OPACITY_60 = "eon-green-active-opacity-60";
export const COLOR_GREEN_ACTIVE_OPACITY_65 = "eon-green-active-opacity-65";
export const COLOR_GREEN_ACTIVE_OPACITY_70 = "eon-green-active-opacity-70";
export const COLOR_GREEN_ACTIVE_OPACITY_75 = "eon-green-active-opacity-75";
export const COLOR_GREEN_ACTIVE_OPACITY_80 = "eon-green-active-opacity-80";
export const COLOR_GREEN_ACTIVE_OPACITY_85 = "eon-green-active-opacity-85";
export const COLOR_GREEN_ACTIVE_OPACITY_90 = "eon-green-active-opacity-90";
export const COLOR_GREEN_ACTIVE_OPACITY_95 = "eon-green-active-opacity-95";
export const COLOR_LIGHTGREEN_SHADE_1 = "eon-lightgreen-shade-1";
export const COLOR_LIGHTGREEN_SHADE_2 = "eon-lightgreen-shade-2";
export const COLOR_LIGHTGREEN_TINT_1 = "eon-lightgreen-tint-1";
export const COLOR_LIGHTGREEN_TINT_2 = "eon-lightgreen-tint-2";
export const COLOR_LIGHTGREEN_5 = "eon-lightgreen-5";
export const COLOR_LIGHTGREEN_10 = "eon-lightgreen-10";
export const COLOR_LIGHTGREEN_15 = "eon-lightgreen-15";
export const COLOR_LIGHTGREEN_20 = "eon-lightgreen-20";
export const COLOR_LIGHTGREEN_25 = "eon-lightgreen-25";
export const COLOR_LIGHTGREEN_30 = "eon-lightgreen-30";
export const COLOR_LIGHTGREEN_35 = "eon-lightgreen-35";
export const COLOR_LIGHTGREEN_40 = "eon-lightgreen-40";
export const COLOR_LIGHTGREEN_45 = "eon-lightgreen-45";
export const COLOR_LIGHTGREEN_50 = "eon-lightgreen-50";
export const COLOR_LIGHTGREEN_55 = "eon-lightgreen-55";
export const COLOR_LIGHTGREEN_60 = "eon-lightgreen-60";
export const COLOR_LIGHTGREEN_65 = "eon-lightgreen-65";
export const COLOR_LIGHTGREEN_70 = "eon-lightgreen-70";
export const COLOR_LIGHTGREEN_75 = "eon-lightgreen-75";
export const COLOR_LIGHTGREEN_80 = "eon-lightgreen-80";
export const COLOR_LIGHTGREEN_85 = "eon-lightgreen-85";
export const COLOR_LIGHTGREEN_90 = "eon-lightgreen-90";
export const COLOR_LIGHTGREEN_95 = "eon-lightgreen-95";
export const COLOR_LIGHTGREEN_OPACITY_5 = "eon-lightgreen-opacity-5";
export const COLOR_LIGHTGREEN_OPACITY_10 = "eon-lightgreen-opacity-10";
export const COLOR_LIGHTGREEN_OPACITY_15 = "eon-lightgreen-opacity-15";
export const COLOR_LIGHTGREEN_OPACITY_20 = "eon-lightgreen-opacity-20";
export const COLOR_LIGHTGREEN_OPACITY_25 = "eon-lightgreen-opacity-25";
export const COLOR_LIGHTGREEN_OPACITY_30 = "eon-lightgreen-opacity-30";
export const COLOR_LIGHTGREEN_OPACITY_35 = "eon-lightgreen-opacity-35";
export const COLOR_LIGHTGREEN_OPACITY_40 = "eon-lightgreen-opacity-40";
export const COLOR_LIGHTGREEN_OPACITY_45 = "eon-lightgreen-opacity-45";
export const COLOR_LIGHTGREEN_OPACITY_50 = "eon-lightgreen-opacity-50";
export const COLOR_LIGHTGREEN_OPACITY_55 = "eon-lightgreen-opacity-55";
export const COLOR_LIGHTGREEN_OPACITY_60 = "eon-lightgreen-opacity-60";
export const COLOR_LIGHTGREEN_OPACITY_65 = "eon-lightgreen-opacity-65";
export const COLOR_LIGHTGREEN_OPACITY_70 = "eon-lightgreen-opacity-70";
export const COLOR_LIGHTGREEN_OPACITY_75 = "eon-lightgreen-opacity-75";
export const COLOR_LIGHTGREEN_OPACITY_80 = "eon-lightgreen-opacity-80";
export const COLOR_LIGHTGREEN_OPACITY_85 = "eon-lightgreen-opacity-85";
export const COLOR_LIGHTGREEN_OPACITY_90 = "eon-lightgreen-opacity-90";
export const COLOR_LIGHTGREEN_OPACITY_95 = "eon-lightgreen-opacity-95";
export const COLOR_MIDDLEGREEN_SHADE_1 = "eon-middlegreen-shade-1";
export const COLOR_MIDDLEGREEN_SHADE_2 = "eon-middlegreen-shade-2";
export const COLOR_MIDDLEGREEN_TINT_1 = "eon-middlegreen-tint-1";
export const COLOR_MIDDLEGREEN_TINT_2 = "eon-middlegreen-tint-2";
export const COLOR_MIDDLEGREEN_5 = "eon-middlegreen-5";
export const COLOR_MIDDLEGREEN_10 = "eon-middlegreen-10";
export const COLOR_MIDDLEGREEN_15 = "eon-middlegreen-15";
export const COLOR_MIDDLEGREEN_20 = "eon-middlegreen-20";
export const COLOR_MIDDLEGREEN_25 = "eon-middlegreen-25";
export const COLOR_MIDDLEGREEN_30 = "eon-middlegreen-30";
export const COLOR_MIDDLEGREEN_35 = "eon-middlegreen-35";
export const COLOR_MIDDLEGREEN_40 = "eon-middlegreen-40";
export const COLOR_MIDDLEGREEN_45 = "eon-middlegreen-45";
export const COLOR_MIDDLEGREEN_50 = "eon-middlegreen-50";
export const COLOR_MIDDLEGREEN_55 = "eon-middlegreen-55";
export const COLOR_MIDDLEGREEN_60 = "eon-middlegreen-60";
export const COLOR_MIDDLEGREEN_65 = "eon-middlegreen-65";
export const COLOR_MIDDLEGREEN_70 = "eon-middlegreen-70";
export const COLOR_MIDDLEGREEN_75 = "eon-middlegreen-75";
export const COLOR_MIDDLEGREEN_80 = "eon-middlegreen-80";
export const COLOR_MIDDLEGREEN_85 = "eon-middlegreen-85";
export const COLOR_MIDDLEGREEN_90 = "eon-middlegreen-90";
export const COLOR_MIDDLEGREEN_95 = "eon-middlegreen-95";
export const COLOR_MIDDLEGREEN_OPACITY_5 = "eon-middlegreen-opacity-5";
export const COLOR_MIDDLEGREEN_OPACITY_10 = "eon-middlegreen-opacity-10";
export const COLOR_MIDDLEGREEN_OPACITY_15 = "eon-middlegreen-opacity-15";
export const COLOR_MIDDLEGREEN_OPACITY_20 = "eon-middlegreen-opacity-20";
export const COLOR_MIDDLEGREEN_OPACITY_25 = "eon-middlegreen-opacity-25";
export const COLOR_MIDDLEGREEN_OPACITY_30 = "eon-middlegreen-opacity-30";
export const COLOR_MIDDLEGREEN_OPACITY_35 = "eon-middlegreen-opacity-35";
export const COLOR_MIDDLEGREEN_OPACITY_40 = "eon-middlegreen-opacity-40";
export const COLOR_MIDDLEGREEN_OPACITY_45 = "eon-middlegreen-opacity-45";
export const COLOR_MIDDLEGREEN_OPACITY_50 = "eon-middlegreen-opacity-50";
export const COLOR_MIDDLEGREEN_OPACITY_55 = "eon-middlegreen-opacity-55";
export const COLOR_MIDDLEGREEN_OPACITY_60 = "eon-middlegreen-opacity-60";
export const COLOR_MIDDLEGREEN_OPACITY_65 = "eon-middlegreen-opacity-65";
export const COLOR_MIDDLEGREEN_OPACITY_70 = "eon-middlegreen-opacity-70";
export const COLOR_MIDDLEGREEN_OPACITY_75 = "eon-middlegreen-opacity-75";
export const COLOR_MIDDLEGREEN_OPACITY_80 = "eon-middlegreen-opacity-80";
export const COLOR_MIDDLEGREEN_OPACITY_85 = "eon-middlegreen-opacity-85";
export const COLOR_MIDDLEGREEN_OPACITY_90 = "eon-middlegreen-opacity-90";
export const COLOR_MIDDLEGREEN_OPACITY_95 = "eon-middlegreen-opacity-95";
export const COLOR_LIGHTORANGE_SHADE_1 = "eon-lightorange-shade-1";
export const COLOR_LIGHTORANGE_SHADE_2 = "eon-lightorange-shade-2";
export const COLOR_LIGHTORANGE_TINT_1 = "eon-lightorange-tint-1";
export const COLOR_LIGHTORANGE_TINT_2 = "eon-lightorange-tint-2";
export const COLOR_LIGHTORANGE_5 = "eon-lightorange-5";
export const COLOR_LIGHTORANGE_10 = "eon-lightorange-10";
export const COLOR_LIGHTORANGE_15 = "eon-lightorange-15";
export const COLOR_LIGHTORANGE_20 = "eon-lightorange-20";
export const COLOR_LIGHTORANGE_25 = "eon-lightorange-25";
export const COLOR_LIGHTORANGE_30 = "eon-lightorange-30";
export const COLOR_LIGHTORANGE_35 = "eon-lightorange-35";
export const COLOR_LIGHTORANGE_40 = "eon-lightorange-40";
export const COLOR_LIGHTORANGE_45 = "eon-lightorange-45";
export const COLOR_LIGHTORANGE_50 = "eon-lightorange-50";
export const COLOR_LIGHTORANGE_55 = "eon-lightorange-55";
export const COLOR_LIGHTORANGE_60 = "eon-lightorange-60";
export const COLOR_LIGHTORANGE_65 = "eon-lightorange-65";
export const COLOR_LIGHTORANGE_70 = "eon-lightorange-70";
export const COLOR_LIGHTORANGE_75 = "eon-lightorange-75";
export const COLOR_LIGHTORANGE_80 = "eon-lightorange-80";
export const COLOR_LIGHTORANGE_85 = "eon-lightorange-85";
export const COLOR_LIGHTORANGE_90 = "eon-lightorange-90";
export const COLOR_LIGHTORANGE_95 = "eon-lightorange-95";
export const COLOR_LIGHTORANGE_OPACITY_5 = "eon-lightorange-opacity-5";
export const COLOR_LIGHTORANGE_OPACITY_10 = "eon-lightorange-opacity-10";
export const COLOR_LIGHTORANGE_OPACITY_15 = "eon-lightorange-opacity-15";
export const COLOR_LIGHTORANGE_OPACITY_20 = "eon-lightorange-opacity-20";
export const COLOR_LIGHTORANGE_OPACITY_25 = "eon-lightorange-opacity-25";
export const COLOR_LIGHTORANGE_OPACITY_30 = "eon-lightorange-opacity-30";
export const COLOR_LIGHTORANGE_OPACITY_35 = "eon-lightorange-opacity-35";
export const COLOR_LIGHTORANGE_OPACITY_40 = "eon-lightorange-opacity-40";
export const COLOR_LIGHTORANGE_OPACITY_45 = "eon-lightorange-opacity-45";
export const COLOR_LIGHTORANGE_OPACITY_50 = "eon-lightorange-opacity-50";
export const COLOR_LIGHTORANGE_OPACITY_55 = "eon-lightorange-opacity-55";
export const COLOR_LIGHTORANGE_OPACITY_60 = "eon-lightorange-opacity-60";
export const COLOR_LIGHTORANGE_OPACITY_65 = "eon-lightorange-opacity-65";
export const COLOR_LIGHTORANGE_OPACITY_70 = "eon-lightorange-opacity-70";
export const COLOR_LIGHTORANGE_OPACITY_75 = "eon-lightorange-opacity-75";
export const COLOR_LIGHTORANGE_OPACITY_80 = "eon-lightorange-opacity-80";
export const COLOR_LIGHTORANGE_OPACITY_85 = "eon-lightorange-opacity-85";
export const COLOR_LIGHTORANGE_OPACITY_90 = "eon-lightorange-opacity-90";
export const COLOR_LIGHTORANGE_OPACITY_95 = "eon-lightorange-opacity-95";
export const COLOR_MIDDLEORANGE_SHADE_1 = "eon-middleorange-shade-1";
export const COLOR_MIDDLEORANGE_SHADE_2 = "eon-middleorange-shade-2";
export const COLOR_MIDDLEORANGE_TINT_1 = "eon-middleorange-tint-1";
export const COLOR_MIDDLEORANGE_TINT_2 = "eon-middleorange-tint-2";
export const COLOR_MIDDLEORANGE_5 = "eon-middleorange-5";
export const COLOR_MIDDLEORANGE_10 = "eon-middleorange-10";
export const COLOR_MIDDLEORANGE_15 = "eon-middleorange-15";
export const COLOR_MIDDLEORANGE_20 = "eon-middleorange-20";
export const COLOR_MIDDLEORANGE_25 = "eon-middleorange-25";
export const COLOR_MIDDLEORANGE_30 = "eon-middleorange-30";
export const COLOR_MIDDLEORANGE_35 = "eon-middleorange-35";
export const COLOR_MIDDLEORANGE_40 = "eon-middleorange-40";
export const COLOR_MIDDLEORANGE_45 = "eon-middleorange-45";
export const COLOR_MIDDLEORANGE_50 = "eon-middleorange-50";
export const COLOR_MIDDLEORANGE_55 = "eon-middleorange-55";
export const COLOR_MIDDLEORANGE_60 = "eon-middleorange-60";
export const COLOR_MIDDLEORANGE_65 = "eon-middleorange-65";
export const COLOR_MIDDLEORANGE_70 = "eon-middleorange-70";
export const COLOR_MIDDLEORANGE_75 = "eon-middleorange-75";
export const COLOR_MIDDLEORANGE_80 = "eon-middleorange-80";
export const COLOR_MIDDLEORANGE_85 = "eon-middleorange-85";
export const COLOR_MIDDLEORANGE_90 = "eon-middleorange-90";
export const COLOR_MIDDLEORANGE_95 = "eon-middleorange-95";
export const COLOR_MIDDLEORANGE_OPACITY_5 = "eon-middleorange-opacity-5";
export const COLOR_MIDDLEORANGE_OPACITY_10 = "eon-middleorange-opacity-10";
export const COLOR_MIDDLEORANGE_OPACITY_15 = "eon-middleorange-opacity-15";
export const COLOR_MIDDLEORANGE_OPACITY_20 = "eon-middleorange-opacity-20";
export const COLOR_MIDDLEORANGE_OPACITY_25 = "eon-middleorange-opacity-25";
export const COLOR_MIDDLEORANGE_OPACITY_30 = "eon-middleorange-opacity-30";
export const COLOR_MIDDLEORANGE_OPACITY_35 = "eon-middleorange-opacity-35";
export const COLOR_MIDDLEORANGE_OPACITY_40 = "eon-middleorange-opacity-40";
export const COLOR_MIDDLEORANGE_OPACITY_45 = "eon-middleorange-opacity-45";
export const COLOR_MIDDLEORANGE_OPACITY_50 = "eon-middleorange-opacity-50";
export const COLOR_MIDDLEORANGE_OPACITY_55 = "eon-middleorange-opacity-55";
export const COLOR_MIDDLEORANGE_OPACITY_60 = "eon-middleorange-opacity-60";
export const COLOR_MIDDLEORANGE_OPACITY_65 = "eon-middleorange-opacity-65";
export const COLOR_MIDDLEORANGE_OPACITY_70 = "eon-middleorange-opacity-70";
export const COLOR_MIDDLEORANGE_OPACITY_75 = "eon-middleorange-opacity-75";
export const COLOR_MIDDLEORANGE_OPACITY_80 = "eon-middleorange-opacity-80";
export const COLOR_MIDDLEORANGE_OPACITY_85 = "eon-middleorange-opacity-85";
export const COLOR_MIDDLEORANGE_OPACITY_90 = "eon-middleorange-opacity-90";
export const COLOR_MIDDLEORANGE_OPACITY_95 = "eon-middleorange-opacity-95";
export const COLOR_BRIGHT_SHADE_1 = "eon-bright-shade-1";
export const COLOR_BRIGHT_SHADE_2 = "eon-bright-shade-2";
export const COLOR_BRIGHT_TINT_1 = "eon-bright-tint-1";
export const COLOR_BRIGHT_TINT_2 = "eon-bright-tint-2";
export const COLOR_BRIGHT_5 = "eon-bright-5";
export const COLOR_BRIGHT_10 = "eon-bright-10";
export const COLOR_BRIGHT_15 = "eon-bright-15";
export const COLOR_BRIGHT_20 = "eon-bright-20";
export const COLOR_BRIGHT_25 = "eon-bright-25";
export const COLOR_BRIGHT_30 = "eon-bright-30";
export const COLOR_BRIGHT_35 = "eon-bright-35";
export const COLOR_BRIGHT_40 = "eon-bright-40";
export const COLOR_BRIGHT_45 = "eon-bright-45";
export const COLOR_BRIGHT_50 = "eon-bright-50";
export const COLOR_BRIGHT_55 = "eon-bright-55";
export const COLOR_BRIGHT_60 = "eon-bright-60";
export const COLOR_BRIGHT_65 = "eon-bright-65";
export const COLOR_BRIGHT_70 = "eon-bright-70";
export const COLOR_BRIGHT_75 = "eon-bright-75";
export const COLOR_BRIGHT_80 = "eon-bright-80";
export const COLOR_BRIGHT_85 = "eon-bright-85";
export const COLOR_BRIGHT_90 = "eon-bright-90";
export const COLOR_BRIGHT_95 = "eon-bright-95";
export const COLOR_BRIGHT_OPACITY_5 = "eon-bright-opacity-5";
export const COLOR_BRIGHT_OPACITY_10 = "eon-bright-opacity-10";
export const COLOR_BRIGHT_OPACITY_15 = "eon-bright-opacity-15";
export const COLOR_BRIGHT_OPACITY_20 = "eon-bright-opacity-20";
export const COLOR_BRIGHT_OPACITY_25 = "eon-bright-opacity-25";
export const COLOR_BRIGHT_OPACITY_30 = "eon-bright-opacity-30";
export const COLOR_BRIGHT_OPACITY_35 = "eon-bright-opacity-35";
export const COLOR_BRIGHT_OPACITY_40 = "eon-bright-opacity-40";
export const COLOR_BRIGHT_OPACITY_45 = "eon-bright-opacity-45";
export const COLOR_BRIGHT_OPACITY_50 = "eon-bright-opacity-50";
export const COLOR_BRIGHT_OPACITY_55 = "eon-bright-opacity-55";
export const COLOR_BRIGHT_OPACITY_60 = "eon-bright-opacity-60";
export const COLOR_BRIGHT_OPACITY_65 = "eon-bright-opacity-65";
export const COLOR_BRIGHT_OPACITY_70 = "eon-bright-opacity-70";
export const COLOR_BRIGHT_OPACITY_75 = "eon-bright-opacity-75";
export const COLOR_BRIGHT_OPACITY_80 = "eon-bright-opacity-80";
export const COLOR_BRIGHT_OPACITY_85 = "eon-bright-opacity-85";
export const COLOR_BRIGHT_OPACITY_90 = "eon-bright-opacity-90";
export const COLOR_BRIGHT_OPACITY_95 = "eon-bright-opacity-95";
export const COLOR_DARK_SHADE_1 = "eon-dark-shade-1";
export const COLOR_DARK_SHADE_2 = "eon-dark-shade-2";
export const COLOR_DARK_TINT_1 = "eon-dark-tint-1";
export const COLOR_DARK_TINT_2 = "eon-dark-tint-2";
export const COLOR_DARK_5 = "eon-dark-5";
export const COLOR_DARK_10 = "eon-dark-10";
export const COLOR_DARK_15 = "eon-dark-15";
export const COLOR_DARK_20 = "eon-dark-20";
export const COLOR_DARK_25 = "eon-dark-25";
export const COLOR_DARK_30 = "eon-dark-30";
export const COLOR_DARK_35 = "eon-dark-35";
export const COLOR_DARK_40 = "eon-dark-40";
export const COLOR_DARK_45 = "eon-dark-45";
export const COLOR_DARK_50 = "eon-dark-50";
export const COLOR_DARK_55 = "eon-dark-55";
export const COLOR_DARK_60 = "eon-dark-60";
export const COLOR_DARK_65 = "eon-dark-65";
export const COLOR_DARK_70 = "eon-dark-70";
export const COLOR_DARK_75 = "eon-dark-75";
export const COLOR_DARK_80 = "eon-dark-80";
export const COLOR_DARK_85 = "eon-dark-85";
export const COLOR_DARK_90 = "eon-dark-90";
export const COLOR_DARK_95 = "eon-dark-95";
export const COLOR_DARK_OPACITY_5 = "eon-dark-opacity-5";
export const COLOR_DARK_OPACITY_10 = "eon-dark-opacity-10";
export const COLOR_DARK_OPACITY_15 = "eon-dark-opacity-15";
export const COLOR_DARK_OPACITY_20 = "eon-dark-opacity-20";
export const COLOR_DARK_OPACITY_25 = "eon-dark-opacity-25";
export const COLOR_DARK_OPACITY_30 = "eon-dark-opacity-30";
export const COLOR_DARK_OPACITY_35 = "eon-dark-opacity-35";
export const COLOR_DARK_OPACITY_40 = "eon-dark-opacity-40";
export const COLOR_DARK_OPACITY_45 = "eon-dark-opacity-45";
export const COLOR_DARK_OPACITY_50 = "eon-dark-opacity-50";
export const COLOR_DARK_OPACITY_55 = "eon-dark-opacity-55";
export const COLOR_DARK_OPACITY_60 = "eon-dark-opacity-60";
export const COLOR_DARK_OPACITY_65 = "eon-dark-opacity-65";
export const COLOR_DARK_OPACITY_70 = "eon-dark-opacity-70";
export const COLOR_DARK_OPACITY_75 = "eon-dark-opacity-75";
export const COLOR_DARK_OPACITY_80 = "eon-dark-opacity-80";
export const COLOR_DARK_OPACITY_85 = "eon-dark-opacity-85";
export const COLOR_DARK_OPACITY_90 = "eon-dark-opacity-90";
export const COLOR_DARK_OPACITY_95 = "eon-dark-opacity-95";
export const COLOR_LIGHT_GREY_SHADE_1 = "eon-light-grey-shade-1";
export const COLOR_LIGHT_GREY_SHADE_2 = "eon-light-grey-shade-2";
export const COLOR_LIGHT_GREY_TINT_1 = "eon-light-grey-tint-1";
export const COLOR_LIGHT_GREY_TINT_2 = "eon-light-grey-tint-2";
export const COLOR_LIGHT_GREY_5 = "eon-light-grey-5";
export const COLOR_LIGHT_GREY_10 = "eon-light-grey-10";
export const COLOR_LIGHT_GREY_15 = "eon-light-grey-15";
export const COLOR_LIGHT_GREY_20 = "eon-light-grey-20";
export const COLOR_LIGHT_GREY_25 = "eon-light-grey-25";
export const COLOR_LIGHT_GREY_30 = "eon-light-grey-30";
export const COLOR_LIGHT_GREY_35 = "eon-light-grey-35";
export const COLOR_LIGHT_GREY_40 = "eon-light-grey-40";
export const COLOR_LIGHT_GREY_45 = "eon-light-grey-45";
export const COLOR_LIGHT_GREY_50 = "eon-light-grey-50";
export const COLOR_LIGHT_GREY_55 = "eon-light-grey-55";
export const COLOR_LIGHT_GREY_60 = "eon-light-grey-60";
export const COLOR_LIGHT_GREY_65 = "eon-light-grey-65";
export const COLOR_LIGHT_GREY_70 = "eon-light-grey-70";
export const COLOR_LIGHT_GREY_75 = "eon-light-grey-75";
export const COLOR_LIGHT_GREY_80 = "eon-light-grey-80";
export const COLOR_LIGHT_GREY_85 = "eon-light-grey-85";
export const COLOR_LIGHT_GREY_90 = "eon-light-grey-90";
export const COLOR_LIGHT_GREY_95 = "eon-light-grey-95";
export const COLOR_LIGHT_GREY_OPACITY_5 = "eon-light-grey-opacity-5";
export const COLOR_LIGHT_GREY_OPACITY_10 = "eon-light-grey-opacity-10";
export const COLOR_LIGHT_GREY_OPACITY_15 = "eon-light-grey-opacity-15";
export const COLOR_LIGHT_GREY_OPACITY_20 = "eon-light-grey-opacity-20";
export const COLOR_LIGHT_GREY_OPACITY_25 = "eon-light-grey-opacity-25";
export const COLOR_LIGHT_GREY_OPACITY_30 = "eon-light-grey-opacity-30";
export const COLOR_LIGHT_GREY_OPACITY_35 = "eon-light-grey-opacity-35";
export const COLOR_LIGHT_GREY_OPACITY_40 = "eon-light-grey-opacity-40";
export const COLOR_LIGHT_GREY_OPACITY_45 = "eon-light-grey-opacity-45";
export const COLOR_LIGHT_GREY_OPACITY_50 = "eon-light-grey-opacity-50";
export const COLOR_LIGHT_GREY_OPACITY_55 = "eon-light-grey-opacity-55";
export const COLOR_LIGHT_GREY_OPACITY_60 = "eon-light-grey-opacity-60";
export const COLOR_LIGHT_GREY_OPACITY_65 = "eon-light-grey-opacity-65";
export const COLOR_LIGHT_GREY_OPACITY_70 = "eon-light-grey-opacity-70";
export const COLOR_LIGHT_GREY_OPACITY_75 = "eon-light-grey-opacity-75";
export const COLOR_LIGHT_GREY_OPACITY_80 = "eon-light-grey-opacity-80";
export const COLOR_LIGHT_GREY_OPACITY_85 = "eon-light-grey-opacity-85";
export const COLOR_LIGHT_GREY_OPACITY_90 = "eon-light-grey-opacity-90";
export const COLOR_LIGHT_GREY_OPACITY_95 = "eon-light-grey-opacity-95";
export const COLOR_TRANSPARENT_GREEN_SHADE_1 = "eon-transparent-green-shade-1";
export const COLOR_TRANSPARENT_GREEN_SHADE_2 = "eon-transparent-green-shade-2";
export const COLOR_TRANSPARENT_GREEN_TINT_1 = "eon-transparent-green-tint-1";
export const COLOR_TRANSPARENT_GREEN_TINT_2 = "eon-transparent-green-tint-2";
export const COLOR_TRANSPARENT_GREEN_5 = "eon-transparent-green-5";
export const COLOR_TRANSPARENT_GREEN_10 = "eon-transparent-green-10";
export const COLOR_TRANSPARENT_GREEN_15 = "eon-transparent-green-15";
export const COLOR_TRANSPARENT_GREEN_20 = "eon-transparent-green-20";
export const COLOR_TRANSPARENT_GREEN_25 = "eon-transparent-green-25";
export const COLOR_TRANSPARENT_GREEN_30 = "eon-transparent-green-30";
export const COLOR_TRANSPARENT_GREEN_35 = "eon-transparent-green-35";
export const COLOR_TRANSPARENT_GREEN_40 = "eon-transparent-green-40";
export const COLOR_TRANSPARENT_GREEN_45 = "eon-transparent-green-45";
export const COLOR_TRANSPARENT_GREEN_50 = "eon-transparent-green-50";
export const COLOR_TRANSPARENT_GREEN_55 = "eon-transparent-green-55";
export const COLOR_TRANSPARENT_GREEN_60 = "eon-transparent-green-60";
export const COLOR_TRANSPARENT_GREEN_65 = "eon-transparent-green-65";
export const COLOR_TRANSPARENT_GREEN_70 = "eon-transparent-green-70";
export const COLOR_TRANSPARENT_GREEN_75 = "eon-transparent-green-75";
export const COLOR_TRANSPARENT_GREEN_80 = "eon-transparent-green-80";
export const COLOR_TRANSPARENT_GREEN_85 = "eon-transparent-green-85";
export const COLOR_TRANSPARENT_GREEN_90 = "eon-transparent-green-90";
export const COLOR_TRANSPARENT_GREEN_95 = "eon-transparent-green-95";
export const COLOR_TRANSPARENT_GREEN_OPACITY_5 = "eon-transparent-green-opacity-5";
export const COLOR_TRANSPARENT_GREEN_OPACITY_10 = "eon-transparent-green-opacity-10";
export const COLOR_TRANSPARENT_GREEN_OPACITY_15 = "eon-transparent-green-opacity-15";
export const COLOR_TRANSPARENT_GREEN_OPACITY_20 = "eon-transparent-green-opacity-20";
export const COLOR_TRANSPARENT_GREEN_OPACITY_25 = "eon-transparent-green-opacity-25";
export const COLOR_TRANSPARENT_GREEN_OPACITY_30 = "eon-transparent-green-opacity-30";
export const COLOR_TRANSPARENT_GREEN_OPACITY_35 = "eon-transparent-green-opacity-35";
export const COLOR_TRANSPARENT_GREEN_OPACITY_40 = "eon-transparent-green-opacity-40";
export const COLOR_TRANSPARENT_GREEN_OPACITY_45 = "eon-transparent-green-opacity-45";
export const COLOR_TRANSPARENT_GREEN_OPACITY_50 = "eon-transparent-green-opacity-50";
export const COLOR_TRANSPARENT_GREEN_OPACITY_55 = "eon-transparent-green-opacity-55";
export const COLOR_TRANSPARENT_GREEN_OPACITY_60 = "eon-transparent-green-opacity-60";
export const COLOR_TRANSPARENT_GREEN_OPACITY_65 = "eon-transparent-green-opacity-65";
export const COLOR_TRANSPARENT_GREEN_OPACITY_70 = "eon-transparent-green-opacity-70";
export const COLOR_TRANSPARENT_GREEN_OPACITY_75 = "eon-transparent-green-opacity-75";
export const COLOR_TRANSPARENT_GREEN_OPACITY_80 = "eon-transparent-green-opacity-80";
export const COLOR_TRANSPARENT_GREEN_OPACITY_85 = "eon-transparent-green-opacity-85";
export const COLOR_TRANSPARENT_GREEN_OPACITY_90 = "eon-transparent-green-opacity-90";
export const COLOR_TRANSPARENT_GREEN_OPACITY_95 = "eon-transparent-green-opacity-95";
export const COLOR_TRANSPARENT_RED_SHADE_1 = "eon-transparent-red-shade-1";
export const COLOR_TRANSPARENT_RED_SHADE_2 = "eon-transparent-red-shade-2";
export const COLOR_TRANSPARENT_RED_TINT_1 = "eon-transparent-red-tint-1";
export const COLOR_TRANSPARENT_RED_TINT_2 = "eon-transparent-red-tint-2";
export const COLOR_TRANSPARENT_RED_5 = "eon-transparent-red-5";
export const COLOR_TRANSPARENT_RED_10 = "eon-transparent-red-10";
export const COLOR_TRANSPARENT_RED_15 = "eon-transparent-red-15";
export const COLOR_TRANSPARENT_RED_20 = "eon-transparent-red-20";
export const COLOR_TRANSPARENT_RED_25 = "eon-transparent-red-25";
export const COLOR_TRANSPARENT_RED_30 = "eon-transparent-red-30";
export const COLOR_TRANSPARENT_RED_35 = "eon-transparent-red-35";
export const COLOR_TRANSPARENT_RED_40 = "eon-transparent-red-40";
export const COLOR_TRANSPARENT_RED_45 = "eon-transparent-red-45";
export const COLOR_TRANSPARENT_RED_50 = "eon-transparent-red-50";
export const COLOR_TRANSPARENT_RED_55 = "eon-transparent-red-55";
export const COLOR_TRANSPARENT_RED_60 = "eon-transparent-red-60";
export const COLOR_TRANSPARENT_RED_65 = "eon-transparent-red-65";
export const COLOR_TRANSPARENT_RED_70 = "eon-transparent-red-70";
export const COLOR_TRANSPARENT_RED_75 = "eon-transparent-red-75";
export const COLOR_TRANSPARENT_RED_80 = "eon-transparent-red-80";
export const COLOR_TRANSPARENT_RED_85 = "eon-transparent-red-85";
export const COLOR_TRANSPARENT_RED_90 = "eon-transparent-red-90";
export const COLOR_TRANSPARENT_RED_95 = "eon-transparent-red-95";
export const COLOR_TRANSPARENT_RED_OPACITY_5 = "eon-transparent-red-opacity-5";
export const COLOR_TRANSPARENT_RED_OPACITY_10 = "eon-transparent-red-opacity-10";
export const COLOR_TRANSPARENT_RED_OPACITY_15 = "eon-transparent-red-opacity-15";
export const COLOR_TRANSPARENT_RED_OPACITY_20 = "eon-transparent-red-opacity-20";
export const COLOR_TRANSPARENT_RED_OPACITY_25 = "eon-transparent-red-opacity-25";
export const COLOR_TRANSPARENT_RED_OPACITY_30 = "eon-transparent-red-opacity-30";
export const COLOR_TRANSPARENT_RED_OPACITY_35 = "eon-transparent-red-opacity-35";
export const COLOR_TRANSPARENT_RED_OPACITY_40 = "eon-transparent-red-opacity-40";
export const COLOR_TRANSPARENT_RED_OPACITY_45 = "eon-transparent-red-opacity-45";
export const COLOR_TRANSPARENT_RED_OPACITY_50 = "eon-transparent-red-opacity-50";
export const COLOR_TRANSPARENT_RED_OPACITY_55 = "eon-transparent-red-opacity-55";
export const COLOR_TRANSPARENT_RED_OPACITY_60 = "eon-transparent-red-opacity-60";
export const COLOR_TRANSPARENT_RED_OPACITY_65 = "eon-transparent-red-opacity-65";
export const COLOR_TRANSPARENT_RED_OPACITY_70 = "eon-transparent-red-opacity-70";
export const COLOR_TRANSPARENT_RED_OPACITY_75 = "eon-transparent-red-opacity-75";
export const COLOR_TRANSPARENT_RED_OPACITY_80 = "eon-transparent-red-opacity-80";
export const COLOR_TRANSPARENT_RED_OPACITY_85 = "eon-transparent-red-opacity-85";
export const COLOR_TRANSPARENT_RED_OPACITY_90 = "eon-transparent-red-opacity-90";
export const COLOR_TRANSPARENT_RED_OPACITY_95 = "eon-transparent-red-opacity-95";
export const COLOR_TRANSPARENT_YELLOW_SHADE_1 = "eon-transparent-yellow-shade-1";
export const COLOR_TRANSPARENT_YELLOW_SHADE_2 = "eon-transparent-yellow-shade-2";
export const COLOR_TRANSPARENT_YELLOW_TINT_1 = "eon-transparent-yellow-tint-1";
export const COLOR_TRANSPARENT_YELLOW_TINT_2 = "eon-transparent-yellow-tint-2";
export const COLOR_TRANSPARENT_YELLOW_5 = "eon-transparent-yellow-5";
export const COLOR_TRANSPARENT_YELLOW_10 = "eon-transparent-yellow-10";
export const COLOR_TRANSPARENT_YELLOW_15 = "eon-transparent-yellow-15";
export const COLOR_TRANSPARENT_YELLOW_20 = "eon-transparent-yellow-20";
export const COLOR_TRANSPARENT_YELLOW_25 = "eon-transparent-yellow-25";
export const COLOR_TRANSPARENT_YELLOW_30 = "eon-transparent-yellow-30";
export const COLOR_TRANSPARENT_YELLOW_35 = "eon-transparent-yellow-35";
export const COLOR_TRANSPARENT_YELLOW_40 = "eon-transparent-yellow-40";
export const COLOR_TRANSPARENT_YELLOW_45 = "eon-transparent-yellow-45";
export const COLOR_TRANSPARENT_YELLOW_50 = "eon-transparent-yellow-50";
export const COLOR_TRANSPARENT_YELLOW_55 = "eon-transparent-yellow-55";
export const COLOR_TRANSPARENT_YELLOW_60 = "eon-transparent-yellow-60";
export const COLOR_TRANSPARENT_YELLOW_65 = "eon-transparent-yellow-65";
export const COLOR_TRANSPARENT_YELLOW_70 = "eon-transparent-yellow-70";
export const COLOR_TRANSPARENT_YELLOW_75 = "eon-transparent-yellow-75";
export const COLOR_TRANSPARENT_YELLOW_80 = "eon-transparent-yellow-80";
export const COLOR_TRANSPARENT_YELLOW_85 = "eon-transparent-yellow-85";
export const COLOR_TRANSPARENT_YELLOW_90 = "eon-transparent-yellow-90";
export const COLOR_TRANSPARENT_YELLOW_95 = "eon-transparent-yellow-95";
export const COLOR_TRANSPARENT_YELLOW_OPACITY_5 = "eon-transparent-yellow-opacity-5";
export const COLOR_TRANSPARENT_YELLOW_OPACITY_10 = "eon-transparent-yellow-opacity-10";
export const COLOR_TRANSPARENT_YELLOW_OPACITY_15 = "eon-transparent-yellow-opacity-15";
export const COLOR_TRANSPARENT_YELLOW_OPACITY_20 = "eon-transparent-yellow-opacity-20";
export const COLOR_TRANSPARENT_YELLOW_OPACITY_25 = "eon-transparent-yellow-opacity-25";
export const COLOR_TRANSPARENT_YELLOW_OPACITY_30 = "eon-transparent-yellow-opacity-30";
export const COLOR_TRANSPARENT_YELLOW_OPACITY_35 = "eon-transparent-yellow-opacity-35";
export const COLOR_TRANSPARENT_YELLOW_OPACITY_40 = "eon-transparent-yellow-opacity-40";
export const COLOR_TRANSPARENT_YELLOW_OPACITY_45 = "eon-transparent-yellow-opacity-45";
export const COLOR_TRANSPARENT_YELLOW_OPACITY_50 = "eon-transparent-yellow-opacity-50";
export const COLOR_TRANSPARENT_YELLOW_OPACITY_55 = "eon-transparent-yellow-opacity-55";
export const COLOR_TRANSPARENT_YELLOW_OPACITY_60 = "eon-transparent-yellow-opacity-60";
export const COLOR_TRANSPARENT_YELLOW_OPACITY_65 = "eon-transparent-yellow-opacity-65";
export const COLOR_TRANSPARENT_YELLOW_OPACITY_70 = "eon-transparent-yellow-opacity-70";
export const COLOR_TRANSPARENT_YELLOW_OPACITY_75 = "eon-transparent-yellow-opacity-75";
export const COLOR_TRANSPARENT_YELLOW_OPACITY_80 = "eon-transparent-yellow-opacity-80";
export const COLOR_TRANSPARENT_YELLOW_OPACITY_85 = "eon-transparent-yellow-opacity-85";
export const COLOR_TRANSPARENT_YELLOW_OPACITY_90 = "eon-transparent-yellow-opacity-90";
export const COLOR_TRANSPARENT_YELLOW_OPACITY_95 = "eon-transparent-yellow-opacity-95";
export const COLOR_TRANSPARENT_BLUE_SHADE_1 = "eon-transparent-blue-shade-1";
export const COLOR_TRANSPARENT_BLUE_SHADE_2 = "eon-transparent-blue-shade-2";
export const COLOR_TRANSPARENT_BLUE_TINT_1 = "eon-transparent-blue-tint-1";
export const COLOR_TRANSPARENT_BLUE_TINT_2 = "eon-transparent-blue-tint-2";
export const COLOR_TRANSPARENT_BLUE_5 = "eon-transparent-blue-5";
export const COLOR_TRANSPARENT_BLUE_10 = "eon-transparent-blue-10";
export const COLOR_TRANSPARENT_BLUE_15 = "eon-transparent-blue-15";
export const COLOR_TRANSPARENT_BLUE_20 = "eon-transparent-blue-20";
export const COLOR_TRANSPARENT_BLUE_25 = "eon-transparent-blue-25";
export const COLOR_TRANSPARENT_BLUE_30 = "eon-transparent-blue-30";
export const COLOR_TRANSPARENT_BLUE_35 = "eon-transparent-blue-35";
export const COLOR_TRANSPARENT_BLUE_40 = "eon-transparent-blue-40";
export const COLOR_TRANSPARENT_BLUE_45 = "eon-transparent-blue-45";
export const COLOR_TRANSPARENT_BLUE_50 = "eon-transparent-blue-50";
export const COLOR_TRANSPARENT_BLUE_55 = "eon-transparent-blue-55";
export const COLOR_TRANSPARENT_BLUE_60 = "eon-transparent-blue-60";
export const COLOR_TRANSPARENT_BLUE_65 = "eon-transparent-blue-65";
export const COLOR_TRANSPARENT_BLUE_70 = "eon-transparent-blue-70";
export const COLOR_TRANSPARENT_BLUE_75 = "eon-transparent-blue-75";
export const COLOR_TRANSPARENT_BLUE_80 = "eon-transparent-blue-80";
export const COLOR_TRANSPARENT_BLUE_85 = "eon-transparent-blue-85";
export const COLOR_TRANSPARENT_BLUE_90 = "eon-transparent-blue-90";
export const COLOR_TRANSPARENT_BLUE_95 = "eon-transparent-blue-95";
export const COLOR_TRANSPARENT_BLUE_OPACITY_5 = "eon-transparent-blue-opacity-5";
export const COLOR_TRANSPARENT_BLUE_OPACITY_10 = "eon-transparent-blue-opacity-10";
export const COLOR_TRANSPARENT_BLUE_OPACITY_15 = "eon-transparent-blue-opacity-15";
export const COLOR_TRANSPARENT_BLUE_OPACITY_20 = "eon-transparent-blue-opacity-20";
export const COLOR_TRANSPARENT_BLUE_OPACITY_25 = "eon-transparent-blue-opacity-25";
export const COLOR_TRANSPARENT_BLUE_OPACITY_30 = "eon-transparent-blue-opacity-30";
export const COLOR_TRANSPARENT_BLUE_OPACITY_35 = "eon-transparent-blue-opacity-35";
export const COLOR_TRANSPARENT_BLUE_OPACITY_40 = "eon-transparent-blue-opacity-40";
export const COLOR_TRANSPARENT_BLUE_OPACITY_45 = "eon-transparent-blue-opacity-45";
export const COLOR_TRANSPARENT_BLUE_OPACITY_50 = "eon-transparent-blue-opacity-50";
export const COLOR_TRANSPARENT_BLUE_OPACITY_55 = "eon-transparent-blue-opacity-55";
export const COLOR_TRANSPARENT_BLUE_OPACITY_60 = "eon-transparent-blue-opacity-60";
export const COLOR_TRANSPARENT_BLUE_OPACITY_65 = "eon-transparent-blue-opacity-65";
export const COLOR_TRANSPARENT_BLUE_OPACITY_70 = "eon-transparent-blue-opacity-70";
export const COLOR_TRANSPARENT_BLUE_OPACITY_75 = "eon-transparent-blue-opacity-75";
export const COLOR_TRANSPARENT_BLUE_OPACITY_80 = "eon-transparent-blue-opacity-80";
export const COLOR_TRANSPARENT_BLUE_OPACITY_85 = "eon-transparent-blue-opacity-85";
export const COLOR_TRANSPARENT_BLUE_OPACITY_90 = "eon-transparent-blue-opacity-90";
export const COLOR_TRANSPARENT_BLUE_OPACITY_95 = "eon-transparent-blue-opacity-95";
export const COLOR_WHITE_SHADE_1 = "eon-white-shade-1";
export const COLOR_WHITE_SHADE_2 = "eon-white-shade-2";
export const COLOR_WHITE_TINT_1 = "eon-white-tint-1";
export const COLOR_WHITE_TINT_2 = "eon-white-tint-2";
export const COLOR_WHITE_5 = "eon-white-5";
export const COLOR_WHITE_10 = "eon-white-10";
export const COLOR_WHITE_15 = "eon-white-15";
export const COLOR_WHITE_20 = "eon-white-20";
export const COLOR_WHITE_25 = "eon-white-25";
export const COLOR_WHITE_30 = "eon-white-30";
export const COLOR_WHITE_35 = "eon-white-35";
export const COLOR_WHITE_40 = "eon-white-40";
export const COLOR_WHITE_45 = "eon-white-45";
export const COLOR_WHITE_50 = "eon-white-50";
export const COLOR_WHITE_55 = "eon-white-55";
export const COLOR_WHITE_60 = "eon-white-60";
export const COLOR_WHITE_65 = "eon-white-65";
export const COLOR_WHITE_70 = "eon-white-70";
export const COLOR_WHITE_75 = "eon-white-75";
export const COLOR_WHITE_80 = "eon-white-80";
export const COLOR_WHITE_85 = "eon-white-85";
export const COLOR_WHITE_90 = "eon-white-90";
export const COLOR_WHITE_95 = "eon-white-95";
export const COLOR_WHITE_OPACITY_5 = "eon-white-opacity-5";
export const COLOR_WHITE_OPACITY_10 = "eon-white-opacity-10";
export const COLOR_WHITE_OPACITY_15 = "eon-white-opacity-15";
export const COLOR_WHITE_OPACITY_20 = "eon-white-opacity-20";
export const COLOR_WHITE_OPACITY_25 = "eon-white-opacity-25";
export const COLOR_WHITE_OPACITY_30 = "eon-white-opacity-30";
export const COLOR_WHITE_OPACITY_35 = "eon-white-opacity-35";
export const COLOR_WHITE_OPACITY_40 = "eon-white-opacity-40";
export const COLOR_WHITE_OPACITY_45 = "eon-white-opacity-45";
export const COLOR_WHITE_OPACITY_50 = "eon-white-opacity-50";
export const COLOR_WHITE_OPACITY_55 = "eon-white-opacity-55";
export const COLOR_WHITE_OPACITY_60 = "eon-white-opacity-60";
export const COLOR_WHITE_OPACITY_65 = "eon-white-opacity-65";
export const COLOR_WHITE_OPACITY_70 = "eon-white-opacity-70";
export const COLOR_WHITE_OPACITY_75 = "eon-white-opacity-75";
export const COLOR_WHITE_OPACITY_80 = "eon-white-opacity-80";
export const COLOR_WHITE_OPACITY_85 = "eon-white-opacity-85";
export const COLOR_WHITE_OPACITY_90 = "eon-white-opacity-90";
export const COLOR_WHITE_OPACITY_95 = "eon-white-opacity-95";
export const COLOR_BLACK_SHADE_1 = "eon-black-shade-1";
export const COLOR_BLACK_SHADE_2 = "eon-black-shade-2";
export const COLOR_BLACK_TINT_1 = "eon-black-tint-1";
export const COLOR_BLACK_TINT_2 = "eon-black-tint-2";
export const COLOR_BLACK_5 = "eon-black-5";
export const COLOR_BLACK_10 = "eon-black-10";
export const COLOR_BLACK_15 = "eon-black-15";
export const COLOR_BLACK_20 = "eon-black-20";
export const COLOR_BLACK_25 = "eon-black-25";
export const COLOR_BLACK_30 = "eon-black-30";
export const COLOR_BLACK_35 = "eon-black-35";
export const COLOR_BLACK_40 = "eon-black-40";
export const COLOR_BLACK_45 = "eon-black-45";
export const COLOR_BLACK_50 = "eon-black-50";
export const COLOR_BLACK_55 = "eon-black-55";
export const COLOR_BLACK_60 = "eon-black-60";
export const COLOR_BLACK_65 = "eon-black-65";
export const COLOR_BLACK_70 = "eon-black-70";
export const COLOR_BLACK_75 = "eon-black-75";
export const COLOR_BLACK_80 = "eon-black-80";
export const COLOR_BLACK_85 = "eon-black-85";
export const COLOR_BLACK_90 = "eon-black-90";
export const COLOR_BLACK_95 = "eon-black-95";
export const COLOR_BLACK_OPACITY_5 = "eon-black-opacity-5";
export const COLOR_BLACK_OPACITY_10 = "eon-black-opacity-10";
export const COLOR_BLACK_OPACITY_15 = "eon-black-opacity-15";
export const COLOR_BLACK_OPACITY_20 = "eon-black-opacity-20";
export const COLOR_BLACK_OPACITY_25 = "eon-black-opacity-25";
export const COLOR_BLACK_OPACITY_30 = "eon-black-opacity-30";
export const COLOR_BLACK_OPACITY_35 = "eon-black-opacity-35";
export const COLOR_BLACK_OPACITY_40 = "eon-black-opacity-40";
export const COLOR_BLACK_OPACITY_45 = "eon-black-opacity-45";
export const COLOR_BLACK_OPACITY_50 = "eon-black-opacity-50";
export const COLOR_BLACK_OPACITY_55 = "eon-black-opacity-55";
export const COLOR_BLACK_OPACITY_60 = "eon-black-opacity-60";
export const COLOR_BLACK_OPACITY_65 = "eon-black-opacity-65";
export const COLOR_BLACK_OPACITY_70 = "eon-black-opacity-70";
export const COLOR_BLACK_OPACITY_75 = "eon-black-opacity-75";
export const COLOR_BLACK_OPACITY_80 = "eon-black-opacity-80";
export const COLOR_BLACK_OPACITY_85 = "eon-black-opacity-85";
export const COLOR_BLACK_OPACITY_90 = "eon-black-opacity-90";
export const COLOR_BLACK_OPACITY_95 = "eon-black-opacity-95";

export const EON_COLORS = [
  COLOR_BLUE,
  COLOR_DARKBLUE,
  COLOR_BLUE_ACTIVE,
  COLOR_GREEN,
  COLOR_ORANGE,
  COLOR_ORANGE_ACTIVE,
  COLOR_TEAL,
  COLOR_TEAL_ACTIVE,
  COLOR_TURQUOISE,
  COLOR_TURQUOISE_ACTIVE,
  COLOR_LIGHTTEAL,
  COLOR_MIDDLETEAL,
  COLOR_LIGHTBLUE,
  COLOR_MIDDLEBLUE,
  COLOR_BLUE_BORDER,
  COLOR_RED,
  COLOR_YELLOW,
  COLOR_LIGHTTURQUOISE,
  COLOR_MIDDLETURQUOISE,
  COLOR_GREEN_BORDER,
  COLOR_GREEN_ACTIVE,
  COLOR_LIGHTGREEN,
  COLOR_MIDDLEGREEN,
  COLOR_LIGHTORANGE,
  COLOR_MIDDLEORANGE,
  COLOR_BRIGHT,
  COLOR_DARK,
  COLOR_LIGHT_GREY,
  COLOR_TRANSPARENT_GREEN,
  COLOR_TRANSPARENT_RED,
  COLOR_TRANSPARENT_YELLOW,
  COLOR_TRANSPARENT_BLUE,
  COLOR_WHITE,
  COLOR_BLACK,
  COLOR_BLUE_SHADE_1,
  COLOR_BLUE_SHADE_2,
  COLOR_BLUE_TINT_1,
  COLOR_BLUE_TINT_2,
  COLOR_BLUE_5,
  COLOR_BLUE_10,
  COLOR_BLUE_15,
  COLOR_BLUE_20,
  COLOR_BLUE_25,
  COLOR_BLUE_30,
  COLOR_BLUE_35,
  COLOR_BLUE_40,
  COLOR_BLUE_45,
  COLOR_BLUE_50,
  COLOR_BLUE_55,
  COLOR_BLUE_60,
  COLOR_BLUE_65,
  COLOR_BLUE_70,
  COLOR_BLUE_75,
  COLOR_BLUE_80,
  COLOR_BLUE_85,
  COLOR_BLUE_90,
  COLOR_BLUE_95,
  COLOR_BLUE_OPACITY_5,
  COLOR_BLUE_OPACITY_10,
  COLOR_BLUE_OPACITY_15,
  COLOR_BLUE_OPACITY_20,
  COLOR_BLUE_OPACITY_25,
  COLOR_BLUE_OPACITY_30,
  COLOR_BLUE_OPACITY_35,
  COLOR_BLUE_OPACITY_40,
  COLOR_BLUE_OPACITY_45,
  COLOR_BLUE_OPACITY_50,
  COLOR_BLUE_OPACITY_55,
  COLOR_BLUE_OPACITY_60,
  COLOR_BLUE_OPACITY_65,
  COLOR_BLUE_OPACITY_70,
  COLOR_BLUE_OPACITY_75,
  COLOR_BLUE_OPACITY_80,
  COLOR_BLUE_OPACITY_85,
  COLOR_BLUE_OPACITY_90,
  COLOR_BLUE_OPACITY_95,
  COLOR_DARKBLUE_SHADE_1,
  COLOR_DARKBLUE_SHADE_2,
  COLOR_DARKBLUE_TINT_1,
  COLOR_DARKBLUE_TINT_2,
  COLOR_DARKBLUE_5,
  COLOR_DARKBLUE_10,
  COLOR_DARKBLUE_15,
  COLOR_DARKBLUE_20,
  COLOR_DARKBLUE_25,
  COLOR_DARKBLUE_30,
  COLOR_DARKBLUE_35,
  COLOR_DARKBLUE_40,
  COLOR_DARKBLUE_45,
  COLOR_DARKBLUE_50,
  COLOR_DARKBLUE_55,
  COLOR_DARKBLUE_60,
  COLOR_DARKBLUE_65,
  COLOR_DARKBLUE_70,
  COLOR_DARKBLUE_75,
  COLOR_DARKBLUE_80,
  COLOR_DARKBLUE_85,
  COLOR_DARKBLUE_90,
  COLOR_DARKBLUE_95,
  COLOR_DARKBLUE_OPACITY_5,
  COLOR_DARKBLUE_OPACITY_10,
  COLOR_DARKBLUE_OPACITY_15,
  COLOR_DARKBLUE_OPACITY_20,
  COLOR_DARKBLUE_OPACITY_25,
  COLOR_DARKBLUE_OPACITY_30,
  COLOR_DARKBLUE_OPACITY_35,
  COLOR_DARKBLUE_OPACITY_40,
  COLOR_DARKBLUE_OPACITY_45,
  COLOR_DARKBLUE_OPACITY_50,
  COLOR_DARKBLUE_OPACITY_55,
  COLOR_DARKBLUE_OPACITY_60,
  COLOR_DARKBLUE_OPACITY_65,
  COLOR_DARKBLUE_OPACITY_70,
  COLOR_DARKBLUE_OPACITY_75,
  COLOR_DARKBLUE_OPACITY_80,
  COLOR_DARKBLUE_OPACITY_85,
  COLOR_DARKBLUE_OPACITY_90,
  COLOR_DARKBLUE_OPACITY_95,
  COLOR_BLUE_ACTIVE_SHADE_1,
  COLOR_BLUE_ACTIVE_SHADE_2,
  COLOR_BLUE_ACTIVE_TINT_1,
  COLOR_BLUE_ACTIVE_TINT_2,
  COLOR_BLUE_ACTIVE_5,
  COLOR_BLUE_ACTIVE_10,
  COLOR_BLUE_ACTIVE_15,
  COLOR_BLUE_ACTIVE_20,
  COLOR_BLUE_ACTIVE_25,
  COLOR_BLUE_ACTIVE_30,
  COLOR_BLUE_ACTIVE_35,
  COLOR_BLUE_ACTIVE_40,
  COLOR_BLUE_ACTIVE_45,
  COLOR_BLUE_ACTIVE_50,
  COLOR_BLUE_ACTIVE_55,
  COLOR_BLUE_ACTIVE_60,
  COLOR_BLUE_ACTIVE_65,
  COLOR_BLUE_ACTIVE_70,
  COLOR_BLUE_ACTIVE_75,
  COLOR_BLUE_ACTIVE_80,
  COLOR_BLUE_ACTIVE_85,
  COLOR_BLUE_ACTIVE_90,
  COLOR_BLUE_ACTIVE_95,
  COLOR_BLUE_ACTIVE_OPACITY_5,
  COLOR_BLUE_ACTIVE_OPACITY_10,
  COLOR_BLUE_ACTIVE_OPACITY_15,
  COLOR_BLUE_ACTIVE_OPACITY_20,
  COLOR_BLUE_ACTIVE_OPACITY_25,
  COLOR_BLUE_ACTIVE_OPACITY_30,
  COLOR_BLUE_ACTIVE_OPACITY_35,
  COLOR_BLUE_ACTIVE_OPACITY_40,
  COLOR_BLUE_ACTIVE_OPACITY_45,
  COLOR_BLUE_ACTIVE_OPACITY_50,
  COLOR_BLUE_ACTIVE_OPACITY_55,
  COLOR_BLUE_ACTIVE_OPACITY_60,
  COLOR_BLUE_ACTIVE_OPACITY_65,
  COLOR_BLUE_ACTIVE_OPACITY_70,
  COLOR_BLUE_ACTIVE_OPACITY_75,
  COLOR_BLUE_ACTIVE_OPACITY_80,
  COLOR_BLUE_ACTIVE_OPACITY_85,
  COLOR_BLUE_ACTIVE_OPACITY_90,
  COLOR_BLUE_ACTIVE_OPACITY_95,
  COLOR_GREEN_SHADE_1,
  COLOR_GREEN_SHADE_2,
  COLOR_GREEN_TINT_1,
  COLOR_GREEN_TINT_2,
  COLOR_GREEN_5,
  COLOR_GREEN_10,
  COLOR_GREEN_15,
  COLOR_GREEN_20,
  COLOR_GREEN_25,
  COLOR_GREEN_30,
  COLOR_GREEN_35,
  COLOR_GREEN_40,
  COLOR_GREEN_45,
  COLOR_GREEN_50,
  COLOR_GREEN_55,
  COLOR_GREEN_60,
  COLOR_GREEN_65,
  COLOR_GREEN_70,
  COLOR_GREEN_75,
  COLOR_GREEN_80,
  COLOR_GREEN_85,
  COLOR_GREEN_90,
  COLOR_GREEN_95,
  COLOR_GREEN_OPACITY_5,
  COLOR_GREEN_OPACITY_10,
  COLOR_GREEN_OPACITY_15,
  COLOR_GREEN_OPACITY_20,
  COLOR_GREEN_OPACITY_25,
  COLOR_GREEN_OPACITY_30,
  COLOR_GREEN_OPACITY_35,
  COLOR_GREEN_OPACITY_40,
  COLOR_GREEN_OPACITY_45,
  COLOR_GREEN_OPACITY_50,
  COLOR_GREEN_OPACITY_55,
  COLOR_GREEN_OPACITY_60,
  COLOR_GREEN_OPACITY_65,
  COLOR_GREEN_OPACITY_70,
  COLOR_GREEN_OPACITY_75,
  COLOR_GREEN_OPACITY_80,
  COLOR_GREEN_OPACITY_85,
  COLOR_GREEN_OPACITY_90,
  COLOR_GREEN_OPACITY_95,
  COLOR_ORANGE_SHADE_1,
  COLOR_ORANGE_SHADE_2,
  COLOR_ORANGE_TINT_1,
  COLOR_ORANGE_TINT_2,
  COLOR_ORANGE_5,
  COLOR_ORANGE_10,
  COLOR_ORANGE_15,
  COLOR_ORANGE_20,
  COLOR_ORANGE_25,
  COLOR_ORANGE_30,
  COLOR_ORANGE_35,
  COLOR_ORANGE_40,
  COLOR_ORANGE_45,
  COLOR_ORANGE_50,
  COLOR_ORANGE_55,
  COLOR_ORANGE_60,
  COLOR_ORANGE_65,
  COLOR_ORANGE_70,
  COLOR_ORANGE_75,
  COLOR_ORANGE_80,
  COLOR_ORANGE_85,
  COLOR_ORANGE_90,
  COLOR_ORANGE_95,
  COLOR_ORANGE_OPACITY_5,
  COLOR_ORANGE_OPACITY_10,
  COLOR_ORANGE_OPACITY_15,
  COLOR_ORANGE_OPACITY_20,
  COLOR_ORANGE_OPACITY_25,
  COLOR_ORANGE_OPACITY_30,
  COLOR_ORANGE_OPACITY_35,
  COLOR_ORANGE_OPACITY_40,
  COLOR_ORANGE_OPACITY_45,
  COLOR_ORANGE_OPACITY_50,
  COLOR_ORANGE_OPACITY_55,
  COLOR_ORANGE_OPACITY_60,
  COLOR_ORANGE_OPACITY_65,
  COLOR_ORANGE_OPACITY_70,
  COLOR_ORANGE_OPACITY_75,
  COLOR_ORANGE_OPACITY_80,
  COLOR_ORANGE_OPACITY_85,
  COLOR_ORANGE_OPACITY_90,
  COLOR_ORANGE_OPACITY_95,
  COLOR_ORANGE_ACTIVE_SHADE_1,
  COLOR_ORANGE_ACTIVE_SHADE_2,
  COLOR_ORANGE_ACTIVE_TINT_1,
  COLOR_ORANGE_ACTIVE_TINT_2,
  COLOR_ORANGE_ACTIVE_5,
  COLOR_ORANGE_ACTIVE_10,
  COLOR_ORANGE_ACTIVE_15,
  COLOR_ORANGE_ACTIVE_20,
  COLOR_ORANGE_ACTIVE_25,
  COLOR_ORANGE_ACTIVE_30,
  COLOR_ORANGE_ACTIVE_35,
  COLOR_ORANGE_ACTIVE_40,
  COLOR_ORANGE_ACTIVE_45,
  COLOR_ORANGE_ACTIVE_50,
  COLOR_ORANGE_ACTIVE_55,
  COLOR_ORANGE_ACTIVE_60,
  COLOR_ORANGE_ACTIVE_65,
  COLOR_ORANGE_ACTIVE_70,
  COLOR_ORANGE_ACTIVE_75,
  COLOR_ORANGE_ACTIVE_80,
  COLOR_ORANGE_ACTIVE_85,
  COLOR_ORANGE_ACTIVE_90,
  COLOR_ORANGE_ACTIVE_95,
  COLOR_ORANGE_ACTIVE_OPACITY_5,
  COLOR_ORANGE_ACTIVE_OPACITY_10,
  COLOR_ORANGE_ACTIVE_OPACITY_15,
  COLOR_ORANGE_ACTIVE_OPACITY_20,
  COLOR_ORANGE_ACTIVE_OPACITY_25,
  COLOR_ORANGE_ACTIVE_OPACITY_30,
  COLOR_ORANGE_ACTIVE_OPACITY_35,
  COLOR_ORANGE_ACTIVE_OPACITY_40,
  COLOR_ORANGE_ACTIVE_OPACITY_45,
  COLOR_ORANGE_ACTIVE_OPACITY_50,
  COLOR_ORANGE_ACTIVE_OPACITY_55,
  COLOR_ORANGE_ACTIVE_OPACITY_60,
  COLOR_ORANGE_ACTIVE_OPACITY_65,
  COLOR_ORANGE_ACTIVE_OPACITY_70,
  COLOR_ORANGE_ACTIVE_OPACITY_75,
  COLOR_ORANGE_ACTIVE_OPACITY_80,
  COLOR_ORANGE_ACTIVE_OPACITY_85,
  COLOR_ORANGE_ACTIVE_OPACITY_90,
  COLOR_ORANGE_ACTIVE_OPACITY_95,
  COLOR_TEAL_SHADE_1,
  COLOR_TEAL_SHADE_2,
  COLOR_TEAL_TINT_1,
  COLOR_TEAL_TINT_2,
  COLOR_TEAL_5,
  COLOR_TEAL_10,
  COLOR_TEAL_15,
  COLOR_TEAL_20,
  COLOR_TEAL_25,
  COLOR_TEAL_30,
  COLOR_TEAL_35,
  COLOR_TEAL_40,
  COLOR_TEAL_45,
  COLOR_TEAL_50,
  COLOR_TEAL_55,
  COLOR_TEAL_60,
  COLOR_TEAL_65,
  COLOR_TEAL_70,
  COLOR_TEAL_75,
  COLOR_TEAL_80,
  COLOR_TEAL_85,
  COLOR_TEAL_90,
  COLOR_TEAL_95,
  COLOR_TEAL_OPACITY_5,
  COLOR_TEAL_OPACITY_10,
  COLOR_TEAL_OPACITY_15,
  COLOR_TEAL_OPACITY_20,
  COLOR_TEAL_OPACITY_25,
  COLOR_TEAL_OPACITY_30,
  COLOR_TEAL_OPACITY_35,
  COLOR_TEAL_OPACITY_40,
  COLOR_TEAL_OPACITY_45,
  COLOR_TEAL_OPACITY_50,
  COLOR_TEAL_OPACITY_55,
  COLOR_TEAL_OPACITY_60,
  COLOR_TEAL_OPACITY_65,
  COLOR_TEAL_OPACITY_70,
  COLOR_TEAL_OPACITY_75,
  COLOR_TEAL_OPACITY_80,
  COLOR_TEAL_OPACITY_85,
  COLOR_TEAL_OPACITY_90,
  COLOR_TEAL_OPACITY_95,
  COLOR_TEAL_ACTIVE_SHADE_1,
  COLOR_TEAL_ACTIVE_SHADE_2,
  COLOR_TEAL_ACTIVE_TINT_1,
  COLOR_TEAL_ACTIVE_TINT_2,
  COLOR_TEAL_ACTIVE_5,
  COLOR_TEAL_ACTIVE_10,
  COLOR_TEAL_ACTIVE_15,
  COLOR_TEAL_ACTIVE_20,
  COLOR_TEAL_ACTIVE_25,
  COLOR_TEAL_ACTIVE_30,
  COLOR_TEAL_ACTIVE_35,
  COLOR_TEAL_ACTIVE_40,
  COLOR_TEAL_ACTIVE_45,
  COLOR_TEAL_ACTIVE_50,
  COLOR_TEAL_ACTIVE_55,
  COLOR_TEAL_ACTIVE_60,
  COLOR_TEAL_ACTIVE_65,
  COLOR_TEAL_ACTIVE_70,
  COLOR_TEAL_ACTIVE_75,
  COLOR_TEAL_ACTIVE_80,
  COLOR_TEAL_ACTIVE_85,
  COLOR_TEAL_ACTIVE_90,
  COLOR_TEAL_ACTIVE_95,
  COLOR_TEAL_ACTIVE_OPACITY_5,
  COLOR_TEAL_ACTIVE_OPACITY_10,
  COLOR_TEAL_ACTIVE_OPACITY_15,
  COLOR_TEAL_ACTIVE_OPACITY_20,
  COLOR_TEAL_ACTIVE_OPACITY_25,
  COLOR_TEAL_ACTIVE_OPACITY_30,
  COLOR_TEAL_ACTIVE_OPACITY_35,
  COLOR_TEAL_ACTIVE_OPACITY_40,
  COLOR_TEAL_ACTIVE_OPACITY_45,
  COLOR_TEAL_ACTIVE_OPACITY_50,
  COLOR_TEAL_ACTIVE_OPACITY_55,
  COLOR_TEAL_ACTIVE_OPACITY_60,
  COLOR_TEAL_ACTIVE_OPACITY_65,
  COLOR_TEAL_ACTIVE_OPACITY_70,
  COLOR_TEAL_ACTIVE_OPACITY_75,
  COLOR_TEAL_ACTIVE_OPACITY_80,
  COLOR_TEAL_ACTIVE_OPACITY_85,
  COLOR_TEAL_ACTIVE_OPACITY_90,
  COLOR_TEAL_ACTIVE_OPACITY_95,
  COLOR_TURQUOISE_SHADE_1,
  COLOR_TURQUOISE_SHADE_2,
  COLOR_TURQUOISE_TINT_1,
  COLOR_TURQUOISE_TINT_2,
  COLOR_TURQUOISE_5,
  COLOR_TURQUOISE_10,
  COLOR_TURQUOISE_15,
  COLOR_TURQUOISE_20,
  COLOR_TURQUOISE_25,
  COLOR_TURQUOISE_30,
  COLOR_TURQUOISE_35,
  COLOR_TURQUOISE_40,
  COLOR_TURQUOISE_45,
  COLOR_TURQUOISE_50,
  COLOR_TURQUOISE_55,
  COLOR_TURQUOISE_60,
  COLOR_TURQUOISE_65,
  COLOR_TURQUOISE_70,
  COLOR_TURQUOISE_75,
  COLOR_TURQUOISE_80,
  COLOR_TURQUOISE_85,
  COLOR_TURQUOISE_90,
  COLOR_TURQUOISE_95,
  COLOR_TURQUOISE_OPACITY_5,
  COLOR_TURQUOISE_OPACITY_10,
  COLOR_TURQUOISE_OPACITY_15,
  COLOR_TURQUOISE_OPACITY_20,
  COLOR_TURQUOISE_OPACITY_25,
  COLOR_TURQUOISE_OPACITY_30,
  COLOR_TURQUOISE_OPACITY_35,
  COLOR_TURQUOISE_OPACITY_40,
  COLOR_TURQUOISE_OPACITY_45,
  COLOR_TURQUOISE_OPACITY_50,
  COLOR_TURQUOISE_OPACITY_55,
  COLOR_TURQUOISE_OPACITY_60,
  COLOR_TURQUOISE_OPACITY_65,
  COLOR_TURQUOISE_OPACITY_70,
  COLOR_TURQUOISE_OPACITY_75,
  COLOR_TURQUOISE_OPACITY_80,
  COLOR_TURQUOISE_OPACITY_85,
  COLOR_TURQUOISE_OPACITY_90,
  COLOR_TURQUOISE_OPACITY_95,
  COLOR_TURQUOISE_ACTIVE_SHADE_1,
  COLOR_TURQUOISE_ACTIVE_SHADE_2,
  COLOR_TURQUOISE_ACTIVE_TINT_1,
  COLOR_TURQUOISE_ACTIVE_TINT_2,
  COLOR_TURQUOISE_ACTIVE_5,
  COLOR_TURQUOISE_ACTIVE_10,
  COLOR_TURQUOISE_ACTIVE_15,
  COLOR_TURQUOISE_ACTIVE_20,
  COLOR_TURQUOISE_ACTIVE_25,
  COLOR_TURQUOISE_ACTIVE_30,
  COLOR_TURQUOISE_ACTIVE_35,
  COLOR_TURQUOISE_ACTIVE_40,
  COLOR_TURQUOISE_ACTIVE_45,
  COLOR_TURQUOISE_ACTIVE_50,
  COLOR_TURQUOISE_ACTIVE_55,
  COLOR_TURQUOISE_ACTIVE_60,
  COLOR_TURQUOISE_ACTIVE_65,
  COLOR_TURQUOISE_ACTIVE_70,
  COLOR_TURQUOISE_ACTIVE_75,
  COLOR_TURQUOISE_ACTIVE_80,
  COLOR_TURQUOISE_ACTIVE_85,
  COLOR_TURQUOISE_ACTIVE_90,
  COLOR_TURQUOISE_ACTIVE_95,
  COLOR_TURQUOISE_ACTIVE_OPACITY_5,
  COLOR_TURQUOISE_ACTIVE_OPACITY_10,
  COLOR_TURQUOISE_ACTIVE_OPACITY_15,
  COLOR_TURQUOISE_ACTIVE_OPACITY_20,
  COLOR_TURQUOISE_ACTIVE_OPACITY_25,
  COLOR_TURQUOISE_ACTIVE_OPACITY_30,
  COLOR_TURQUOISE_ACTIVE_OPACITY_35,
  COLOR_TURQUOISE_ACTIVE_OPACITY_40,
  COLOR_TURQUOISE_ACTIVE_OPACITY_45,
  COLOR_TURQUOISE_ACTIVE_OPACITY_50,
  COLOR_TURQUOISE_ACTIVE_OPACITY_55,
  COLOR_TURQUOISE_ACTIVE_OPACITY_60,
  COLOR_TURQUOISE_ACTIVE_OPACITY_65,
  COLOR_TURQUOISE_ACTIVE_OPACITY_70,
  COLOR_TURQUOISE_ACTIVE_OPACITY_75,
  COLOR_TURQUOISE_ACTIVE_OPACITY_80,
  COLOR_TURQUOISE_ACTIVE_OPACITY_85,
  COLOR_TURQUOISE_ACTIVE_OPACITY_90,
  COLOR_TURQUOISE_ACTIVE_OPACITY_95,
  COLOR_LIGHTTEAL_SHADE_1,
  COLOR_LIGHTTEAL_SHADE_2,
  COLOR_LIGHTTEAL_TINT_1,
  COLOR_LIGHTTEAL_TINT_2,
  COLOR_LIGHTTEAL_5,
  COLOR_LIGHTTEAL_10,
  COLOR_LIGHTTEAL_15,
  COLOR_LIGHTTEAL_20,
  COLOR_LIGHTTEAL_25,
  COLOR_LIGHTTEAL_30,
  COLOR_LIGHTTEAL_35,
  COLOR_LIGHTTEAL_40,
  COLOR_LIGHTTEAL_45,
  COLOR_LIGHTTEAL_50,
  COLOR_LIGHTTEAL_55,
  COLOR_LIGHTTEAL_60,
  COLOR_LIGHTTEAL_65,
  COLOR_LIGHTTEAL_70,
  COLOR_LIGHTTEAL_75,
  COLOR_LIGHTTEAL_80,
  COLOR_LIGHTTEAL_85,
  COLOR_LIGHTTEAL_90,
  COLOR_LIGHTTEAL_95,
  COLOR_LIGHTTEAL_OPACITY_5,
  COLOR_LIGHTTEAL_OPACITY_10,
  COLOR_LIGHTTEAL_OPACITY_15,
  COLOR_LIGHTTEAL_OPACITY_20,
  COLOR_LIGHTTEAL_OPACITY_25,
  COLOR_LIGHTTEAL_OPACITY_30,
  COLOR_LIGHTTEAL_OPACITY_35,
  COLOR_LIGHTTEAL_OPACITY_40,
  COLOR_LIGHTTEAL_OPACITY_45,
  COLOR_LIGHTTEAL_OPACITY_50,
  COLOR_LIGHTTEAL_OPACITY_55,
  COLOR_LIGHTTEAL_OPACITY_60,
  COLOR_LIGHTTEAL_OPACITY_65,
  COLOR_LIGHTTEAL_OPACITY_70,
  COLOR_LIGHTTEAL_OPACITY_75,
  COLOR_LIGHTTEAL_OPACITY_80,
  COLOR_LIGHTTEAL_OPACITY_85,
  COLOR_LIGHTTEAL_OPACITY_90,
  COLOR_LIGHTTEAL_OPACITY_95,
  COLOR_MIDDLETEAL_SHADE_1,
  COLOR_MIDDLETEAL_SHADE_2,
  COLOR_MIDDLETEAL_TINT_1,
  COLOR_MIDDLETEAL_TINT_2,
  COLOR_MIDDLETEAL_5,
  COLOR_MIDDLETEAL_10,
  COLOR_MIDDLETEAL_15,
  COLOR_MIDDLETEAL_20,
  COLOR_MIDDLETEAL_25,
  COLOR_MIDDLETEAL_30,
  COLOR_MIDDLETEAL_35,
  COLOR_MIDDLETEAL_40,
  COLOR_MIDDLETEAL_45,
  COLOR_MIDDLETEAL_50,
  COLOR_MIDDLETEAL_55,
  COLOR_MIDDLETEAL_60,
  COLOR_MIDDLETEAL_65,
  COLOR_MIDDLETEAL_70,
  COLOR_MIDDLETEAL_75,
  COLOR_MIDDLETEAL_80,
  COLOR_MIDDLETEAL_85,
  COLOR_MIDDLETEAL_90,
  COLOR_MIDDLETEAL_95,
  COLOR_MIDDLETEAL_OPACITY_5,
  COLOR_MIDDLETEAL_OPACITY_10,
  COLOR_MIDDLETEAL_OPACITY_15,
  COLOR_MIDDLETEAL_OPACITY_20,
  COLOR_MIDDLETEAL_OPACITY_25,
  COLOR_MIDDLETEAL_OPACITY_30,
  COLOR_MIDDLETEAL_OPACITY_35,
  COLOR_MIDDLETEAL_OPACITY_40,
  COLOR_MIDDLETEAL_OPACITY_45,
  COLOR_MIDDLETEAL_OPACITY_50,
  COLOR_MIDDLETEAL_OPACITY_55,
  COLOR_MIDDLETEAL_OPACITY_60,
  COLOR_MIDDLETEAL_OPACITY_65,
  COLOR_MIDDLETEAL_OPACITY_70,
  COLOR_MIDDLETEAL_OPACITY_75,
  COLOR_MIDDLETEAL_OPACITY_80,
  COLOR_MIDDLETEAL_OPACITY_85,
  COLOR_MIDDLETEAL_OPACITY_90,
  COLOR_MIDDLETEAL_OPACITY_95,
  COLOR_LIGHTBLUE_SHADE_1,
  COLOR_LIGHTBLUE_SHADE_2,
  COLOR_LIGHTBLUE_TINT_1,
  COLOR_LIGHTBLUE_TINT_2,
  COLOR_LIGHTBLUE_5,
  COLOR_LIGHTBLUE_10,
  COLOR_LIGHTBLUE_15,
  COLOR_LIGHTBLUE_20,
  COLOR_LIGHTBLUE_25,
  COLOR_LIGHTBLUE_30,
  COLOR_LIGHTBLUE_35,
  COLOR_LIGHTBLUE_40,
  COLOR_LIGHTBLUE_45,
  COLOR_LIGHTBLUE_50,
  COLOR_LIGHTBLUE_55,
  COLOR_LIGHTBLUE_60,
  COLOR_LIGHTBLUE_65,
  COLOR_LIGHTBLUE_70,
  COLOR_LIGHTBLUE_75,
  COLOR_LIGHTBLUE_80,
  COLOR_LIGHTBLUE_85,
  COLOR_LIGHTBLUE_90,
  COLOR_LIGHTBLUE_95,
  COLOR_LIGHTBLUE_OPACITY_5,
  COLOR_LIGHTBLUE_OPACITY_10,
  COLOR_LIGHTBLUE_OPACITY_15,
  COLOR_LIGHTBLUE_OPACITY_20,
  COLOR_LIGHTBLUE_OPACITY_25,
  COLOR_LIGHTBLUE_OPACITY_30,
  COLOR_LIGHTBLUE_OPACITY_35,
  COLOR_LIGHTBLUE_OPACITY_40,
  COLOR_LIGHTBLUE_OPACITY_45,
  COLOR_LIGHTBLUE_OPACITY_50,
  COLOR_LIGHTBLUE_OPACITY_55,
  COLOR_LIGHTBLUE_OPACITY_60,
  COLOR_LIGHTBLUE_OPACITY_65,
  COLOR_LIGHTBLUE_OPACITY_70,
  COLOR_LIGHTBLUE_OPACITY_75,
  COLOR_LIGHTBLUE_OPACITY_80,
  COLOR_LIGHTBLUE_OPACITY_85,
  COLOR_LIGHTBLUE_OPACITY_90,
  COLOR_LIGHTBLUE_OPACITY_95,
  COLOR_MIDDLEBLUE_SHADE_1,
  COLOR_MIDDLEBLUE_SHADE_2,
  COLOR_MIDDLEBLUE_TINT_1,
  COLOR_MIDDLEBLUE_TINT_2,
  COLOR_MIDDLEBLUE_5,
  COLOR_MIDDLEBLUE_10,
  COLOR_MIDDLEBLUE_15,
  COLOR_MIDDLEBLUE_20,
  COLOR_MIDDLEBLUE_25,
  COLOR_MIDDLEBLUE_30,
  COLOR_MIDDLEBLUE_35,
  COLOR_MIDDLEBLUE_40,
  COLOR_MIDDLEBLUE_45,
  COLOR_MIDDLEBLUE_50,
  COLOR_MIDDLEBLUE_55,
  COLOR_MIDDLEBLUE_60,
  COLOR_MIDDLEBLUE_65,
  COLOR_MIDDLEBLUE_70,
  COLOR_MIDDLEBLUE_75,
  COLOR_MIDDLEBLUE_80,
  COLOR_MIDDLEBLUE_85,
  COLOR_MIDDLEBLUE_90,
  COLOR_MIDDLEBLUE_95,
  COLOR_MIDDLEBLUE_OPACITY_5,
  COLOR_MIDDLEBLUE_OPACITY_10,
  COLOR_MIDDLEBLUE_OPACITY_15,
  COLOR_MIDDLEBLUE_OPACITY_20,
  COLOR_MIDDLEBLUE_OPACITY_25,
  COLOR_MIDDLEBLUE_OPACITY_30,
  COLOR_MIDDLEBLUE_OPACITY_35,
  COLOR_MIDDLEBLUE_OPACITY_40,
  COLOR_MIDDLEBLUE_OPACITY_45,
  COLOR_MIDDLEBLUE_OPACITY_50,
  COLOR_MIDDLEBLUE_OPACITY_55,
  COLOR_MIDDLEBLUE_OPACITY_60,
  COLOR_MIDDLEBLUE_OPACITY_65,
  COLOR_MIDDLEBLUE_OPACITY_70,
  COLOR_MIDDLEBLUE_OPACITY_75,
  COLOR_MIDDLEBLUE_OPACITY_80,
  COLOR_MIDDLEBLUE_OPACITY_85,
  COLOR_MIDDLEBLUE_OPACITY_90,
  COLOR_MIDDLEBLUE_OPACITY_95,
  COLOR_BLUE_BORDER_SHADE_1,
  COLOR_BLUE_BORDER_SHADE_2,
  COLOR_BLUE_BORDER_TINT_1,
  COLOR_BLUE_BORDER_TINT_2,
  COLOR_BLUE_BORDER_5,
  COLOR_BLUE_BORDER_10,
  COLOR_BLUE_BORDER_15,
  COLOR_BLUE_BORDER_20,
  COLOR_BLUE_BORDER_25,
  COLOR_BLUE_BORDER_30,
  COLOR_BLUE_BORDER_35,
  COLOR_BLUE_BORDER_40,
  COLOR_BLUE_BORDER_45,
  COLOR_BLUE_BORDER_50,
  COLOR_BLUE_BORDER_55,
  COLOR_BLUE_BORDER_60,
  COLOR_BLUE_BORDER_65,
  COLOR_BLUE_BORDER_70,
  COLOR_BLUE_BORDER_75,
  COLOR_BLUE_BORDER_80,
  COLOR_BLUE_BORDER_85,
  COLOR_BLUE_BORDER_90,
  COLOR_BLUE_BORDER_95,
  COLOR_BLUE_BORDER_OPACITY_5,
  COLOR_BLUE_BORDER_OPACITY_10,
  COLOR_BLUE_BORDER_OPACITY_15,
  COLOR_BLUE_BORDER_OPACITY_20,
  COLOR_BLUE_BORDER_OPACITY_25,
  COLOR_BLUE_BORDER_OPACITY_30,
  COLOR_BLUE_BORDER_OPACITY_35,
  COLOR_BLUE_BORDER_OPACITY_40,
  COLOR_BLUE_BORDER_OPACITY_45,
  COLOR_BLUE_BORDER_OPACITY_50,
  COLOR_BLUE_BORDER_OPACITY_55,
  COLOR_BLUE_BORDER_OPACITY_60,
  COLOR_BLUE_BORDER_OPACITY_65,
  COLOR_BLUE_BORDER_OPACITY_70,
  COLOR_BLUE_BORDER_OPACITY_75,
  COLOR_BLUE_BORDER_OPACITY_80,
  COLOR_BLUE_BORDER_OPACITY_85,
  COLOR_BLUE_BORDER_OPACITY_90,
  COLOR_BLUE_BORDER_OPACITY_95,
  COLOR_RED_SHADE_1,
  COLOR_RED_SHADE_2,
  COLOR_RED_TINT_1,
  COLOR_RED_TINT_2,
  COLOR_RED_5,
  COLOR_RED_10,
  COLOR_RED_15,
  COLOR_RED_20,
  COLOR_RED_25,
  COLOR_RED_30,
  COLOR_RED_35,
  COLOR_RED_40,
  COLOR_RED_45,
  COLOR_RED_50,
  COLOR_RED_55,
  COLOR_RED_60,
  COLOR_RED_65,
  COLOR_RED_70,
  COLOR_RED_75,
  COLOR_RED_80,
  COLOR_RED_85,
  COLOR_RED_90,
  COLOR_RED_95,
  COLOR_RED_OPACITY_5,
  COLOR_RED_OPACITY_10,
  COLOR_RED_OPACITY_15,
  COLOR_RED_OPACITY_20,
  COLOR_RED_OPACITY_25,
  COLOR_RED_OPACITY_30,
  COLOR_RED_OPACITY_35,
  COLOR_RED_OPACITY_40,
  COLOR_RED_OPACITY_45,
  COLOR_RED_OPACITY_50,
  COLOR_RED_OPACITY_55,
  COLOR_RED_OPACITY_60,
  COLOR_RED_OPACITY_65,
  COLOR_RED_OPACITY_70,
  COLOR_RED_OPACITY_75,
  COLOR_RED_OPACITY_80,
  COLOR_RED_OPACITY_85,
  COLOR_RED_OPACITY_90,
  COLOR_RED_OPACITY_95,
  COLOR_YELLOW_SHADE_1,
  COLOR_YELLOW_SHADE_2,
  COLOR_YELLOW_TINT_1,
  COLOR_YELLOW_TINT_2,
  COLOR_YELLOW_5,
  COLOR_YELLOW_10,
  COLOR_YELLOW_15,
  COLOR_YELLOW_20,
  COLOR_YELLOW_25,
  COLOR_YELLOW_30,
  COLOR_YELLOW_35,
  COLOR_YELLOW_40,
  COLOR_YELLOW_45,
  COLOR_YELLOW_50,
  COLOR_YELLOW_55,
  COLOR_YELLOW_60,
  COLOR_YELLOW_65,
  COLOR_YELLOW_70,
  COLOR_YELLOW_75,
  COLOR_YELLOW_80,
  COLOR_YELLOW_85,
  COLOR_YELLOW_90,
  COLOR_YELLOW_95,
  COLOR_YELLOW_OPACITY_5,
  COLOR_YELLOW_OPACITY_10,
  COLOR_YELLOW_OPACITY_15,
  COLOR_YELLOW_OPACITY_20,
  COLOR_YELLOW_OPACITY_25,
  COLOR_YELLOW_OPACITY_30,
  COLOR_YELLOW_OPACITY_35,
  COLOR_YELLOW_OPACITY_40,
  COLOR_YELLOW_OPACITY_45,
  COLOR_YELLOW_OPACITY_50,
  COLOR_YELLOW_OPACITY_55,
  COLOR_YELLOW_OPACITY_60,
  COLOR_YELLOW_OPACITY_65,
  COLOR_YELLOW_OPACITY_70,
  COLOR_YELLOW_OPACITY_75,
  COLOR_YELLOW_OPACITY_80,
  COLOR_YELLOW_OPACITY_85,
  COLOR_YELLOW_OPACITY_90,
  COLOR_YELLOW_OPACITY_95,
  COLOR_LIGHTTURQUOISE_SHADE_1,
  COLOR_LIGHTTURQUOISE_SHADE_2,
  COLOR_LIGHTTURQUOISE_TINT_1,
  COLOR_LIGHTTURQUOISE_TINT_2,
  COLOR_LIGHTTURQUOISE_5,
  COLOR_LIGHTTURQUOISE_10,
  COLOR_LIGHTTURQUOISE_15,
  COLOR_LIGHTTURQUOISE_20,
  COLOR_LIGHTTURQUOISE_25,
  COLOR_LIGHTTURQUOISE_30,
  COLOR_LIGHTTURQUOISE_35,
  COLOR_LIGHTTURQUOISE_40,
  COLOR_LIGHTTURQUOISE_45,
  COLOR_LIGHTTURQUOISE_50,
  COLOR_LIGHTTURQUOISE_55,
  COLOR_LIGHTTURQUOISE_60,
  COLOR_LIGHTTURQUOISE_65,
  COLOR_LIGHTTURQUOISE_70,
  COLOR_LIGHTTURQUOISE_75,
  COLOR_LIGHTTURQUOISE_80,
  COLOR_LIGHTTURQUOISE_85,
  COLOR_LIGHTTURQUOISE_90,
  COLOR_LIGHTTURQUOISE_95,
  COLOR_LIGHTTURQUOISE_OPACITY_5,
  COLOR_LIGHTTURQUOISE_OPACITY_10,
  COLOR_LIGHTTURQUOISE_OPACITY_15,
  COLOR_LIGHTTURQUOISE_OPACITY_20,
  COLOR_LIGHTTURQUOISE_OPACITY_25,
  COLOR_LIGHTTURQUOISE_OPACITY_30,
  COLOR_LIGHTTURQUOISE_OPACITY_35,
  COLOR_LIGHTTURQUOISE_OPACITY_40,
  COLOR_LIGHTTURQUOISE_OPACITY_45,
  COLOR_LIGHTTURQUOISE_OPACITY_50,
  COLOR_LIGHTTURQUOISE_OPACITY_55,
  COLOR_LIGHTTURQUOISE_OPACITY_60,
  COLOR_LIGHTTURQUOISE_OPACITY_65,
  COLOR_LIGHTTURQUOISE_OPACITY_70,
  COLOR_LIGHTTURQUOISE_OPACITY_75,
  COLOR_LIGHTTURQUOISE_OPACITY_80,
  COLOR_LIGHTTURQUOISE_OPACITY_85,
  COLOR_LIGHTTURQUOISE_OPACITY_90,
  COLOR_LIGHTTURQUOISE_OPACITY_95,
  COLOR_MIDDLETURQUOISE_SHADE_1,
  COLOR_MIDDLETURQUOISE_SHADE_2,
  COLOR_MIDDLETURQUOISE_TINT_1,
  COLOR_MIDDLETURQUOISE_TINT_2,
  COLOR_MIDDLETURQUOISE_5,
  COLOR_MIDDLETURQUOISE_10,
  COLOR_MIDDLETURQUOISE_15,
  COLOR_MIDDLETURQUOISE_20,
  COLOR_MIDDLETURQUOISE_25,
  COLOR_MIDDLETURQUOISE_30,
  COLOR_MIDDLETURQUOISE_35,
  COLOR_MIDDLETURQUOISE_40,
  COLOR_MIDDLETURQUOISE_45,
  COLOR_MIDDLETURQUOISE_50,
  COLOR_MIDDLETURQUOISE_55,
  COLOR_MIDDLETURQUOISE_60,
  COLOR_MIDDLETURQUOISE_65,
  COLOR_MIDDLETURQUOISE_70,
  COLOR_MIDDLETURQUOISE_75,
  COLOR_MIDDLETURQUOISE_80,
  COLOR_MIDDLETURQUOISE_85,
  COLOR_MIDDLETURQUOISE_90,
  COLOR_MIDDLETURQUOISE_95,
  COLOR_MIDDLETURQUOISE_OPACITY_5,
  COLOR_MIDDLETURQUOISE_OPACITY_10,
  COLOR_MIDDLETURQUOISE_OPACITY_15,
  COLOR_MIDDLETURQUOISE_OPACITY_20,
  COLOR_MIDDLETURQUOISE_OPACITY_25,
  COLOR_MIDDLETURQUOISE_OPACITY_30,
  COLOR_MIDDLETURQUOISE_OPACITY_35,
  COLOR_MIDDLETURQUOISE_OPACITY_40,
  COLOR_MIDDLETURQUOISE_OPACITY_45,
  COLOR_MIDDLETURQUOISE_OPACITY_50,
  COLOR_MIDDLETURQUOISE_OPACITY_55,
  COLOR_MIDDLETURQUOISE_OPACITY_60,
  COLOR_MIDDLETURQUOISE_OPACITY_65,
  COLOR_MIDDLETURQUOISE_OPACITY_70,
  COLOR_MIDDLETURQUOISE_OPACITY_75,
  COLOR_MIDDLETURQUOISE_OPACITY_80,
  COLOR_MIDDLETURQUOISE_OPACITY_85,
  COLOR_MIDDLETURQUOISE_OPACITY_90,
  COLOR_MIDDLETURQUOISE_OPACITY_95,
  COLOR_GREEN_BORDER_SHADE_1,
  COLOR_GREEN_BORDER_SHADE_2,
  COLOR_GREEN_BORDER_TINT_1,
  COLOR_GREEN_BORDER_TINT_2,
  COLOR_GREEN_BORDER_5,
  COLOR_GREEN_BORDER_10,
  COLOR_GREEN_BORDER_15,
  COLOR_GREEN_BORDER_20,
  COLOR_GREEN_BORDER_25,
  COLOR_GREEN_BORDER_30,
  COLOR_GREEN_BORDER_35,
  COLOR_GREEN_BORDER_40,
  COLOR_GREEN_BORDER_45,
  COLOR_GREEN_BORDER_50,
  COLOR_GREEN_BORDER_55,
  COLOR_GREEN_BORDER_60,
  COLOR_GREEN_BORDER_65,
  COLOR_GREEN_BORDER_70,
  COLOR_GREEN_BORDER_75,
  COLOR_GREEN_BORDER_80,
  COLOR_GREEN_BORDER_85,
  COLOR_GREEN_BORDER_90,
  COLOR_GREEN_BORDER_95,
  COLOR_GREEN_BORDER_OPACITY_5,
  COLOR_GREEN_BORDER_OPACITY_10,
  COLOR_GREEN_BORDER_OPACITY_15,
  COLOR_GREEN_BORDER_OPACITY_20,
  COLOR_GREEN_BORDER_OPACITY_25,
  COLOR_GREEN_BORDER_OPACITY_30,
  COLOR_GREEN_BORDER_OPACITY_35,
  COLOR_GREEN_BORDER_OPACITY_40,
  COLOR_GREEN_BORDER_OPACITY_45,
  COLOR_GREEN_BORDER_OPACITY_50,
  COLOR_GREEN_BORDER_OPACITY_55,
  COLOR_GREEN_BORDER_OPACITY_60,
  COLOR_GREEN_BORDER_OPACITY_65,
  COLOR_GREEN_BORDER_OPACITY_70,
  COLOR_GREEN_BORDER_OPACITY_75,
  COLOR_GREEN_BORDER_OPACITY_80,
  COLOR_GREEN_BORDER_OPACITY_85,
  COLOR_GREEN_BORDER_OPACITY_90,
  COLOR_GREEN_BORDER_OPACITY_95,
  COLOR_GREEN_ACTIVE_SHADE_1,
  COLOR_GREEN_ACTIVE_SHADE_2,
  COLOR_GREEN_ACTIVE_TINT_1,
  COLOR_GREEN_ACTIVE_TINT_2,
  COLOR_GREEN_ACTIVE_5,
  COLOR_GREEN_ACTIVE_10,
  COLOR_GREEN_ACTIVE_15,
  COLOR_GREEN_ACTIVE_20,
  COLOR_GREEN_ACTIVE_25,
  COLOR_GREEN_ACTIVE_30,
  COLOR_GREEN_ACTIVE_35,
  COLOR_GREEN_ACTIVE_40,
  COLOR_GREEN_ACTIVE_45,
  COLOR_GREEN_ACTIVE_50,
  COLOR_GREEN_ACTIVE_55,
  COLOR_GREEN_ACTIVE_60,
  COLOR_GREEN_ACTIVE_65,
  COLOR_GREEN_ACTIVE_70,
  COLOR_GREEN_ACTIVE_75,
  COLOR_GREEN_ACTIVE_80,
  COLOR_GREEN_ACTIVE_85,
  COLOR_GREEN_ACTIVE_90,
  COLOR_GREEN_ACTIVE_95,
  COLOR_GREEN_ACTIVE_OPACITY_5,
  COLOR_GREEN_ACTIVE_OPACITY_10,
  COLOR_GREEN_ACTIVE_OPACITY_15,
  COLOR_GREEN_ACTIVE_OPACITY_20,
  COLOR_GREEN_ACTIVE_OPACITY_25,
  COLOR_GREEN_ACTIVE_OPACITY_30,
  COLOR_GREEN_ACTIVE_OPACITY_35,
  COLOR_GREEN_ACTIVE_OPACITY_40,
  COLOR_GREEN_ACTIVE_OPACITY_45,
  COLOR_GREEN_ACTIVE_OPACITY_50,
  COLOR_GREEN_ACTIVE_OPACITY_55,
  COLOR_GREEN_ACTIVE_OPACITY_60,
  COLOR_GREEN_ACTIVE_OPACITY_65,
  COLOR_GREEN_ACTIVE_OPACITY_70,
  COLOR_GREEN_ACTIVE_OPACITY_75,
  COLOR_GREEN_ACTIVE_OPACITY_80,
  COLOR_GREEN_ACTIVE_OPACITY_85,
  COLOR_GREEN_ACTIVE_OPACITY_90,
  COLOR_GREEN_ACTIVE_OPACITY_95,
  COLOR_LIGHTGREEN_SHADE_1,
  COLOR_LIGHTGREEN_SHADE_2,
  COLOR_LIGHTGREEN_TINT_1,
  COLOR_LIGHTGREEN_TINT_2,
  COLOR_LIGHTGREEN_5,
  COLOR_LIGHTGREEN_10,
  COLOR_LIGHTGREEN_15,
  COLOR_LIGHTGREEN_20,
  COLOR_LIGHTGREEN_25,
  COLOR_LIGHTGREEN_30,
  COLOR_LIGHTGREEN_35,
  COLOR_LIGHTGREEN_40,
  COLOR_LIGHTGREEN_45,
  COLOR_LIGHTGREEN_50,
  COLOR_LIGHTGREEN_55,
  COLOR_LIGHTGREEN_60,
  COLOR_LIGHTGREEN_65,
  COLOR_LIGHTGREEN_70,
  COLOR_LIGHTGREEN_75,
  COLOR_LIGHTGREEN_80,
  COLOR_LIGHTGREEN_85,
  COLOR_LIGHTGREEN_90,
  COLOR_LIGHTGREEN_95,
  COLOR_LIGHTGREEN_OPACITY_5,
  COLOR_LIGHTGREEN_OPACITY_10,
  COLOR_LIGHTGREEN_OPACITY_15,
  COLOR_LIGHTGREEN_OPACITY_20,
  COLOR_LIGHTGREEN_OPACITY_25,
  COLOR_LIGHTGREEN_OPACITY_30,
  COLOR_LIGHTGREEN_OPACITY_35,
  COLOR_LIGHTGREEN_OPACITY_40,
  COLOR_LIGHTGREEN_OPACITY_45,
  COLOR_LIGHTGREEN_OPACITY_50,
  COLOR_LIGHTGREEN_OPACITY_55,
  COLOR_LIGHTGREEN_OPACITY_60,
  COLOR_LIGHTGREEN_OPACITY_65,
  COLOR_LIGHTGREEN_OPACITY_70,
  COLOR_LIGHTGREEN_OPACITY_75,
  COLOR_LIGHTGREEN_OPACITY_80,
  COLOR_LIGHTGREEN_OPACITY_85,
  COLOR_LIGHTGREEN_OPACITY_90,
  COLOR_LIGHTGREEN_OPACITY_95,
  COLOR_MIDDLEGREEN_SHADE_1,
  COLOR_MIDDLEGREEN_SHADE_2,
  COLOR_MIDDLEGREEN_TINT_1,
  COLOR_MIDDLEGREEN_TINT_2,
  COLOR_MIDDLEGREEN_5,
  COLOR_MIDDLEGREEN_10,
  COLOR_MIDDLEGREEN_15,
  COLOR_MIDDLEGREEN_20,
  COLOR_MIDDLEGREEN_25,
  COLOR_MIDDLEGREEN_30,
  COLOR_MIDDLEGREEN_35,
  COLOR_MIDDLEGREEN_40,
  COLOR_MIDDLEGREEN_45,
  COLOR_MIDDLEGREEN_50,
  COLOR_MIDDLEGREEN_55,
  COLOR_MIDDLEGREEN_60,
  COLOR_MIDDLEGREEN_65,
  COLOR_MIDDLEGREEN_70,
  COLOR_MIDDLEGREEN_75,
  COLOR_MIDDLEGREEN_80,
  COLOR_MIDDLEGREEN_85,
  COLOR_MIDDLEGREEN_90,
  COLOR_MIDDLEGREEN_95,
  COLOR_MIDDLEGREEN_OPACITY_5,
  COLOR_MIDDLEGREEN_OPACITY_10,
  COLOR_MIDDLEGREEN_OPACITY_15,
  COLOR_MIDDLEGREEN_OPACITY_20,
  COLOR_MIDDLEGREEN_OPACITY_25,
  COLOR_MIDDLEGREEN_OPACITY_30,
  COLOR_MIDDLEGREEN_OPACITY_35,
  COLOR_MIDDLEGREEN_OPACITY_40,
  COLOR_MIDDLEGREEN_OPACITY_45,
  COLOR_MIDDLEGREEN_OPACITY_50,
  COLOR_MIDDLEGREEN_OPACITY_55,
  COLOR_MIDDLEGREEN_OPACITY_60,
  COLOR_MIDDLEGREEN_OPACITY_65,
  COLOR_MIDDLEGREEN_OPACITY_70,
  COLOR_MIDDLEGREEN_OPACITY_75,
  COLOR_MIDDLEGREEN_OPACITY_80,
  COLOR_MIDDLEGREEN_OPACITY_85,
  COLOR_MIDDLEGREEN_OPACITY_90,
  COLOR_MIDDLEGREEN_OPACITY_95,
  COLOR_LIGHTORANGE_SHADE_1,
  COLOR_LIGHTORANGE_SHADE_2,
  COLOR_LIGHTORANGE_TINT_1,
  COLOR_LIGHTORANGE_TINT_2,
  COLOR_LIGHTORANGE_5,
  COLOR_LIGHTORANGE_10,
  COLOR_LIGHTORANGE_15,
  COLOR_LIGHTORANGE_20,
  COLOR_LIGHTORANGE_25,
  COLOR_LIGHTORANGE_30,
  COLOR_LIGHTORANGE_35,
  COLOR_LIGHTORANGE_40,
  COLOR_LIGHTORANGE_45,
  COLOR_LIGHTORANGE_50,
  COLOR_LIGHTORANGE_55,
  COLOR_LIGHTORANGE_60,
  COLOR_LIGHTORANGE_65,
  COLOR_LIGHTORANGE_70,
  COLOR_LIGHTORANGE_75,
  COLOR_LIGHTORANGE_80,
  COLOR_LIGHTORANGE_85,
  COLOR_LIGHTORANGE_90,
  COLOR_LIGHTORANGE_95,
  COLOR_LIGHTORANGE_OPACITY_5,
  COLOR_LIGHTORANGE_OPACITY_10,
  COLOR_LIGHTORANGE_OPACITY_15,
  COLOR_LIGHTORANGE_OPACITY_20,
  COLOR_LIGHTORANGE_OPACITY_25,
  COLOR_LIGHTORANGE_OPACITY_30,
  COLOR_LIGHTORANGE_OPACITY_35,
  COLOR_LIGHTORANGE_OPACITY_40,
  COLOR_LIGHTORANGE_OPACITY_45,
  COLOR_LIGHTORANGE_OPACITY_50,
  COLOR_LIGHTORANGE_OPACITY_55,
  COLOR_LIGHTORANGE_OPACITY_60,
  COLOR_LIGHTORANGE_OPACITY_65,
  COLOR_LIGHTORANGE_OPACITY_70,
  COLOR_LIGHTORANGE_OPACITY_75,
  COLOR_LIGHTORANGE_OPACITY_80,
  COLOR_LIGHTORANGE_OPACITY_85,
  COLOR_LIGHTORANGE_OPACITY_90,
  COLOR_LIGHTORANGE_OPACITY_95,
  COLOR_MIDDLEORANGE_SHADE_1,
  COLOR_MIDDLEORANGE_SHADE_2,
  COLOR_MIDDLEORANGE_TINT_1,
  COLOR_MIDDLEORANGE_TINT_2,
  COLOR_MIDDLEORANGE_5,
  COLOR_MIDDLEORANGE_10,
  COLOR_MIDDLEORANGE_15,
  COLOR_MIDDLEORANGE_20,
  COLOR_MIDDLEORANGE_25,
  COLOR_MIDDLEORANGE_30,
  COLOR_MIDDLEORANGE_35,
  COLOR_MIDDLEORANGE_40,
  COLOR_MIDDLEORANGE_45,
  COLOR_MIDDLEORANGE_50,
  COLOR_MIDDLEORANGE_55,
  COLOR_MIDDLEORANGE_60,
  COLOR_MIDDLEORANGE_65,
  COLOR_MIDDLEORANGE_70,
  COLOR_MIDDLEORANGE_75,
  COLOR_MIDDLEORANGE_80,
  COLOR_MIDDLEORANGE_85,
  COLOR_MIDDLEORANGE_90,
  COLOR_MIDDLEORANGE_95,
  COLOR_MIDDLEORANGE_OPACITY_5,
  COLOR_MIDDLEORANGE_OPACITY_10,
  COLOR_MIDDLEORANGE_OPACITY_15,
  COLOR_MIDDLEORANGE_OPACITY_20,
  COLOR_MIDDLEORANGE_OPACITY_25,
  COLOR_MIDDLEORANGE_OPACITY_30,
  COLOR_MIDDLEORANGE_OPACITY_35,
  COLOR_MIDDLEORANGE_OPACITY_40,
  COLOR_MIDDLEORANGE_OPACITY_45,
  COLOR_MIDDLEORANGE_OPACITY_50,
  COLOR_MIDDLEORANGE_OPACITY_55,
  COLOR_MIDDLEORANGE_OPACITY_60,
  COLOR_MIDDLEORANGE_OPACITY_65,
  COLOR_MIDDLEORANGE_OPACITY_70,
  COLOR_MIDDLEORANGE_OPACITY_75,
  COLOR_MIDDLEORANGE_OPACITY_80,
  COLOR_MIDDLEORANGE_OPACITY_85,
  COLOR_MIDDLEORANGE_OPACITY_90,
  COLOR_MIDDLEORANGE_OPACITY_95,
  COLOR_BRIGHT_SHADE_1,
  COLOR_BRIGHT_SHADE_2,
  COLOR_BRIGHT_TINT_1,
  COLOR_BRIGHT_TINT_2,
  COLOR_BRIGHT_5,
  COLOR_BRIGHT_10,
  COLOR_BRIGHT_15,
  COLOR_BRIGHT_20,
  COLOR_BRIGHT_25,
  COLOR_BRIGHT_30,
  COLOR_BRIGHT_35,
  COLOR_BRIGHT_40,
  COLOR_BRIGHT_45,
  COLOR_BRIGHT_50,
  COLOR_BRIGHT_55,
  COLOR_BRIGHT_60,
  COLOR_BRIGHT_65,
  COLOR_BRIGHT_70,
  COLOR_BRIGHT_75,
  COLOR_BRIGHT_80,
  COLOR_BRIGHT_85,
  COLOR_BRIGHT_90,
  COLOR_BRIGHT_95,
  COLOR_BRIGHT_OPACITY_5,
  COLOR_BRIGHT_OPACITY_10,
  COLOR_BRIGHT_OPACITY_15,
  COLOR_BRIGHT_OPACITY_20,
  COLOR_BRIGHT_OPACITY_25,
  COLOR_BRIGHT_OPACITY_30,
  COLOR_BRIGHT_OPACITY_35,
  COLOR_BRIGHT_OPACITY_40,
  COLOR_BRIGHT_OPACITY_45,
  COLOR_BRIGHT_OPACITY_50,
  COLOR_BRIGHT_OPACITY_55,
  COLOR_BRIGHT_OPACITY_60,
  COLOR_BRIGHT_OPACITY_65,
  COLOR_BRIGHT_OPACITY_70,
  COLOR_BRIGHT_OPACITY_75,
  COLOR_BRIGHT_OPACITY_80,
  COLOR_BRIGHT_OPACITY_85,
  COLOR_BRIGHT_OPACITY_90,
  COLOR_BRIGHT_OPACITY_95,
  COLOR_DARK_SHADE_1,
  COLOR_DARK_SHADE_2,
  COLOR_DARK_TINT_1,
  COLOR_DARK_TINT_2,
  COLOR_DARK_5,
  COLOR_DARK_10,
  COLOR_DARK_15,
  COLOR_DARK_20,
  COLOR_DARK_25,
  COLOR_DARK_30,
  COLOR_DARK_35,
  COLOR_DARK_40,
  COLOR_DARK_45,
  COLOR_DARK_50,
  COLOR_DARK_55,
  COLOR_DARK_60,
  COLOR_DARK_65,
  COLOR_DARK_70,
  COLOR_DARK_75,
  COLOR_DARK_80,
  COLOR_DARK_85,
  COLOR_DARK_90,
  COLOR_DARK_95,
  COLOR_DARK_OPACITY_5,
  COLOR_DARK_OPACITY_10,
  COLOR_DARK_OPACITY_15,
  COLOR_DARK_OPACITY_20,
  COLOR_DARK_OPACITY_25,
  COLOR_DARK_OPACITY_30,
  COLOR_DARK_OPACITY_35,
  COLOR_DARK_OPACITY_40,
  COLOR_DARK_OPACITY_45,
  COLOR_DARK_OPACITY_50,
  COLOR_DARK_OPACITY_55,
  COLOR_DARK_OPACITY_60,
  COLOR_DARK_OPACITY_65,
  COLOR_DARK_OPACITY_70,
  COLOR_DARK_OPACITY_75,
  COLOR_DARK_OPACITY_80,
  COLOR_DARK_OPACITY_85,
  COLOR_DARK_OPACITY_90,
  COLOR_DARK_OPACITY_95,
  COLOR_LIGHT_GREY_SHADE_1,
  COLOR_LIGHT_GREY_SHADE_2,
  COLOR_LIGHT_GREY_TINT_1,
  COLOR_LIGHT_GREY_TINT_2,
  COLOR_LIGHT_GREY_5,
  COLOR_LIGHT_GREY_10,
  COLOR_LIGHT_GREY_15,
  COLOR_LIGHT_GREY_20,
  COLOR_LIGHT_GREY_25,
  COLOR_LIGHT_GREY_30,
  COLOR_LIGHT_GREY_35,
  COLOR_LIGHT_GREY_40,
  COLOR_LIGHT_GREY_45,
  COLOR_LIGHT_GREY_50,
  COLOR_LIGHT_GREY_55,
  COLOR_LIGHT_GREY_60,
  COLOR_LIGHT_GREY_65,
  COLOR_LIGHT_GREY_70,
  COLOR_LIGHT_GREY_75,
  COLOR_LIGHT_GREY_80,
  COLOR_LIGHT_GREY_85,
  COLOR_LIGHT_GREY_90,
  COLOR_LIGHT_GREY_95,
  COLOR_LIGHT_GREY_OPACITY_5,
  COLOR_LIGHT_GREY_OPACITY_10,
  COLOR_LIGHT_GREY_OPACITY_15,
  COLOR_LIGHT_GREY_OPACITY_20,
  COLOR_LIGHT_GREY_OPACITY_25,
  COLOR_LIGHT_GREY_OPACITY_30,
  COLOR_LIGHT_GREY_OPACITY_35,
  COLOR_LIGHT_GREY_OPACITY_40,
  COLOR_LIGHT_GREY_OPACITY_45,
  COLOR_LIGHT_GREY_OPACITY_50,
  COLOR_LIGHT_GREY_OPACITY_55,
  COLOR_LIGHT_GREY_OPACITY_60,
  COLOR_LIGHT_GREY_OPACITY_65,
  COLOR_LIGHT_GREY_OPACITY_70,
  COLOR_LIGHT_GREY_OPACITY_75,
  COLOR_LIGHT_GREY_OPACITY_80,
  COLOR_LIGHT_GREY_OPACITY_85,
  COLOR_LIGHT_GREY_OPACITY_90,
  COLOR_LIGHT_GREY_OPACITY_95,
  COLOR_TRANSPARENT_GREEN_SHADE_1,
  COLOR_TRANSPARENT_GREEN_SHADE_2,
  COLOR_TRANSPARENT_GREEN_TINT_1,
  COLOR_TRANSPARENT_GREEN_TINT_2,
  COLOR_TRANSPARENT_GREEN_5,
  COLOR_TRANSPARENT_GREEN_10,
  COLOR_TRANSPARENT_GREEN_15,
  COLOR_TRANSPARENT_GREEN_20,
  COLOR_TRANSPARENT_GREEN_25,
  COLOR_TRANSPARENT_GREEN_30,
  COLOR_TRANSPARENT_GREEN_35,
  COLOR_TRANSPARENT_GREEN_40,
  COLOR_TRANSPARENT_GREEN_45,
  COLOR_TRANSPARENT_GREEN_50,
  COLOR_TRANSPARENT_GREEN_55,
  COLOR_TRANSPARENT_GREEN_60,
  COLOR_TRANSPARENT_GREEN_65,
  COLOR_TRANSPARENT_GREEN_70,
  COLOR_TRANSPARENT_GREEN_75,
  COLOR_TRANSPARENT_GREEN_80,
  COLOR_TRANSPARENT_GREEN_85,
  COLOR_TRANSPARENT_GREEN_90,
  COLOR_TRANSPARENT_GREEN_95,
  COLOR_TRANSPARENT_GREEN_OPACITY_5,
  COLOR_TRANSPARENT_GREEN_OPACITY_10,
  COLOR_TRANSPARENT_GREEN_OPACITY_15,
  COLOR_TRANSPARENT_GREEN_OPACITY_20,
  COLOR_TRANSPARENT_GREEN_OPACITY_25,
  COLOR_TRANSPARENT_GREEN_OPACITY_30,
  COLOR_TRANSPARENT_GREEN_OPACITY_35,
  COLOR_TRANSPARENT_GREEN_OPACITY_40,
  COLOR_TRANSPARENT_GREEN_OPACITY_45,
  COLOR_TRANSPARENT_GREEN_OPACITY_50,
  COLOR_TRANSPARENT_GREEN_OPACITY_55,
  COLOR_TRANSPARENT_GREEN_OPACITY_60,
  COLOR_TRANSPARENT_GREEN_OPACITY_65,
  COLOR_TRANSPARENT_GREEN_OPACITY_70,
  COLOR_TRANSPARENT_GREEN_OPACITY_75,
  COLOR_TRANSPARENT_GREEN_OPACITY_80,
  COLOR_TRANSPARENT_GREEN_OPACITY_85,
  COLOR_TRANSPARENT_GREEN_OPACITY_90,
  COLOR_TRANSPARENT_GREEN_OPACITY_95,
  COLOR_TRANSPARENT_RED_SHADE_1,
  COLOR_TRANSPARENT_RED_SHADE_2,
  COLOR_TRANSPARENT_RED_TINT_1,
  COLOR_TRANSPARENT_RED_TINT_2,
  COLOR_TRANSPARENT_RED_5,
  COLOR_TRANSPARENT_RED_10,
  COLOR_TRANSPARENT_RED_15,
  COLOR_TRANSPARENT_RED_20,
  COLOR_TRANSPARENT_RED_25,
  COLOR_TRANSPARENT_RED_30,
  COLOR_TRANSPARENT_RED_35,
  COLOR_TRANSPARENT_RED_40,
  COLOR_TRANSPARENT_RED_45,
  COLOR_TRANSPARENT_RED_50,
  COLOR_TRANSPARENT_RED_55,
  COLOR_TRANSPARENT_RED_60,
  COLOR_TRANSPARENT_RED_65,
  COLOR_TRANSPARENT_RED_70,
  COLOR_TRANSPARENT_RED_75,
  COLOR_TRANSPARENT_RED_80,
  COLOR_TRANSPARENT_RED_85,
  COLOR_TRANSPARENT_RED_90,
  COLOR_TRANSPARENT_RED_95,
  COLOR_TRANSPARENT_RED_OPACITY_5,
  COLOR_TRANSPARENT_RED_OPACITY_10,
  COLOR_TRANSPARENT_RED_OPACITY_15,
  COLOR_TRANSPARENT_RED_OPACITY_20,
  COLOR_TRANSPARENT_RED_OPACITY_25,
  COLOR_TRANSPARENT_RED_OPACITY_30,
  COLOR_TRANSPARENT_RED_OPACITY_35,
  COLOR_TRANSPARENT_RED_OPACITY_40,
  COLOR_TRANSPARENT_RED_OPACITY_45,
  COLOR_TRANSPARENT_RED_OPACITY_50,
  COLOR_TRANSPARENT_RED_OPACITY_55,
  COLOR_TRANSPARENT_RED_OPACITY_60,
  COLOR_TRANSPARENT_RED_OPACITY_65,
  COLOR_TRANSPARENT_RED_OPACITY_70,
  COLOR_TRANSPARENT_RED_OPACITY_75,
  COLOR_TRANSPARENT_RED_OPACITY_80,
  COLOR_TRANSPARENT_RED_OPACITY_85,
  COLOR_TRANSPARENT_RED_OPACITY_90,
  COLOR_TRANSPARENT_RED_OPACITY_95,
  COLOR_TRANSPARENT_YELLOW_SHADE_1,
  COLOR_TRANSPARENT_YELLOW_SHADE_2,
  COLOR_TRANSPARENT_YELLOW_TINT_1,
  COLOR_TRANSPARENT_YELLOW_TINT_2,
  COLOR_TRANSPARENT_YELLOW_5,
  COLOR_TRANSPARENT_YELLOW_10,
  COLOR_TRANSPARENT_YELLOW_15,
  COLOR_TRANSPARENT_YELLOW_20,
  COLOR_TRANSPARENT_YELLOW_25,
  COLOR_TRANSPARENT_YELLOW_30,
  COLOR_TRANSPARENT_YELLOW_35,
  COLOR_TRANSPARENT_YELLOW_40,
  COLOR_TRANSPARENT_YELLOW_45,
  COLOR_TRANSPARENT_YELLOW_50,
  COLOR_TRANSPARENT_YELLOW_55,
  COLOR_TRANSPARENT_YELLOW_60,
  COLOR_TRANSPARENT_YELLOW_65,
  COLOR_TRANSPARENT_YELLOW_70,
  COLOR_TRANSPARENT_YELLOW_75,
  COLOR_TRANSPARENT_YELLOW_80,
  COLOR_TRANSPARENT_YELLOW_85,
  COLOR_TRANSPARENT_YELLOW_90,
  COLOR_TRANSPARENT_YELLOW_95,
  COLOR_TRANSPARENT_YELLOW_OPACITY_5,
  COLOR_TRANSPARENT_YELLOW_OPACITY_10,
  COLOR_TRANSPARENT_YELLOW_OPACITY_15,
  COLOR_TRANSPARENT_YELLOW_OPACITY_20,
  COLOR_TRANSPARENT_YELLOW_OPACITY_25,
  COLOR_TRANSPARENT_YELLOW_OPACITY_30,
  COLOR_TRANSPARENT_YELLOW_OPACITY_35,
  COLOR_TRANSPARENT_YELLOW_OPACITY_40,
  COLOR_TRANSPARENT_YELLOW_OPACITY_45,
  COLOR_TRANSPARENT_YELLOW_OPACITY_50,
  COLOR_TRANSPARENT_YELLOW_OPACITY_55,
  COLOR_TRANSPARENT_YELLOW_OPACITY_60,
  COLOR_TRANSPARENT_YELLOW_OPACITY_65,
  COLOR_TRANSPARENT_YELLOW_OPACITY_70,
  COLOR_TRANSPARENT_YELLOW_OPACITY_75,
  COLOR_TRANSPARENT_YELLOW_OPACITY_80,
  COLOR_TRANSPARENT_YELLOW_OPACITY_85,
  COLOR_TRANSPARENT_YELLOW_OPACITY_90,
  COLOR_TRANSPARENT_YELLOW_OPACITY_95,
  COLOR_TRANSPARENT_BLUE_SHADE_1,
  COLOR_TRANSPARENT_BLUE_SHADE_2,
  COLOR_TRANSPARENT_BLUE_TINT_1,
  COLOR_TRANSPARENT_BLUE_TINT_2,
  COLOR_TRANSPARENT_BLUE_5,
  COLOR_TRANSPARENT_BLUE_10,
  COLOR_TRANSPARENT_BLUE_15,
  COLOR_TRANSPARENT_BLUE_20,
  COLOR_TRANSPARENT_BLUE_25,
  COLOR_TRANSPARENT_BLUE_30,
  COLOR_TRANSPARENT_BLUE_35,
  COLOR_TRANSPARENT_BLUE_40,
  COLOR_TRANSPARENT_BLUE_45,
  COLOR_TRANSPARENT_BLUE_50,
  COLOR_TRANSPARENT_BLUE_55,
  COLOR_TRANSPARENT_BLUE_60,
  COLOR_TRANSPARENT_BLUE_65,
  COLOR_TRANSPARENT_BLUE_70,
  COLOR_TRANSPARENT_BLUE_75,
  COLOR_TRANSPARENT_BLUE_80,
  COLOR_TRANSPARENT_BLUE_85,
  COLOR_TRANSPARENT_BLUE_90,
  COLOR_TRANSPARENT_BLUE_95,
  COLOR_TRANSPARENT_BLUE_OPACITY_5,
  COLOR_TRANSPARENT_BLUE_OPACITY_10,
  COLOR_TRANSPARENT_BLUE_OPACITY_15,
  COLOR_TRANSPARENT_BLUE_OPACITY_20,
  COLOR_TRANSPARENT_BLUE_OPACITY_25,
  COLOR_TRANSPARENT_BLUE_OPACITY_30,
  COLOR_TRANSPARENT_BLUE_OPACITY_35,
  COLOR_TRANSPARENT_BLUE_OPACITY_40,
  COLOR_TRANSPARENT_BLUE_OPACITY_45,
  COLOR_TRANSPARENT_BLUE_OPACITY_50,
  COLOR_TRANSPARENT_BLUE_OPACITY_55,
  COLOR_TRANSPARENT_BLUE_OPACITY_60,
  COLOR_TRANSPARENT_BLUE_OPACITY_65,
  COLOR_TRANSPARENT_BLUE_OPACITY_70,
  COLOR_TRANSPARENT_BLUE_OPACITY_75,
  COLOR_TRANSPARENT_BLUE_OPACITY_80,
  COLOR_TRANSPARENT_BLUE_OPACITY_85,
  COLOR_TRANSPARENT_BLUE_OPACITY_90,
  COLOR_TRANSPARENT_BLUE_OPACITY_95,
  COLOR_WHITE_SHADE_1,
  COLOR_WHITE_SHADE_2,
  COLOR_WHITE_TINT_1,
  COLOR_WHITE_TINT_2,
  COLOR_WHITE_5,
  COLOR_WHITE_10,
  COLOR_WHITE_15,
  COLOR_WHITE_20,
  COLOR_WHITE_25,
  COLOR_WHITE_30,
  COLOR_WHITE_35,
  COLOR_WHITE_40,
  COLOR_WHITE_45,
  COLOR_WHITE_50,
  COLOR_WHITE_55,
  COLOR_WHITE_60,
  COLOR_WHITE_65,
  COLOR_WHITE_70,
  COLOR_WHITE_75,
  COLOR_WHITE_80,
  COLOR_WHITE_85,
  COLOR_WHITE_90,
  COLOR_WHITE_95,
  COLOR_WHITE_OPACITY_5,
  COLOR_WHITE_OPACITY_10,
  COLOR_WHITE_OPACITY_15,
  COLOR_WHITE_OPACITY_20,
  COLOR_WHITE_OPACITY_25,
  COLOR_WHITE_OPACITY_30,
  COLOR_WHITE_OPACITY_35,
  COLOR_WHITE_OPACITY_40,
  COLOR_WHITE_OPACITY_45,
  COLOR_WHITE_OPACITY_50,
  COLOR_WHITE_OPACITY_55,
  COLOR_WHITE_OPACITY_60,
  COLOR_WHITE_OPACITY_65,
  COLOR_WHITE_OPACITY_70,
  COLOR_WHITE_OPACITY_75,
  COLOR_WHITE_OPACITY_80,
  COLOR_WHITE_OPACITY_85,
  COLOR_WHITE_OPACITY_90,
  COLOR_WHITE_OPACITY_95,
  COLOR_BLACK_SHADE_1,
  COLOR_BLACK_SHADE_2,
  COLOR_BLACK_TINT_1,
  COLOR_BLACK_TINT_2,
  COLOR_BLACK_5,
  COLOR_BLACK_10,
  COLOR_BLACK_15,
  COLOR_BLACK_20,
  COLOR_BLACK_25,
  COLOR_BLACK_30,
  COLOR_BLACK_35,
  COLOR_BLACK_40,
  COLOR_BLACK_45,
  COLOR_BLACK_50,
  COLOR_BLACK_55,
  COLOR_BLACK_60,
  COLOR_BLACK_65,
  COLOR_BLACK_70,
  COLOR_BLACK_75,
  COLOR_BLACK_80,
  COLOR_BLACK_85,
  COLOR_BLACK_90,
  COLOR_BLACK_95,
  COLOR_BLACK_OPACITY_5,
  COLOR_BLACK_OPACITY_10,
  COLOR_BLACK_OPACITY_15,
  COLOR_BLACK_OPACITY_20,
  COLOR_BLACK_OPACITY_25,
  COLOR_BLACK_OPACITY_30,
  COLOR_BLACK_OPACITY_35,
  COLOR_BLACK_OPACITY_40,
  COLOR_BLACK_OPACITY_45,
  COLOR_BLACK_OPACITY_50,
  COLOR_BLACK_OPACITY_55,
  COLOR_BLACK_OPACITY_60,
  COLOR_BLACK_OPACITY_65,
  COLOR_BLACK_OPACITY_70,
  COLOR_BLACK_OPACITY_75,
  COLOR_BLACK_OPACITY_80,
  COLOR_BLACK_OPACITY_85,
  COLOR_BLACK_OPACITY_90,
  COLOR_BLACK_OPACITY_95,
  COLOR_BRIGHT_BLUE,
  COLOR_LIGHTER_BLUE,
  COLOR_BRIGHT_YELLOW,
  COLOR_BASE_GREY,
  COLOR_MIDDLE_GREY,
  COLOR_DARK_GREY,
  COLOR_BRIGHT_TABBAR_COLOR,
  COLOR_DARK_TABBAR_COLOR,
  COLOR_TAB_BORDER_COLOR,

  COLOR_TRANSPARENT,
  COLOR_WHITE,
  COLOR_SYSTEM_SUCCESS_LIGHT,
  COLOR_SYSTEM_SUCCESS,
  COLOR_SYSTEM_SUCCESS_DARK,
  COLOR_SYSTEM_WARNING_LIGHT,
  COLOR_SYSTEM_WARNING,
  COLOR_SYSTEM_WARNING_DARK,
  COLOR_SYSTEM_ERROR_LIGHT,
  COLOR_SYSTEM_ERROR,
  COLOR_SYSTEM_ERROR_DARK,
  COLOR_SYSTEM_HIGHLIGHT_LIGHT,
  COLOR_SYSTEM_HIGHLIGHT,
  COLOR_SYSTEM_HIGHLIGHT_DARK,
  COLOR_GREY100,
  COLOR_GREY200,
  COLOR_GREY300,
  COLOR_GREY400,
  COLOR_GREY500,
  COLOR_GREY600,
  COLOR_GREY700,
  COLOR_GREY800,
  COLOR_GREY900
] as const;

export const THEME_COLORS = [
  "blue",
  "darkblue",
  "blueActive",
  "green",
  "orange",
  "orangeActive",
  "teal",
  "tealActive",
  "turquoise",
  "turquoiseActive",
  "lightteal",
  "middleteal",
  "lightblue",
  "middleblue",
  "blueBorder",
  "red",
  "yellow",
  "lightturquoise",
  "middleturquoise",
  "greenBorder",
  "greenActive",
  "lightgreen",
  "middlegreen",
  "lightorange",
  "middleorange",
  "bright",
  "dark",
  "lightGrey",
  "transparentGreen",
  "transparentRed",
  "transparentYellow",
  "transparentBlue",
  "white",
  "black"
];

export const DEFAULT_PAGE_BACKGROUND_COLOR = "eon-bright" as const;

export const ACCORDION_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "green",
    scheme: {
      hoverTextColor: COLOR_DARK
    }
  },
  {
    schemeName: "teal",
    scheme: {
      hoverTextColor: COLOR_BRIGHT,
      outlineColor: COLOR_BLUE
    }
  },
  {
    schemeName: "blue",
    scheme: {
      hoverTextColor: COLOR_BRIGHT,
      activeAccordionBackgroundColor: COLOR_BLUE_ACTIVE
    }
  },
  {
    schemeName: "orange",
    scheme: {
      hoverTextColor: COLOR_DARK
    }
  },
  {
    schemeName: "bright",
    scheme: {
      hoverTextColor: COLOR_DARK
    }
  }
];
export const ANSWER_CARD_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "bright",
    scheme: {
      footTextColor: COLOR_BASE_GREY,
      footTextHoverColor: COLOR_BRIGHT,
      imageBackgroundColor: COLOR_BRIGHT,
      imageBackgroundSelectedColor: COLOR_BLUE,
      footBackgroundColor: COLOR_LIGHT_GREY,
      footBackgroundHoverColor: COLOR_BLUE_ACTIVE,
      footBackgroundSelectedColor: COLOR_BLUE_ACTIVE,
      hoverCardBorderColor: COLOR_BLUE,
      selectedCardBorderColor: COLOR_BLUE,
      indicatorBorderColor: COLOR_BLUE
    }
  },
  {
    schemeName: "blue",
    scheme: {
      footTextColor: COLOR_BASE_GREY,
      footTextHoverColor: COLOR_BRIGHT,
      imageBackgroundColor: COLOR_BRIGHT,
      imageBackgroundSelectedColor: COLOR_BLUE,
      footBackgroundColor: COLOR_LIGHT_GREY,
      footBackgroundHoverColor: COLOR_BLUE_ACTIVE,
      footBackgroundSelectedColor: COLOR_BLUE_ACTIVE,
      hoverCardBorderColor: COLOR_BRIGHT_OPACITY_50,
      selectedCardBorderColor: COLOR_BRIGHT,
      indicatorBordercolor: COLOR_BLUE
    }
  },
  {
    schemeName: "green",
    scheme: {
      footTextColor: COLOR_BASE_GREY,
      footTextHoverColor: COLOR_BRIGHT,
      imageBackgroundColor: COLOR_BRIGHT,
      imageBackgroundSelectedColor: COLOR_GREEN,
      footBackgroundColor: COLOR_LIGHT_GREY,
      footBackgroundHoverColor: COLOR_GREEN_ACTIVE,
      footBackgroundSelectedColor: COLOR_GREEN_ACTIVE,
      hoverCardBorderColor: COLOR_BRIGHT_OPACITY_50,
      selectedCardBorderColor: COLOR_BRIGHT,
      indicatorBordercolor: COLOR_GREEN
    }
  },
  {
    schemeName: "teal",
    scheme: {
      footTextColor: COLOR_BASE_GREY,
      footTextHoverColor: COLOR_BRIGHT,
      imageBackgroundColor: COLOR_BRIGHT,
      imageBackgroundSelectedColor: COLOR_TEAL,
      footBackgroundColor: COLOR_LIGHT_GREY,
      footBackgroundHoverColor: COLOR_TEAL_ACTIVE,
      footBackgroundSelectedColor: COLOR_TEAL_ACTIVE,
      hoverCardBorderColor: COLOR_BRIGHT_OPACITY_50,
      selectedCardBorderColor: COLOR_BRIGHT,
      indicatorBordercolor: COLOR_TEAL
    }
  },
  {
    schemeName: "orange",
    scheme: {
      footTextColor: COLOR_BASE_GREY,
      footTextHoverColor: COLOR_BRIGHT,
      imageBackgroundColor: COLOR_BRIGHT,
      imageBackgroundSelectedColor: COLOR_ORANGE,
      footBackgroundColor: COLOR_LIGHT_GREY,
      footBackgroundHoverColor: COLOR_ORANGE_ACTIVE,
      footBackgroundSelectedColor: COLOR_ORANGE_ACTIVE,
      hoverCardBorderColor: COLOR_BRIGHT_OPACITY_50,
      selectedCardBorderColor: COLOR_BRIGHT,
      indicatorBordercolor: COLOR_ORANGE
    }
  },
  {
    schemeName: "lightGrey",
    scheme: {
      footTextColor: COLOR_BASE_GREY,
      footTextHoverColor: COLOR_BRIGHT,
      imageBackgroundColor: COLOR_BRIGHT,
      imageBackgroundSelectedColor: COLOR_BLUE,
      footBackgroundColor: COLOR_LIGHT_GREY,
      footBackgroundHoverColor: COLOR_BLUE_ACTIVE,
      footBackgroundSelectedColor: COLOR_BLUE_ACTIVE,
      hoverCardBorderColor: COLOR_BLUE,
      selectedCardBorderColor: COLOR_BLUE,
      indicatorBordercolor: COLOR_BLUE
    }
  }
];
export const BADGE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "bright"
  },
  {
    schemeName: "dark"
  }
];
export const BASIC_TEASER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "bright"
  },
  {
    schemeName: "green"
  },
  {
    schemeName: "blue"
  },
  {
    schemeName: "orange"
  },
  {
    schemeName: "teal"
  },
  {
    schemeName: "white"
  }
];
export const BREADCRUMB_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "bright"
  },
  {
    schemeName: "baseGrey"
  }
];
export const BOTTOM_DRAWER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "green"
  },
  {
    schemeName: "blue"
  },
  {
    schemeName: "orange"
  },
  {
    schemeName: "bright"
  }
];
export const BULLET_LIST_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "bright",
    scheme: {
      textColor: COLOR_BRIGHT,
      highlight: COLOR_ORANGE
    }
  },
  {
    schemeName: "dark",
    scheme: {
      highlight: COLOR_GREEN
    }
  }
];
export const BULLET_LIST_DEPRECATED_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "green"
  },
  {
    schemeName: "lightblue"
  },
  {
    schemeName: "blue"
  },
  {
    schemeName: "bright"
  },
  {
    schemeName: "dark"
  }
];
export const BUSINESSCARD_AUTHOR_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "green",
    scheme: {
      textHoverColor: COLOR_GREEN_ACTIVE
    }
  },
  {
    schemeName: "blue",
    scheme: {
      textHoverColor: COLOR_BLUE_ACTIVE
    }
  },
  {
    schemeName: "bright",
    scheme: {
      textHoverColor: COLOR_BRIGHT_OPACITY_85
    }
  },
  {
    schemeName: "dark",
    scheme: {
      textHoverColor: COLOR_BASE_GREY
    }
  }
];
export const BUSINESSCARD_CONTACT_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "green",
    scheme: {
      backgroundColor: COLOR_GREEN,
      textColor: COLOR_BRIGHT,
      linkColor: COLOR_BRIGHT,
      linkHoverColor: COLOR_BRIGHT_OPACITY_85
    }
  },
  {
    schemeName: "blue",
    scheme: {
      backgroundColor: COLOR_BLUE,
      textColor: COLOR_BRIGHT,
      linkColor: COLOR_BRIGHT,
      linkHoverColor: COLOR_BRIGHT_OPACITY_85
    }
  },
  {
    schemeName: "orange",
    scheme: {
      backgroundColor: COLOR_ORANGE,
      textColor: COLOR_BRIGHT,
      linkColor: COLOR_BRIGHT,
      linkHoverColor: COLOR_BRIGHT_OPACITY_85
    }
  },
  {
    schemeName: "teal",
    scheme: {
      backgroundColor: COLOR_TEAL,
      textColor: COLOR_BRIGHT,
      linkColor: COLOR_BRIGHT,
      linkHoverColor: COLOR_BRIGHT_OPACITY_85
    }
  },
  {
    schemeName: "bright",
    scheme: {
      backgroundColor: COLOR_BRIGHT,
      textColor: COLOR_BASE_GREY,
      linkColor: COLOR_BLUE,
      linkHoverColor: COLOR_BLUE_ACTIVE
    }
  },
  {
    schemeName: "dark"
  }
];
export const BOX_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "lightgreen"
  },
  {
    schemeName: "lightblue"
  },
  {
    schemeName: "lightorange"
  },
  {
    schemeName: "bright"
  },
  {
    schemeName: "transparentGreen"
  },
  {
    schemeName: "transparentRed"
  },
  {
    schemeName: "transparentYellow"
  },
  {
    schemeName: "transparentBlue"
  }
];
export const BUTTON_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "green",
    scheme: {
      primaryBackgroundHoverColor: COLOR_GREEN_ACTIVE,
      primaryBorderHoverColor: COLOR_GREEN_ACTIVE,
      primaryTextAndIconColor: COLOR_DARK,
      primaryTextAndIconHoverColor: COLOR_DARK,
      secondaryBackgroundHoverColor: COLOR_GREEN_ACTIVE,
      secondaryBorderHoverColor: COLOR_GREEN_ACTIVE,
      secondaryBtnOnImageTextAndIconHoverColor: COLOR_GREEN_ACTIVE,
      secondaryBtnOnImageHoverFocusColor: COLOR_LIGHT_GREY,
      secondaryBackgroundFocusColor: COLOR_TRANSPARENT,
      secondaryTextAndIconFocusColor: COLOR_GREEN
    }
  },
  {
    schemeName: "orange",
    scheme: {
      primaryBackgroundHoverColor: COLOR_ORANGE_ACTIVE,
      primaryTextAndIconColor: COLOR_DARK,
      primaryTextAndIconHoverColor: COLOR_DARK,
      primaryBorderHoverColor: COLOR_ORANGE_ACTIVE,
      secondaryBackgroundHoverColor: COLOR_ORANGE_ACTIVE,
      secondaryBorderHoverColor: COLOR_ORANGE_ACTIVE,
      secondaryBtnOnImageTextAndIconHoverColor: COLOR_ORANGE_ACTIVE,
      secondaryBtnOnImageHoverFocusColor: COLOR_LIGHT_GREY,
      secondaryBackgroundFocusColor: COLOR_TRANSPARENT,
      secondaryTextAndIconFocusColor: COLOR_ORANGE
    }
  },
  {
    schemeName: "blue",
    scheme: {
      primaryBackgroundHoverColor: COLOR_BRIGHT_BLUE,
      primaryBorderHoverColor: COLOR_BRIGHT_BLUE,
      secondaryBackgroundHoverColor: COLOR_BRIGHT_BLUE,
      secondaryBorderHoverColor: COLOR_BRIGHT_BLUE,
      secondaryBackgroundFocusColor: COLOR_TRANSPARENT,
      secondaryTextAndIconFocusColor: COLOR_BLUE,
      secondaryBtnOnImageTextAndIconHoverColor: COLOR_BRIGHT_BLUE,
      secondaryBtnOnImageHoverFocusColor: COLOR_LIGHT_GREY
    }
  },
  {
    schemeName: "teal",
    scheme: {
      primaryBackgroundHoverColor: COLOR_TEAL_ACTIVE,
      primaryBorderHoverColor: COLOR_TEAL_ACTIVE,
      secondaryBackgroundHoverColor: COLOR_TEAL_ACTIVE,
      secondaryBorderHoverColor: COLOR_TEAL_ACTIVE,
      secondaryBtnOnImageTextAndIconHoverColor: COLOR_TEAL_ACTIVE,
      secondaryBtnOnImageHoverFocusColor: COLOR_LIGHT_GREY,
      secondaryBackgroundFocusColor: COLOR_TRANSPARENT,
      secondaryTextAndIconFocusColor: COLOR_TEAL
    }
  },
  {
    schemeName: "bright",
    scheme: {
      primaryTextAndIconColor: COLOR_LIGHTBLUE,
      primaryTextAndIconHoverColor: COLOR_LIGHTBLUE_SHADE_2,
      primaryBorderHoverColor: COLOR_BRIGHT_BLUE,
      primaryBorderColor: COLOR_BLUE,
      primaryBackgroundHoverColor: COLOR_BRIGHT,
      secondaryBackgroundColor: COLOR_TRANSPARENT,
      secondaryBackgroundHoverColor: COLOR_TRANSPARENT,
      secondaryBackgroundFocusColor: COLOR_TRANSPARENT,
      secondaryTextAndIconColor: COLOR_BRIGHT,
      secondaryTextAndIconHoverColor: COLOR_BRIGHT,
      secondaryBorderColor: COLOR_BLUE,
      secondaryBorderHoverColor: COLOR_BRIGHT
    }
  },
  {
    schemeName: "white",
    scheme: {
      primaryTextAndIconColor: COLOR_BLUE,
      primaryTextAndIconHoverColor: COLOR_BLUE_ACTIVE,
      primaryBorderHoverColor: COLOR_BRIGHT,
      primaryBorderColor: COLOR_WHITE,
      primaryBackgroundHoverColor: COLOR_BRIGHT,
      secondaryBackgroundColor: COLOR_TRANSPARENT,
      secondaryBackgroundHoverColor: COLOR_TRANSPARENT,
      secondaryBackgroundFocusColor: COLOR_TRANSPARENT,
      secondaryTextAndIconColor: COLOR_BRIGHT,
      secondaryTextAndIconHoverColor: COLOR_BRIGHT,
      secondaryBorderColor: COLOR_WHITE,
      secondaryBorderHoverColor: COLOR_BRIGHT
    }
  },
  {
    schemeName: "whiteOutline",
    scheme: {
      primaryBackgroundColor: COLOR_TRANSPARENT,
      primaryBackgroundHoverColor: COLOR_TRANSPARENT,
      primaryBackgroundFocusColor: COLOR_TRANSPARENT,
      primaryTextAndIconColor: COLOR_BRIGHT,
      primaryTextAndIconHoverColor: COLOR_BRIGHT,
      primaryBorderColor: COLOR_BRIGHT,
      primaryBorderHoverColor: COLOR_BRIGHT,
      secondaryBackgroundColor: COLOR_BRIGHT,
      secondaryBackgroundHoverColor: COLOR_BRIGHT,
      secondaryBackgroundFocusColor: COLOR_BRIGHT,
      secondaryTextAndIconColor: COLOR_BLUE,
      secondaryTextAndIconHoverColor: COLOR_BLUE,
      secondaryBorderColor: COLOR_BRIGHT,
      secondaryBorderHoverColor: COLOR_LIGHT_GREY,
      secondaryBtnOnImageBackgroundColor: COLOR_TRANSPARENT,
      secondaryBtnOnImageTextAndIconColor: COLOR_BRIGHT,
      secondaryBtnOnImageTextAndIconHoverColor: COLOR_BRIGHT,
      focusBorderColor: COLOR_BRIGHT
    }
  },
  {
    schemeName: "dark"
  }
];
export const CAPTION_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "green",
    scheme: {
      contentColor: COLOR_BRIGHT,
      backgroundColor: COLOR_GREEN_ACTIVE,
      leftBorderColor: COLOR_BRIGHT
    }
  },
  {
    schemeName: "blueActive",
    scheme: {
      contentColor: COLOR_BRIGHT,
      backgroundColor: COLOR_BLUE_ACTIVE,
      leftBorderColor: COLOR_BRIGHT
    }
  },
  {
    schemeName: "bright",
    scheme: {
      contentColor: COLOR_BASE_GREY,
      backgroundColor: COLOR_LIGHT_GREY,
      leftBorderColor: COLOR_DARK
    }
  },
  {
    schemeName: "dark"
  }
];
export const CARD_TEASER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "blue",
    scheme: {
      linkColor: COLOR_BRIGHT,
      linkHoverColor: COLOR_BRIGHT_OPACITY_85,
      headlineColor: COLOR_BRIGHT,
      alternativeHeadlineColor1: COLOR_GREEN,
      alternativeHeadlineColor2: COLOR_ORANGE,
      headlineColorOffset: COLOR_BLUE,
      categoryColor: COLOR_BRIGHT
    }
  },
  {
    schemeName: "green",
    scheme: {
      linkColor: COLOR_DARK
    }
  },
  {
    schemeName: "orange",
    scheme: {
      linkColor: COLOR_DARK
    }
  },
  {
    schemeName: "teal",
    scheme: {
      linkColor: COLOR_BRIGHT
    }
  },
  {
    schemeName: "bright",
    scheme: {
      linkColor: COLOR_BLUE,
      linkHoverColor: COLOR_BLUE_ACTIVE,
      headlineColor: COLOR_DARK,
      alternativeHeadlineColor1: COLOR_TEAL,
      alternativeHeadlineColor2: COLOR_GREEN,
      headlineColorOffset: COLOR_BLUE,
      categoryColor: COLOR_BASE_GREY
    }
  },
  {
    schemeName: "lightGrey",
    scheme: {
      contentColor: COLOR_DARK,
      backgroundColor: COLOR_LIGHT_GREY,
      linkColor: COLOR_BLUE,
      linkHoverColor: COLOR_BLUE_ACTIVE,
      headlineColor: COLOR_DARK,
      alternativeHeadlineColor1: COLOR_TEAL,
      alternativeHeadlineColor2: COLOR_GREEN,
      headlineColorOffset: COLOR_BLUE,
      categoryColor: COLOR_BASE_GREY
    }
  }
];
export const CAROUSEL_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "green",
    scheme: {
      indicatorColor: COLOR_MIDDLE_GREY,
      indicatorHoverColor: COLOR_MIDDLE_GREY,
      controlHoverColor: COLOR_GREEN_ACTIVE,
      outsideControlHoverColor: COLOR_GREEN_ACTIVE
    }
  },
  {
    schemeName: "greenInverted",
    scheme: {
      indicatorColor: COLOR_BRIGHT_OPACITY_30,
      indicatorHoverColor: COLOR_GREEN_50,
      indicatorActColor: COLOR_BRIGHT,
      controlHoverColor: COLOR_GREEN_ACTIVE,
      controlHoverIconColor: COLOR_GREEN_FONT,
      outsideControlColor: COLOR_BRIGHT,
      outsideControlIconColor: COLOR_BASE_GREY,
      outsideControlHoverColor: COLOR_BRIGHT,
      outsideControlHoverIconColor: COLOR_BASE_GREY
    }
  },
  {
    schemeName: "orange",
    scheme: {
      indicatorColor: COLOR_MIDDLE_GREY,
      indicatorHoverColor: COLOR_MIDDLE_GREY,
      controlHoverColor: COLOR_ORANGE_ACTIVE,
      outsideControlHoverColor: COLOR_ORANGE_ACTIVE
    }
  },
  {
    schemeName: "orangeInverted",
    scheme: {
      indicatorColor: COLOR_BRIGHT_OPACITY_30,
      indicatorHoverColor: COLOR_ORANGE_50,
      indicatorActColor: COLOR_BRIGHT,
      controlHoverColor: COLOR_ORANGE_ACTIVE,
      controlHoverIconColor: COLOR_ORANGE_FONT,
      outsideControlColor: COLOR_BRIGHT,
      outsideControlIconColor: COLOR_BASE_GREY,
      outsideControlHoverColor: COLOR_BRIGHT,
      outsideControlHoverIconColor: COLOR_BASE_GREY
    }
  },
  {
    schemeName: "blue",
    scheme: {
      indicatorColor: COLOR_MIDDLE_GREY,
      indicatorHoverColor: COLOR_MIDDLE_GREY,
      controlHoverColor: COLOR_BLUE_ACTIVE,
      outsideControlHoverColor: COLOR_BLUE_ACTIVE
    }
  },
  {
    schemeName: "blueInverted",
    scheme: {
      indicatorColor: COLOR_BRIGHT_OPACITY_30,
      indicatorHoverColor: COLOR_BLUE_50,
      indicatorActColor: COLOR_BRIGHT,
      controlHoverColor: COLOR_BLUE_ACTIVE,
      controlHoverIconColor: COLOR_BLUE_FONT,
      outsideControlColor: COLOR_BRIGHT,
      outsideControlIconColor: COLOR_BASE_GREY,
      outsideControlHoverColor: COLOR_BRIGHT,
      outsideControlHoverIconColor: COLOR_BASE_GREY
    }
  },
  {
    schemeName: "teal",
    scheme: {
      indicatorColor: COLOR_MIDDLE_GREY,
      indicatorHoverColor: COLOR_MIDDLE_GREY,
      controlHoverColor: COLOR_TEAL_ACTIVE,
      outsideControlHoverColor: COLOR_TEAL_ACTIVE
    }
  },
  {
    schemeName: "tealInverted",
    scheme: {
      indicatorColor: COLOR_BRIGHT_OPACITY_30,
      indicatorHoverColor: COLOR_TEAL_50,
      indicatorActColor: COLOR_BRIGHT,
      controlHoverColor: COLOR_TEAL_ACTIVE,
      controlHoverIconColor: COLOR_TEAL_FONT,
      outsideControlColor: COLOR_BRIGHT,
      outsideControlIconColor: COLOR_BASE_GREY,
      outsideControlHoverColor: COLOR_BRIGHT,
      outsideControlHoverIconColor: COLOR_BASE_GREY
    }
  },
  {
    schemeName: "bright"
  },
  {
    schemeName: "dark",
    scheme: {
      indicatorColor: COLOR_MIDDLE_GREY,
      indicatorHoverColor: COLOR_DARK_GREY,
      controlHoverColor: COLOR_DARK_GREY,
      outsideControlHoverColor: COLOR_DARK_GREY
    }
  }
];
export const CHECKBOX_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "bright",
    scheme: {
      labelColor: COLOR_BRIGHT
    }
  },
  {
    schemeName: "blue",
    scheme: {
      labelColor: COLOR_DARK,
      uncheckedColor: COLOR_MIDDLE_GREY,
      checkedHoverColor: COLOR_BLUE_ACTIVE,
      errorColor: COLOR_RED,
      disabledUncheckedColor: COLOR_MIDDLE_GREY,
      disabledCheckedColor: COLOR_BLUE_OPACITY_60,
      disabledLabelColor: COLOR_BASE_GREY,
      boxColorUnchecked: COLOR_MIDDLE_GREY,
      boxColorCheckedHover: COLOR_BLUE_ACTIVE
    }
  },
  {
    schemeName: "teal",
    scheme: {
      labelColor: COLOR_DARK,
      uncheckedColor: COLOR_MIDDLE_GREY,
      checkedHoverColor: COLOR_TEAL_ACTIVE,
      errorColor: COLOR_RED,
      disabledUncheckedColor: COLOR_MIDDLE_GREY,
      disabledCheckedColor: COLOR_TEAL_OPACITY_60,
      disabledLabelColor: COLOR_BASE_GREY,
      boxColorUnchecked: COLOR_MIDDLE_GREY,
      boxColorCheckedHover: COLOR_TEAL_ACTIVE
    }
  },
  {
    schemeName: "green",
    scheme: {
      labelColor: COLOR_DARK,
      uncheckedColor: COLOR_MIDDLE_GREY,
      checkedHoverColor: COLOR_GREEN_ACTIVE,
      errorColor: COLOR_RED,
      disabledUncheckedColor: COLOR_MIDDLE_GREY,
      disabledCheckedColor: COLOR_GREEN_OPACITY_60,
      disabledLabelColor: COLOR_BASE_GREY,
      boxColorUnchecked: COLOR_MIDDLE_GREY,
      boxColorCheckedHover: COLOR_GREEN_ACTIVE
    }
  },
  {
    schemeName: "orange",
    scheme: {
      labelColor: COLOR_DARK,
      uncheckedColor: COLOR_MIDDLE_GREY,
      checkedHoverColor: COLOR_ORANGE_ACTIVE,
      errorColor: COLOR_RED,
      disabledUncheckedColor: COLOR_MIDDLE_GREY,
      disabledCheckedColor: COLOR_ORANGE_OPACITY_60,
      disabledLabelColor: COLOR_BASE_GREY,
      boxColorUnchecked: COLOR_MIDDLE_GREY,
      boxColorCheckedHover: COLOR_ORANGE_ACTIVE
    }
  },
  {
    schemeName: "inverted",
    scheme: {
      labelColor: COLOR_BRIGHT,
      uncheckedColor: COLOR_BRIGHT,
      uncheckedHoverColor: COLOR_BRIGHT_OPACITY_75,
      focusColor: COLOR_BRIGHT_OPACITY_75,
      iconColor: COLOR_BLUE_ACTIVE,
      checkedColor: COLOR_BRIGHT,
      checkedHoverColor: COLOR_BRIGHT_OPACITY_75,
      errorColor: COLOR_LIGHT_GREY,
      disabledUncheckedColor: COLOR_BRIGHT_OPACITY_60,
      disabledCheckedColor: COLOR_BRIGHT_OPACITY_60,
      disabledLabelColor: COLOR_BRIGHT_OPACITY_60,
      boxColorUnchecked: COLOR_BRIGHT,
      boxColorUncheckedHover: COLOR_BRIGHT_OPACITY_75,
      boxColorChecked: COLOR_BRIGHT,
      boxColorCheckedHover: COLOR_BRIGHT_OPACITY_75
    }
  }
];
export const CHIP_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "blue"
  },
  {
    schemeName: "brightOnBlue"
  },
  {
    schemeName: "blueOnLightblue"
  },
  {
    schemeName: "green"
  },
  {
    schemeName: "brightOnGreen"
  },
  {
    schemeName: "orange"
  },
  {
    schemeName: "brightOnOrange"
  },
  {
    schemeName: "brightOnTeal"
  },
  {
    schemeName: "dark"
  }
];
export const CLICKABLE_IMAGE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "green",
    scheme: {
      backgroundColor: COLOR_GREEN,
      backgroundHoverColor: COLOR_GREEN_ACTIVE,
      backgroundFocusColor: COLOR_GREEN,
      textColor: COLOR_DARK,
      textHoverColor: COLOR_DARK,
      textFocusColor: COLOR_DARK,
      borderLineColor: COLOR_DARK_OPACITY_60,
      borderLineHoverColor: COLOR_DARK,
      borderLineFocusColor: COLOR_DARK,
      labelBackgroundColor: COLOR_BRIGHT_OPACITY_60,
      labelBackgroundColorActive: COLOR_BRIGHT,
      labelBackgroundColorBright: COLOR_DARK_OPACITY_60,
      labelBackgroundColorBrightActive: COLOR_DARK,
      labelColor: COLOR_BLACK,
      labelColorBright: COLOR_WHITE,
      tooltipScheme: "grey900",
      modalScheme: "white"
    }
  },
  {
    schemeName: "blue",
    scheme: {
      backgroundColor: COLOR_BLUE,
      backgroundHoverColor: COLOR_BLUE_ACTIVE,
      backgroundFocusColor: COLOR_BLUE,
      textColor: COLOR_BRIGHT,
      textHoverColor: COLOR_BRIGHT,
      textFocusColor: COLOR_BRIGHT,
      borderLineColor: COLOR_BRIGHT_OPACITY_60,
      borderLineHoverColor: COLOR_BRIGHT,
      borderLineFocusColor: COLOR_BRIGHT,
      labelBackgroundColor: COLOR_BRIGHT_OPACITY_60,
      labelBackgroundColorActive: COLOR_BRIGHT,
      labelBackgroundColorBright: COLOR_BRIGHT_OPACITY_60,
      labelBackgroundColorBrightActive: COLOR_BRIGHT,
      labelColor: COLOR_BLACK,
      labelColorBright: COLOR_WHITE,
      tooltipScheme: "grey900",
      modalScheme: "white"
    }
  },
  {
    schemeName: "orange",
    scheme: {
      backgroundColor: COLOR_ORANGE,
      backgroundHoverColor: COLOR_ORANGE_ACTIVE,
      backgroundFocusColor: COLOR_ORANGE,
      textColor: COLOR_DARK,
      textHoverColor: COLOR_DARK,
      textFocusColor: COLOR_DARK,
      borderLineColor: COLOR_DARK_OPACITY_60,
      borderLineHoverColor: COLOR_DARK,
      borderLineFocusColor: COLOR_DARK,
      labelBackgroundColor: COLOR_BRIGHT_OPACITY_60,
      labelBackgroundColorActive: COLOR_BRIGHT,
      labelBackgroundColorBright: COLOR_DARK_OPACITY_60,
      labelBackgroundColorBrightActive: COLOR_DARK,
      labelColor: COLOR_BLACK,
      labelColorBright: COLOR_WHITE,
      tooltipScheme: "grey900",
      modalScheme: "white"
    }
  },
  {
    schemeName: "teal",
    scheme: {
      backgroundColor: COLOR_TEAL,
      backgroundHoverColor: COLOR_TEAL_ACTIVE,
      backgroundFocusColor: COLOR_TEAL,
      textColor: COLOR_BRIGHT,
      textHoverColor: COLOR_BRIGHT,
      textFocusColor: COLOR_BRIGHT,
      borderLineColor: COLOR_BRIGHT_OPACITY_60,
      borderLineHoverColor: COLOR_BRIGHT,
      borderLineFocusColor: COLOR_BRIGHT,
      labelBackgroundColor: COLOR_BRIGHT_OPACITY_60,
      labelBackgroundColorActive: COLOR_BRIGHT,
      labelBackgroundColorBright: COLOR_BRIGHT_OPACITY_60,
      labelBackgroundColorBrightActive: COLOR_BRIGHT,
      labelColor: COLOR_BLACK,
      labelColorBright: COLOR_WHITE,
      tooltipScheme: "grey900",
      modalScheme: "white"
    }
  },
  {
    schemeName: "bright",
    scheme: {
      tooltipScheme: "bright"
    }
  }
];
export const COMPASS_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "blue"
  }
];
export const CONTACT_BAR_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "green"
  },
  {
    schemeName: "blue"
  },
  {
    schemeName: "bright"
  }
];
export const CONTACT_LIST_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "green"
  },
  {
    schemeName: "lightblue"
  },
  {
    schemeName: "blue"
  },
  {
    schemeName: "bright",
    scheme: {
      linkHoverColor: COLOR_BRIGHT_OPACITY_85
    }
  },
  {
    schemeName: "dark",
    scheme: {
      linkHoverColor: COLOR_DARK_GREY
    }
  }
];
export const CONTACT_LAYER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white"
  }
];
export const CONTENT_AGGREGATOR_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "green"
  },
  {
    schemeName: "blue"
  },
  {
    schemeName: "orange"
  },
  {
    schemeName: "teal"
  },
  {
    schemeName: "bright"
  },
  {
    schemeName: "dark"
  }
];
export const CONTENT_AGGREGATOR_ITEM_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "whiteOnGreen",
    scheme: {
      contentColor: COLOR_DARK,
      dateColorOnImage: COLOR_BRIGHT,
      backgroundColor: COLOR_BRIGHT,
      backgroundColorShade: COLOR_LIGHT_GREY,
      leftBorderColor: COLOR_MIDDLE_GREY,
      linkColor: COLOR_BLUE,
      linkHoverColor: COLOR_BLUE_ACTIVE,
      contentBackground: COLOR_BRIGHT,
      hoverColor: COLOR_DARK_GREY,
      listButtonScheme: "discreet"
    }
  },
  {
    schemeName: "whiteOnBlue",
    scheme: {
      contentColor: COLOR_DARK,
      dateColorOnImage: COLOR_BRIGHT,
      backgroundColor: COLOR_BRIGHT,
      backgroundColorShade: COLOR_LIGHT_GREY,
      leftBorderColor: COLOR_MIDDLE_GREY,
      linkColor: COLOR_BLUE,
      linkHoverColor: COLOR_BLUE_ACTIVE,
      contentBackground: COLOR_BRIGHT,
      hoverColor: COLOR_DARK_GREY,
      listButtonScheme: "discreet"
    }
  },
  {
    schemeName: "whiteOnOrange",
    scheme: {
      contentColor: COLOR_DARK,
      dateColorOnImage: COLOR_BRIGHT,
      backgroundColor: COLOR_BRIGHT,
      backgroundColorShade: COLOR_LIGHT_GREY,
      leftBorderColor: COLOR_MIDDLE_GREY,
      linkColor: COLOR_BLUE,
      linkHoverColor: COLOR_BLUE_ACTIVE,
      contentBackground: COLOR_BRIGHT,
      hoverColor: COLOR_DARK_GREY,
      listButtonScheme: "discreet"
    }
  },
  {
    schemeName: "whiteOnTeal",
    scheme: {
      contentColor: COLOR_DARK,
      dateColorOnImage: COLOR_BRIGHT,
      backgroundColor: COLOR_BRIGHT,
      backgroundColorShade: COLOR_LIGHT_GREY,
      leftBorderColor: COLOR_MIDDLE_GREY,
      linkColor: COLOR_BLUE,
      linkHoverColor: COLOR_BLUE_ACTIVE,
      contentBackground: COLOR_BRIGHT,
      hoverColor: COLOR_DARK_GREY,
      listButtonScheme: "discreet"
    }
  },
  {
    schemeName: "blue",
    scheme: {
      dateColorOnImage: COLOR_BRIGHT,
      backgroundColorShade: COLOR_BLUE_ACTIVE,
      leftBorderColor: COLOR_BRIGHT,
      linkColor: COLOR_BRIGHT,
      linkHoverColor: COLOR_BRIGHT_OPACITY_85,
      contentBackground: COLOR_BRIGHT,
      hoverColor: COLOR_TEAL,
      listButtonScheme: "discreet"
    }
  },
  {
    schemeName: "green",
    scheme: {
      dateColorOnImage: COLOR_BRIGHT,
      backgroundColorShade: COLOR_GREEN_ACTIVE,
      leftBorderColor: COLOR_BRIGHT,
      linkColor: COLOR_BRIGHT,
      linkHoverColor: COLOR_BRIGHT_OPACITY_85,
      contentBackground: COLOR_BRIGHT,
      hoverColor: COLOR_GREEN_ACTIVE,
      listButtonScheme: "discreet"
    }
  },
  {
    schemeName: "bright",
    scheme: {
      dateColorOnImage: COLOR_BRIGHT,
      backgroundColorShade: COLOR_LIGHT_GREY,
      leftBorderColor: COLOR_MIDDLE_GREY,
      linkColor: COLOR_BLUE,
      linkHoverColor: COLOR_BLUE_ACTIVE,
      hoverColor: COLOR_TEAL,
      listButtonScheme: "discreet"
    }
  },
  {
    schemeName: "dark"
  }
];
export const CONTEXT_MENU_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "bright",
    scheme: {
      backgroundColor: COLOR_BRIGHT
    }
  }
];
export const CONTEXT_MENU_ITEM_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "bright",
    scheme: {
      itemBackgroundColor: COLOR_BRIGHT,
      itemIconActiveColor: COLOR_BLUE
    }
  }
];
export const DATE_EVENT_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "bright",
    scheme: {
      dateColor: COLOR_BRIGHT,
      dateLeftBorder: COLOR_LIGHT_GREY
    }
  },
  {
    schemeName: "dark",
    scheme: {
      dateColor: COLOR_DARK,
      dateLeftBorder: COLOR_DARK_OPACITY_50
    }
  }
];
export const DATE_PICKER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "blue",
    scheme: {
      popupBorderColor: COLOR_DARK_GREY,
      popupFocusBorderColor: COLOR_DARK_GREY
    }
  },
  {
    schemeName: "bright",
    scheme: {
      fontColor: COLOR_DARK,
      popupBackgroundColor: COLOR_BRIGHT,
      popupBorderColor: COLOR_BLUE,
      popupFocusBorderColor: COLOR_BLUE,
      separatorColor: COLOR_LIGHT_GREY,
      dayBorderHoverColor: COLOR_BLUE,
      dayBorderSelectedColor: COLOR_TEAL,
      dayBackgroundTodayColor: COLOR_TRANSPARENT_BLUE,
      dayFontDisabledColor: COLOR_LIGHT_GREY,
      dayFontOtherMonthColor: COLOR_LIGHT_GREY,
      monthYearButtonBorderColor: COLOR_LIGHT_GREY,
      scrollbarBackgroundColor: COLOR_LIGHT_GREY,
      scrollbarThumbColor: COLOR_LIGHT_GREY,
      monthYearToggleBorderColor: COLOR_LIGHT_GREY,
      monthYearToggleBorderHoverColor: COLOR_BLUE,
      monthYearToggleBorderActiveColor: COLOR_BLUE,
      monthYearToggleBackgroundActiveColor: COLOR_TRANSPARENT_BLUE,
      internalInputScheme: "bright"
    }
  },
  {
    schemeName: "dark",
    scheme: {
      popupBorderColor: COLOR_LIGHTBLUE,
      popupFocusBorderColor: COLOR_LIGHTBLUE
    }
  }
];
export const DIVIDER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "green"
  },
  {
    schemeName: "orange"
  },
  {
    schemeName: "blue"
  },
  {
    schemeName: "teal"
  },
  {
    schemeName: "bright"
  },
  {
    schemeName: "dark"
  }
];
export const DROPDOWN_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "bright",
    scheme: {
      borderColor: COLOR_MIDDLE_GREY,
      borderHoverColor: COLOR_BLUE,
      borderActiveColor: COLOR_BLUE,
      borderHoverColorActive: COLOR_DARK_GREY,
      labelColor: COLOR_DARK,
      errorMessageColor: COLOR_RED,
      trailingIconBackgroundColor: COLOR_MIDDLE_GREY,
      trailingIconColor: COLOR_DARK,
      trailingIconColorActive: COLOR_BLUE,
      disabledBackgroundColor: COLOR_BRIGHT,
      disabledBorderColor: COLOR_LIGHT_GREY,
      disabledTrailingIconColor: COLOR_MIDDLE_GREY,
      disabledOpacity: 0.6,
      optionsBackgroundColor: COLOR_BRIGHT,
      optionsBorderHoverColor: COLOR_DARK_GREY,
      optionsBorderBottomColor: COLOR_LIGHT_GREY,
      optionsBackgroundColorHover: COLOR_LIGHT_GREY,
      optionsBackgroundColorActive: COLOR_TRANSPARENT_BLUE
    }
  },
  {
    schemeName: "dark",
    scheme: {
      borderColor: COLOR_MIDDLE_GREY,
      borderHoverColor: COLOR_DARK_GREY,
      borderActiveColor: COLOR_LIGHTBLUE,
      labelColor: COLOR_DARK,
      errorMessageColor: COLOR_RED,
      trailingIconBackgroundColor: COLOR_MIDDLE_GREY,
      trailingIconColor: COLOR_DARK,
      trailingIconColorActive: COLOR_DARK,
      disabledBackgroundColor: COLOR_BRIGHT,
      disabledBorderColor: COLOR_LIGHT_GREY,
      disabledTrailingIconColor: COLOR_MIDDLE_GREY,
      disabledOpacity: 0.6,
      optionsBackgroundColor: COLOR_BRIGHT,
      optionsBorderHoverColor: COLOR_DARK_GREY,
      optionsBorderBottomColor: COLOR_LIGHT_GREY,
      optionsBackgroundColorHover: COLOR_LIGHT_GREY,
      optionsBackgroundColorActive: COLOR_LIGHTER_BLUE
    }
  }
];
export const DROPDOWN_OPTION_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "green"
  },
  {
    schemeName: "lightblue"
  },
  {
    schemeName: "blue",
    scheme: {
      borderBottomColor: COLOR_MIDDLE_GREY,
      backgroundColorHover: COLOR_LIGHT_GREY
    }
  },
  {
    schemeName: "bright",
    scheme: {
      labelColor: COLOR_BRIGHT
    }
  },
  {
    schemeName: "dark",
    scheme: {
      borderHoverColor: COLOR_DARK_GREY,
      borderBottomColor: COLOR_LIGHT_GREY,
      backgroundColorHover: COLOR_LIGHT_GREY,
      backgroundColorActive: COLOR_LIGHTER_BLUE,
      textColor: COLOR_DARK
    }
  }
];
export const ERROR_MESSAGE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "red500"
  },
  {
    schemeName: "dark"
  },
  {
    schemeName: "white",
    scheme: {
      linkHoverColor: COLOR_RED,
      leftBorderColor: COLOR_LIGHT_GREY
    }
  },
  {
    schemeName: "grey100",
    scheme: {
      linkHoverColor: COLOR_RED,
      leftBorderColor: COLOR_LIGHT_GREY
    }
  },
  {
    schemeName: "error",
    scheme: {
      backgroundColor: COLOR_SYSTEM_ERROR_LIGHT,
      contentColor: COLOR_WHITE_FONT,
      linkHoverColor: COLOR_GREY700,
      leftBorderColor: COLOR_SYSTEM_ERROR
    }
  },
  {
    schemeName: "warning",
    scheme: {
      backgroundColor: COLOR_SYSTEM_WARNING_LIGHT,
      contentColor: COLOR_WHITE_FONT,
      linkHoverColor: COLOR_GREY700,
      leftBorderColor: COLOR_SYSTEM_WARNING
    }
  },
  {
    schemeName: "success",
    scheme: {
      backgroundColor: COLOR_GREEN,
      contentColor: COLOR_WHITE_FONT,
      linkHoverColor: COLOR_GREY700,
      leftBorderColor: COLOR_GREEN
    }
  },
  {
    schemeName: "info",
    scheme: {
      backgroundColor: COLOR_SYSTEM_HIGHLIGHT_LIGHT,
      contentColor: COLOR_WHITE_FONT,
      linkHoverColor: COLOR_GREY700,
      leftBorderColor: COLOR_SYSTEM_HIGHLIGHT
    }
  },
  {
    schemeName: "neutral100",
    scheme: {
      linkHoverColor: COLOR_RED,
      leftBorderColor: COLOR_LIGHT_GREY
    }
  },
  {
    schemeName: "neutral300",
    scheme: {
      linkHoverColor: COLOR_RED,
      leftBorderColor: COLOR_LIGHT_GREY
    }
  }
];
export const FILE_UPLOAD_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "green"
  },
  {
    schemeName: "blue",
    scheme: {
      dropzoneBorderSingle: COLOR_DARK_OPACITY_20,
      dropzoneBorderMultiple: COLOR_DARK_OPACITY_20,
      dropzoneBackground: COLOR_LIGHT_GREY,
      dropzoneHoverBackground: COLOR_BLUE_25,
      dropzoneHoverBorder: COLOR_BLUE,
      dropzoneOnDragHoverBackground: COLOR_BLUE_25,
      dropzoneOnDragHoverBorder: COLOR_BLUE,
      errorMessageColor: COLOR_RED,
      buttonScheme: String(/rblueInverted/),
      uploadCompleteBackground: COLOR_BRIGHT,
      dragOverBorder: COLOR_BLUE,
      dropzoneIconColor: COLOR_DARK,
      dropzoneIconHoverColor: COLOR_DARK,
      dropzoneContentColor: COLOR_DARK,
      dropzoneContentHoverColor: COLOR_DARK,
      dropzoneLinkColor: COLOR_DARK,
      dropzoneLinkHoverColor: COLOR_DARK,
      uploadedStatusColor: COLOR_DARK,
      uploadCompleteContentColor: COLOR_BLUE
    }
  },
  {
    schemeName: "whiteOnBlue",
    scheme: {
      dropzoneBorderSingle: COLOR_BRIGHT,
      dropzoneBorderMultiple: COLOR_BRIGHT_OPACITY_20,
      dropzoneBackground: COLOR_BRIGHT_OPACITY_10,
      dropzoneHoverBackground: COLOR_BLUE_25,
      dropzoneHoverBorder: COLOR_BRIGHT,
      dropzoneOnDragHoverBackground: COLOR_ORANGE,
      dropzoneOnDragHoverBorder: COLOR_BRIGHT,
      errorMessageColor: COLOR_BRIGHT,
      buttonScheme: String(/blueInverted/),
      uploadCompleteBackground: COLOR_LIGHT_GREY,
      dragOverBorder: COLOR_ORANGE,
      dropzoneIconColor: COLOR_BRIGHT,
      dropzoneIconHoverColor: COLOR_DARK,
      dropzoneContentColor: COLOR_BRIGHT,
      dropzoneContentHoverColor: COLOR_DARK,
      dropzoneLinkColor: COLOR_BRIGHT,
      dropzoneLinkHoverColor: COLOR_DARK,
      uploadedStatusColor: COLOR_BRIGHT,
      uploadCompleteContentColor: COLOR_ORANGE
    }
  },
  {
    schemeName: "orange"
  },
  {
    schemeName: "bright"
  },
  {
    schemeName: "dark"
  }
];
export const FILE_PREVIEW_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "blue",
    scheme: {
      iconColor: COLOR_DARK,
      textColor: COLOR_DARK,
      boxBackground: COLOR_BRIGHT,
      fileIconColor: COLOR_MIDDLE_GREY,
      descriptionColor: COLOR_MIDDLE_GREY,
      progressCircleScheme: "bright",
      previewCancelIconColor: COLOR_MIDDLE_GREY
    }
  },
  {
    schemeName: "bright",
    scheme: {
      iconColor: COLOR_DARK,
      textColor: COLOR_DARK,
      boxBackground: COLOR_LIGHT_GREY,
      fileIconColor: COLOR_MIDDLE_GREY,
      descriptionColor: COLOR_MIDDLE_GREY,
      progressCircleScheme: "lightGrey",
      previewCancelIconColor: COLOR_MIDDLE_GREY
    }
  }
];
export const FORM_MESSAGE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "standard",
    scheme: {
      infoColor: COLOR_DARK,
      successColor: COLOR_GREEN,
      errorColor: COLOR_RED
    }
  },
  {
    schemeName: "bright",
    scheme: {
      errorColor: COLOR_BRIGHT
    }
  },
  {
    schemeName: "dark",
    scheme: {
      errorColor: COLOR_RED
    }
  }
];
export const HEADLINE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "green"
  },
  {
    schemeName: "blue"
  },
  {
    schemeName: "orange"
  },
  {
    schemeName: "teal"
  },
  {
    schemeName: "bright"
  },
  {
    schemeName: "dark"
  }
];
export const HEADLINE_BRAND_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "blue"
  },
  {
    schemeName: "bright"
  }
];
export const HERO_SECTION_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "bright",
    scheme: {
      onBackgroundImageHeadlineScheme: "lightgrey"
    }
  }
];
export const ICON_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "green"
  },
  {
    schemeName: "orange"
  },
  {
    schemeName: "blue"
  },
  {
    schemeName: "teal"
  },
  {
    schemeName: "bright"
  },
  {
    schemeName: "dark"
  }
];
export const INFO_ICON_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "bright",
    scheme: {
      iconHoverColor: COLOR_BRIGHT_OPACITY_80
    }
  },
  {
    schemeName: "dark"
  },
  {
    schemeName: "blue",
    scheme: {
      iconHoverColor: COLOR_BLUE_ACTIVE
    }
  },
  {
    schemeName: "orange",
    scheme: {
      iconHoverColor: COLOR_ORANGE_ACTIVE
    }
  },
  {
    schemeName: "teal",
    scheme: {
      iconHoverColor: COLOR_TEAL_ACTIVE
    }
  },
  {
    schemeName: "middleGrey",
    scheme: {
      iconHoverColor: COLOR_DARK_GREY
    }
  },
  {
    schemeName: "green",
    scheme: {
      iconHoverColor: COLOR_GREEN_ACTIVE
    }
  }
];
export const INPUT_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "bright",
    scheme: {
      background: COLOR_BRIGHT,
      backgroundActive: COLOR_BRIGHT,
      borderColor: COLOR_MIDDLE_GREY,
      borderHoverColor: COLOR_DARK_GREY,
      borderActiveColor: COLOR_BLUE,
      borderHoverColorActive: COLOR_DARK_GREY,
      labelColor: COLOR_DARK,
      labelColorActive: COLOR_DARK,
      errorMessageColor: COLOR_RED,
      trailingIconColor: COLOR_DARK,
      disabledBackgroundColor: COLOR_LIGHT_GREY,
      disabledBorderColor: COLOR_LIGHT_GREY,
      disabledTrailingIconColor: COLOR_DARK,
      disabledLabelColor: COLOR_DARK_OPACITY_40,
      disabledOpacity: 0.4,
      optionsBackgroundColor: COLOR_BRIGHT,
      optionsBorderBottomColor: COLOR_TRANSPARENT,
      optionsBackgroundColorHover: COLOR_LIGHT_GREY
    }
  },
  {
    schemeName: "dark",
    scheme: {
      borderColor: COLOR_LIGHT_GREY,
      borderHoverColor: COLOR_DARK_GREY,
      borderActiveColor: COLOR_LIGHTBLUE,
      labelColor: COLOR_DARK,
      labelColorActive: COLOR_DARK,
      errorMessageColor: COLOR_RED,
      trailingIconBackgroundColor: COLOR_MIDDLE_GREY,
      trailingIconColor: COLOR_DARK,
      trailingIconColorActive: COLOR_DARK,
      disabledBackgroundColor: COLOR_BRIGHT,
      disabledBorderColor: COLOR_LIGHT_GREY,
      disabledTrailingIconColor: COLOR_MIDDLE_GREY,
      disabledOpacity: 0.6,
      optionsBackgroundColor: COLOR_BRIGHT,
      optionsBorderHoverColor: COLOR_DARK_GREY,
      optionsBorderBottomColor: COLOR_LIGHT_GREY,
      optionsBackgroundColorHover: COLOR_MIDDLE_GREY,
      optionsBackgroundColorActive: COLOR_LIGHTER_BLUE
    }
  }
];
export const LINK_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "blue",
    scheme: {
      contentHoverColor: COLOR_BLUE_ACTIVE
    }
  },
  {
    schemeName: "green",
    scheme: {
      contentHoverColor: COLOR_GREEN_ACTIVE
    }
  },
  {
    schemeName: "orange",
    scheme: {
      contentHoverColor: COLOR_ORANGE_ACTIVE
    }
  },
  {
    schemeName: "teal",
    scheme: {
      contentHoverColor: COLOR_TEAL_ACTIVE
    }
  },
  {
    schemeName: "bright",
    scheme: {
      contentHoverColor: COLOR_BRIGHT_OPACITY_85
    }
  },
  {
    schemeName: "white",
    scheme: {
      contentHoverColor: COLOR_WHITE_OPACITY_85
    }
  },
  {
    schemeName: "grey"
  },
  {
    schemeName: "dark"
  }
];
export const LINKLIST_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "green",
    scheme: {
      linklistHoverColor: COLOR_GREEN_ACTIVE
    }
  },
  {
    schemeName: "blue",
    scheme: {
      linklistHoverColor: COLOR_BLUE_ACTIVE
    }
  },
  {
    schemeName: "orange",
    scheme: {
      linklistHoverColor: COLOR_ORANGE_ACTIVE
    }
  },
  {
    schemeName: "teal",
    scheme: {
      linklistHoverColor: COLOR_TEAL_ACTIVE
    }
  },
  {
    schemeName: "bright",
    scheme: {
      linklistHoverColor: COLOR_BRIGHT_OPACITY_85
    }
  },
  {
    schemeName: "dark"
  }
];
export const MAP_INFO_LAYER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "green",
    scheme: {
      headerBackgroundColor: COLOR_GREEN_ACTIVE,
      contentColor: COLOR_BRIGHT,
      contentBackgroundColor: COLOR_GREEN
    }
  },
  {
    schemeName: "teal",
    scheme: {
      headerBackgroundColor: COLOR_TEAL_ACTIVE,
      contentColor: COLOR_BRIGHT,
      contentBackgroundColor: COLOR_TEAL
    }
  },
  {
    schemeName: "orange",
    scheme: {
      headerBackgroundColor: COLOR_ORANGE_ACTIVE,
      contentColor: COLOR_BRIGHT,
      contentBackgroundColor: COLOR_ORANGE
    }
  },
  {
    schemeName: "blue",
    scheme: {
      headerBackgroundColor: COLOR_BLUE_ACTIVE,
      contentColor: COLOR_BRIGHT,
      contentBackgroundColor: COLOR_BLUE
    }
  },
  {
    schemeName: "bright",
    scheme: {
      headerBackgroundColor: COLOR_LIGHT_GREY,
      contentColor: COLOR_DARK,
      contentBackgroundColor: COLOR_BRIGHT
    }
  },
  {
    schemeName: "dark"
  }
];
export const MULTI_CONTENT_STAGE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "blue",
    scheme: {
      backgroundColor: COLOR_BLUE,
      color: COLOR_BRIGHT,
      activeBackgroundColor: COLOR_BLUE_ACTIVE,
      loadingBarColor: COLOR_ORANGE,
      controlColor: COLOR_BRIGHT,
      controlColorHover: COLOR_LIGHT_GREY,
      controlIconColor: COLOR_DARK,
      controlIconColorHover: COLOR_DARK
    }
  },
  {
    schemeName: "green",
    scheme: {
      backgroundColor: COLOR_GREEN,
      color: COLOR_BRIGHT,
      activeBackgroundColor: COLOR_GREEN_ACTIVE,
      loadingBarColor: COLOR_ORANGE,
      controlColor: COLOR_BRIGHT,
      controlColorHover: COLOR_LIGHT_GREY,
      controlIconColor: COLOR_DARK,
      controlIconColorHover: COLOR_DARK
    }
  },
  {
    schemeName: "orange",
    scheme: {
      backgroundColor: COLOR_ORANGE,
      color: COLOR_BRIGHT,
      activeBackgroundColor: COLOR_ORANGE_ACTIVE,
      loadingBarColor: COLOR_BLUE,
      controlColor: COLOR_BRIGHT,
      controlColorHover: COLOR_LIGHT_GREY,
      controlIconColor: COLOR_DARK,
      controlIconColorHover: COLOR_DARK
    }
  },
  {
    schemeName: "teal",
    scheme: {
      backgroundColor: COLOR_TEAL,
      color: COLOR_BRIGHT,
      activeBackgroundColor: COLOR_TEAL_ACTIVE,
      loadingBarColor: COLOR_ORANGE,
      controlColor: COLOR_BRIGHT,
      controlColorHover: COLOR_LIGHT_GREY,
      controlIconColor: COLOR_DARK,
      controlIconColorHover: COLOR_DARK
    }
  },
  {
    schemeName: "bright",
    scheme: {
      backgroundColor: COLOR_BRIGHT,
      color: COLOR_DARK,
      activeBackgroundColor: COLOR_BRIGHT,
      loadingBarColor: COLOR_BLUE,
      controlColor: COLOR_BLUE,
      controlColorHover: COLOR_BLUE_ACTIVE,
      controlIconColor: COLOR_BRIGHT,
      controlIconColorHover: COLOR_BRIGHT
    }
  },
  {
    schemeName: "lightGrey",
    scheme: {
      backgroundColor: COLOR_LIGHT_GREY,
      color: COLOR_DARK,
      activeBackgroundColor: COLOR_LIGHT_GREY_50,
      loadingBarColor: COLOR_BLUE,
      controlColor: COLOR_BLUE,
      controlColorHover: COLOR_BLUE_ACTIVE,
      controlIconColor: COLOR_BRIGHT,
      controlIconColorHover: COLOR_BRIGHT
    }
  }
];
export const NUMBER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "green"
  },
  {
    schemeName: "blue"
  },
  {
    schemeName: "bright"
  },
  {
    schemeName: "orange"
  },
  {
    schemeName: "teal"
  },
  {
    schemeName: "dark"
  }
];
export const OFFSET_TEASER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "bright",
    scheme: {
      contentColor: COLOR_DARK,
      innerBackgroundColor: COLOR_LIGHT_GREY,
      visibleBackgroundColor: COLOR_LIGHT_GREY,
      linkColor: COLOR_BLUE,
      linkHoverColor: COLOR_BLUE_ACTIVE,
      headlineColor: COLOR_BLUE,
      headlineColorOffset: COLOR_BLUE
    }
  },
  {
    schemeName: "whiteOnLightGrey",
    scheme: {
      contentColor: COLOR_DARK,
      innerBackgroundColor: COLOR_BRIGHT,
      visibleBackgroundColor: COLOR_BRIGHT,
      linkColor: COLOR_BLUE,
      linkHoverColor: COLOR_BLUE_ACTIVE,
      headlineColor: COLOR_BLUE,
      headlineColorOffset: COLOR_BLUE
    }
  },
  {
    schemeName: "lightGrey",
    scheme: {
      contentColor: COLOR_DARK,
      innerBackgroundColor: COLOR_MIDDLE_GREY,
      visibleBackgroundColor: COLOR_MIDDLE_GREY,
      linkColor: COLOR_BLUE,
      linkHoverColor: COLOR_BLUE_ACTIVE,
      headlineColor: COLOR_BLUE,
      headlineColorOffset: COLOR_BLUE
    }
  },
  {
    schemeName: "blue",
    scheme: {
      contentColor: COLOR_BRIGHT,
      innerBackgroundColor: COLOR_BLUE,
      visibleBackgroundColor: COLOR_BLUE,
      linkColor: COLOR_BRIGHT,
      linkHoverColor: COLOR_BRIGHT_OPACITY_85,
      headlineColor: COLOR_BRIGHT,
      headlineColorOffset: COLOR_BLUE
    }
  },
  {
    schemeName: "lightblue",
    scheme: {
      contentColor: COLOR_DARK,
      innerBackgroundColor: COLOR_LIGHTBLUE,
      visibleBackgroundColor: COLOR_LIGHTBLUE,
      linkColor: COLOR_BLUE,
      linkHoverColor: COLOR_BLUE_ACTIVE,
      headlineColor: COLOR_DARK,
      headlineColorOffset: COLOR_BLUE
    }
  },
  {
    schemeName: "lightgreen",
    scheme: {
      contentColor: COLOR_DARK,
      innerBackgroundColor: COLOR_LIGHTGREEN,
      visibleBackgroundColor: COLOR_LIGHTGREEN,
      linkColor: COLOR_BLUE,
      linkHoverColor: COLOR_BLUE_ACTIVE,
      headlineColor: COLOR_DARK,
      headlineColorOffset: COLOR_GREEN
    }
  },
  {
    schemeName: "lightorange",
    scheme: {
      contentColor: COLOR_DARK,
      innerBackgroundColor: COLOR_LIGHTORANGE,
      linkColor: COLOR_BLUE,
      linkHoverColor: COLOR_BLUE_ACTIVE,
      headlineColor: COLOR_DARK,
      headlineColorOffset: COLOR_ORANGE
    }
  },
  {
    schemeName: "green",
    scheme: {
      contentColor: COLOR_BRIGHT,
      innerBackgroundColor: COLOR_GREEN,
      visibleBackgroundColor: COLOR_GREEN,
      linkColor: COLOR_BRIGHT,
      linkHoverColor: COLOR_BRIGHT_OPACITY_85,
      headlineColor: COLOR_BRIGHT,
      headlineColorOffset: COLOR_GREEN
    }
  },
  {
    schemeName: "orange",
    scheme: {
      contentColor: COLOR_BRIGHT,
      innerBackgroundColor: COLOR_ORANGE,
      visibleBackgroundColor: COLOR_ORANGE,
      linkColor: COLOR_BRIGHT,
      linkHoverColor: COLOR_BRIGHT_OPACITY_85,
      headlineColor: COLOR_BRIGHT,
      headlineColorOffset: COLOR_ORANGE
    }
  },
  {
    schemeName: "teal",
    scheme: {
      contentColor: COLOR_BRIGHT,
      innerBackgroundColor: COLOR_TEAL,
      visibleBackgroundColor: COLOR_TEAL,
      linkColor: COLOR_BRIGHT,
      linkHoverColor: COLOR_BRIGHT_OPACITY_85,
      headlineColor: COLOR_BRIGHT,
      headlineColorOffset: COLOR_TEAL
    }
  },
  {
    schemeName: "turquoise",
    scheme: {
      contentColor: COLOR_BRIGHT,
      innerBackgroundColor: COLOR_TURQUOISE,
      visibleBackgroundColor: COLOR_TURQUOISE,
      linkColor: COLOR_BRIGHT,
      linkHoverColor: COLOR_BRIGHT_OPACITY_85,
      headlineColor: COLOR_BRIGHT,
      headlineColorOffset: COLOR_TURQUOISE
    }
  },
  {
    schemeName: "whiteOnBlue",
    scheme: {
      contentColor: COLOR_DARK,
      innerBackgroundColor: COLOR_BRIGHT,
      visibleBackgroundColor: COLOR_BRIGHT,
      linkColor: COLOR_BLUE,
      linkHoverColor: COLOR_BLUE_ACTIVE,
      headlineColor: COLOR_BLUE,
      headlineColorOffset: COLOR_BRIGHT
    }
  }
];
export const OFFSET_TEASER5_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "blue"
  },
  {
    schemeName: "green"
  },
  {
    schemeName: "orange"
  },
  {
    schemeName: "teal"
  },
  {
    schemeName: "turquoise"
  },
  {
    schemeName: "lightblue"
  },
  {
    schemeName: "lightorange"
  },
  {
    schemeName: "lightGrey"
  },
  {
    schemeName: "bright"
  },
  {
    schemeName: "lightgreen"
  }
];
export const OPTION_PICKER_ITEM_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "green"
  },
  {
    schemeName: "blue"
  },
  {
    schemeName: "orange"
  },
  {
    schemeName: "teal"
  },
  {
    schemeName: "turquoise"
  },
  {
    schemeName: "bright"
  },
  {
    schemeName: "dark"
  }
];
export const PAGINATION_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "blue"
  }
];
export const PRELOADER_CIRCLE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "colorful",
    scheme: {
      spinnerColor: COLOR_BLUE,
      trackColor: COLOR_DARK_OPACITY_5
    }
  },
  {
    schemeName: "green",
    scheme: {
      trackColor: COLOR_DARK_OPACITY_5
    }
  },
  {
    schemeName: "blue",
    scheme: {
      trackColor: COLOR_DARK_OPACITY_5
    }
  },
  {
    schemeName: "orange",
    scheme: {
      trackColor: COLOR_DARK_OPACITY_5
    }
  },
  {
    schemeName: "bright",
    scheme: {
      spinnerColor: COLOR_BRIGHT,
      trackColor: COLOR_BRIGHT_OPACITY_20
    }
  },
  {
    schemeName: "dark"
  }
];
export const PRELOADER_SQUARES_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "green",
    scheme: {
      color: COLOR_MIDDLE_GREY
    }
  },
  {
    schemeName: "blue",
    scheme: {
      color: COLOR_MIDDLE_GREY
    }
  },
  {
    schemeName: "turquoise",
    scheme: {
      color: COLOR_MIDDLE_GREY
    }
  },
  {
    schemeName: "orange",
    scheme: {
      color: COLOR_MIDDLE_GREY
    }
  },
  {
    schemeName: "bright",
    scheme: {
      color: COLOR_BRIGHT
    }
  },
  {
    schemeName: "dark",
    scheme: {
      color: COLOR_DARK
    }
  }
];
export const PROGRESS_CIRCLE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "green",
    scheme: {
      textColor: COLOR_BRIGHT,
      backgroundColor: COLOR_GREEN,
      progressBackgroundColor: COLOR_BRIGHT_OPACITY_30,
      progressColor: COLOR_BRIGHT,
      iconColorOnHover: COLOR_GREEN_ACTIVE,
      progressBackgroundColorOnHover: COLOR_BRIGHT_OPACITY_30,
      progressColorOnHover: COLOR_BRIGHT
    }
  },
  {
    schemeName: "orange",
    scheme: {
      textColor: COLOR_BRIGHT,
      backgroundColor: COLOR_ORANGE,
      progressBackgroundColor: COLOR_BRIGHT_OPACITY_30,
      progressColor: COLOR_BRIGHT,
      iconColorOnHover: COLOR_ORANGE_ACTIVE,
      progressBackgroundColorOnHover: COLOR_BRIGHT_OPACITY_30,
      progressColorOnHover: COLOR_BRIGHT
    }
  },
  {
    schemeName: "blue",
    scheme: {
      textColor: COLOR_BRIGHT,
      backgroundColor: COLOR_BLUE,
      progressBackgroundColor: COLOR_BRIGHT_OPACITY_30,
      progressColor: COLOR_BRIGHT,
      iconColorOnHover: COLOR_BLUE_ACTIVE,
      progressBackgroundColorOnHover: COLOR_BRIGHT_OPACITY_30,
      progressColorOnHover: COLOR_BRIGHT
    }
  },
  {
    schemeName: "teal",
    scheme: {
      textColor: COLOR_BRIGHT,
      backgroundColor: COLOR_TEAL,
      progressBackgroundColor: COLOR_BRIGHT_OPACITY_30,
      progressColor: COLOR_BRIGHT,
      iconColorOnHover: COLOR_TEAL_ACTIVE,
      progressBackgroundColorOnHover: COLOR_BRIGHT_OPACITY_30,
      progressColorOnHover: COLOR_BRIGHT
    }
  },
  {
    schemeName: "bright",
    scheme: {
      textColor: COLOR_BLUE,
      iconColor: COLOR_BLUE,
      backgroundColor: COLOR_BRIGHT,
      progressBackgroundColor: COLOR_LIGHT_GREY,
      progressColor: COLOR_BLUE,
      iconColorOnHover: COLOR_DARK,
      progressBackgroundColorOnHover: COLOR_LIGHT_GREY,
      progressColorOnHover: COLOR_MIDDLE_GREY,
      progressSuccessColor: COLOR_BLUE,
      iconSuccessColor: COLOR_BLUE
    }
  },
  {
    schemeName: "dark"
  },
  {
    schemeName: "red"
  }
];
export const PROMO_FLAG_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "green",
    scheme: {
      textColor: COLOR_BRIGHT
    }
  },
  {
    schemeName: "blue",
    scheme: {
      textColor: COLOR_BRIGHT
    }
  },
  {
    schemeName: "orange",
    scheme: {
      textColor: COLOR_BRIGHT
    }
  },
  {
    schemeName: "teal",
    scheme: {
      textColor: COLOR_BRIGHT
    }
  },
  {
    schemeName: "bright",
    scheme: {
      textColor: COLOR_DARK
    }
  },
  {
    schemeName: "lightGrey",
    scheme: {
      textColor: COLOR_DARK
    }
  },
  {
    schemeName: "dark"
  }
];
export const PAGE_HEADER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "green",
    scheme: {
      wideShade: COLOR_GREEN_ACTIVE,
      narrowShade: COLOR_TEAL
    }
  },
  {
    schemeName: "blue",
    scheme: {
      wideShade: COLOR_BLUE_ACTIVE,
      narrowShade: COLOR_ORANGE
    }
  },
  {
    schemeName: "orange",
    scheme: {
      wideShade: COLOR_ORANGE_ACTIVE,
      narrowShade: COLOR_TEAL
    }
  },
  {
    schemeName: "bright",
    scheme: {
      contentColor: COLOR_DARK,
      wideShade: COLOR_BRIGHT,
      narrowShade: COLOR_BLUE
    }
  },
  {
    schemeName: "lightGrey",
    scheme: {
      contentColor: COLOR_DARK,
      narrowShade: COLOR_BLUE
    }
  }
];
export const PICTOGRAM_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "green"
  },
  {
    schemeName: "blue"
  },
  {
    schemeName: "orange"
  },
  {
    schemeName: "teal"
  },
  {
    schemeName: "turquoise"
  },
  {
    schemeName: "bright"
  },
  {
    schemeName: "dark"
  }
];
export const RADIO_BUTTON_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "blue",
    scheme: {
      labelColor: COLOR_DARK,
      uncheckedColor: COLOR_MIDDLE_GREY,
      checkedHoverColor: COLOR_BLUE_ACTIVE,
      errorColor: COLOR_RED,
      disabledLabelColor: COLOR_DARK_OPACITY_60
    }
  },
  {
    schemeName: "green",
    scheme: {
      labelColor: COLOR_DARK,
      uncheckedColor: COLOR_MIDDLE_GREY,
      checkedHoverColor: COLOR_GREEN_ACTIVE,
      errorColor: COLOR_RED,
      disabledLabelColor: COLOR_DARK_OPACITY_60
    }
  },
  {
    schemeName: "orange",
    scheme: {
      labelColor: COLOR_DARK,
      uncheckedColor: COLOR_MIDDLE_GREY,
      checkedHoverColor: COLOR_ORANGE_ACTIVE,
      errorColor: COLOR_RED,
      disabledLabelColor: COLOR_DARK_OPACITY_60
    }
  },
  {
    schemeName: "inverted",
    scheme: {
      labelColor: COLOR_BRIGHT,
      uncheckedColor: COLOR_BRIGHT,
      uncheckedHoverColor: COLOR_BRIGHT,
      focusColor: COLOR_BRIGHT_OPACITY_75,
      checkedColor: COLOR_BRIGHT,
      checkedHoverColor: COLOR_BRIGHT_OPACITY_75,
      errorColor: COLOR_BRIGHT,
      inverted: true,
      disabledLabelColor: COLOR_BRIGHT_OPACITY_60
    }
  },
  {
    schemeName: "dark",
    scheme: {
      labelColor: COLOR_DARK,
      uncheckedColor: COLOR_DARK,
      uncheckedHoverColor: COLOR_DARK_OPACITY_80,
      focusColor: COLOR_DARK_OPACITY_80,
      checkedHoverColor: COLOR_DARK_OPACITY_80,
      errorColor: COLOR_RED,
      disabledLabelColor: COLOR_DARK_OPACITY_60
    }
  }
];
export const READ_MORE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "blue"
  },
  {
    schemeName: "darkOnBright",
    scheme: {
      rulerColor: COLOR_DARK,
      rulerButtonHoverColor: COLOR_BLUE_ACTIVE,
      rulerArrowColor: COLOR_BRIGHT,
      rulerColorHover: COLOR_BLUE_ACTIVE
    }
  },
  {
    schemeName: "darkOnLightGrey",
    scheme: {
      rulerColor: COLOR_DARK,
      rulerButtonHoverColor: COLOR_BLUE_ACTIVE,
      rulerArrowColor: COLOR_BRIGHT,
      rulerColorHover: COLOR_BLUE_ACTIVE
    }
  },
  {
    schemeName: "brightOnBlue",
    scheme: {
      rulerColor: COLOR_BRIGHT,
      rulerButtonHoverColor: COLOR_BLUE_15,
      rulerArrowColor: COLOR_DARK,
      rulerColorHover: COLOR_BLUE_15
    }
  },
  {
    schemeName: "brightOnGreen",
    scheme: {
      rulerColor: COLOR_BRIGHT,
      rulerButtonHoverColor: COLOR_GREEN_15,
      rulerArrowColor: COLOR_DARK,
      rulerColorHover: COLOR_GREEN_15
    }
  },
  {
    schemeName: "brightOnOrange",
    scheme: {
      rulerColor: COLOR_BRIGHT,
      rulerButtonHoverColor: COLOR_ORANGE_15,
      rulerArrowColor: COLOR_DARK,
      rulerColorHover: COLOR_ORANGE_15
    }
  },
  {
    schemeName: "brightOnTeal",
    scheme: {
      rulerColor: COLOR_TEAL,
      rulerButtonHoverColor: COLOR_TEAL_15,
      rulerArrowColor: COLOR_DARK,
      rulerColorHover: COLOR_TEAL_15
    }
  }
];
export const RTE_RENDERER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "bright",
    scheme: {
      paragraphColor: COLOR_BRIGHT,
      sublineColor: COLOR_BRIGHT,
      blockquoteColor: COLOR_BRIGHT
    }
  },
  {
    schemeName: "blue",
    scheme: {
      paragraphColor: COLOR_DARK,
      blockquoteColor: COLOR_DARK
    }
  },
  {
    schemeName: "green",
    scheme: {
      paragraphColor: COLOR_DARK,
      blockquoteColor: COLOR_DARK
    }
  },
  {
    schemeName: "orange",
    scheme: {
      paragraphColor: COLOR_DARK,
      blockquoteColor: COLOR_DARK
    }
  },
  {
    schemeName: "teal",
    scheme: {
      paragraphColor: COLOR_DARK,
      blockquoteColor: COLOR_DARK
    }
  },
  {
    schemeName: "dark"
  }
];
export const SECTION_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "green"
  },
  {
    schemeName: "blue"
  },
  {
    schemeName: "orange"
  },
  {
    schemeName: "teal"
  },
  {
    schemeName: "turquoise"
  },
  {
    schemeName: "lightblue"
  },
  {
    schemeName: "lightgreen"
  },
  {
    schemeName: "lightorange"
  },
  {
    schemeName: "transparent"
  },
  {
    schemeName: "bright",
    scheme: {
      footerSeparatorColor: COLOR_LIGHT_GREY
    }
  },
  {
    schemeName: "lightGrey"
  }
];
export const SEARCH_RESULT_ITEM_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "lightGrey",
    scheme: {
      contentBackground: COLOR_LIGHT_GREY,
      descriptionBackground: COLOR_MIDDLE_GREY,
      descriptionBackgroundHoverColor: COLOR_MIDDLE_GREY,
      highlightColor: COLOR_BLUE
    }
  },
  {
    schemeName: "brightWithLightGreyDescription",
    scheme: {
      contentBackground: COLOR_BRIGHT,
      descriptionBackground: COLOR_LIGHT_GREY,
      descriptionBackgroundHoverColor: COLOR_LIGHT_GREY,
      highlightColor: COLOR_BLUE,
      contentFontColor: COLOR_DARK,
      descriptionFontColor: COLOR_DARK,
      dividerColor: COLOR_DARK
    }
  },
  {
    schemeName: "bright",
    scheme: {
      contentBackground: COLOR_BRIGHT,
      descriptionBackground: COLOR_BRIGHT_OPACITY_90,
      descriptionBackgroundHoverColor: COLOR_BRIGHT_OPACITY_90,
      highlightColor: COLOR_DARK
    }
  },
  {
    schemeName: "dark"
  }
];
export const SEGMENTED_BUTTON_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "bright"
  },
  {
    schemeName: "dark"
  }
];
export const SITELINK_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "brightBlue",
    scheme: {
      linkColor: COLOR_DARK,
      linkHoverColor: COLOR_DARK
    }
  },
  {
    schemeName: "brightBlueOnLightGrey",
    scheme: {
      linkColor: COLOR_DARK,
      linkHoverColor: COLOR_DARK
    }
  },
  {
    schemeName: "brightGreen",
    scheme: {
      linkColor: COLOR_DARK,
      linkHoverColor: COLOR_DARK
    }
  },
  {
    schemeName: "brightGreenOnLightGrey",
    scheme: {
      linkColor: COLOR_DARK,
      linkHoverColor: COLOR_DARK
    }
  },
  {
    schemeName: "blue",
    scheme: {
      linkHoverColor: COLOR_BRIGHT
    }
  },
  {
    schemeName: "green",
    scheme: {
      linkHoverColor: COLOR_BRIGHT
    }
  },
  {
    schemeName: "orange",
    scheme: {
      linkHoverColor: COLOR_BRIGHT
    }
  },
  {
    schemeName: "teal",
    scheme: {
      linkHoverColor: COLOR_BRIGHT
    }
  },
  {
    schemeName: "bright"
  }
];
export const SLIDER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "green",
    scheme: {
      knobColor: COLOR_BRIGHT,
      knobHoverColor: COLOR_BRIGHT,
      knobBorderColor: COLOR_GREEN,
      knobBorderHoverColor: COLOR_GREEN,
      barColor: COLOR_DARK_25,
      barActiveColor: COLOR_GREEN_ACTIVE,
      pipColor: COLOR_MIDDLE_GREY,
      pipTextColor: COLOR_MIDDLE_GREY,
      pipHoverColor: COLOR_BASE_GREY,
      errorColor: COLOR_RED
    }
  },
  {
    schemeName: "blue",
    scheme: {
      knobColor: COLOR_BRIGHT,
      knobHoverColor: COLOR_BRIGHT,
      knobBorderColor: COLOR_BLUE,
      knobBorderHoverColor: COLOR_BLUE,
      barColor: COLOR_DARK_25,
      barActiveColor: COLOR_BLUE_ACTIVE,
      pipColor: COLOR_MIDDLE_GREY,
      pipTextColor: COLOR_MIDDLE_GREY,
      pipHoverColor: COLOR_BASE_GREY,
      errorColor: COLOR_RED
    }
  },
  {
    schemeName: "orange",
    scheme: {
      knobColor: COLOR_BRIGHT,
      knobHoverColor: COLOR_BRIGHT,
      knobBorderColor: COLOR_ORANGE,
      knobBorderHoverColor: COLOR_ORANGE,
      barColor: COLOR_DARK_25,
      barActiveColor: COLOR_ORANGE_ACTIVE,
      pipColor: COLOR_MIDDLE_GREY,
      pipTextColor: COLOR_MIDDLE_GREY,
      pipHoverColor: COLOR_BASE_GREY,
      errorColor: COLOR_RED
    }
  },
  {
    schemeName: "teal",
    scheme: {
      knobColor: COLOR_BRIGHT,
      knobHoverColor: COLOR_BRIGHT,
      knobBorderColor: COLOR_TEAL,
      knobBorderHoverColor: COLOR_TEAL,
      barColor: COLOR_DARK_25,
      barActiveColor: COLOR_TEAL_ACTIVE,
      pipColor: COLOR_MIDDLE_GREY,
      pipTextColor: COLOR_MIDDLE_GREY,
      pipHoverColor: COLOR_BASE_GREY,
      errorColor: COLOR_RED
    }
  },
  {
    schemeName: "brightOnGreen",
    scheme: {
      knobColor: COLOR_GREEN,
      knobHoverColor: COLOR_GREEN,
      knobBorderColor: COLOR_BRIGHT,
      knobBorderHoverColor: COLOR_BRIGHT,
      barColor: COLOR_BRIGHT_OPACITY_30,
      barActiveColor: COLOR_BRIGHT,
      pipColor: COLOR_BRIGHT_OPACITY_80,
      pipTextColor: COLOR_BRIGHT_OPACITY_80,
      pipHoverColor: COLOR_BRIGHT,
      errorColor: COLOR_BRIGHT
    }
  },
  {
    schemeName: "brightOnBlue",
    scheme: {
      knobColor: COLOR_BLUE,
      knobHoverColor: COLOR_BLUE,
      knobBorderColor: COLOR_BRIGHT,
      knobBorderHoverColor: COLOR_BRIGHT,
      barColor: COLOR_BRIGHT_OPACITY_30,
      barActiveColor: COLOR_BRIGHT,
      pipColor: COLOR_BRIGHT_OPACITY_80,
      pipTextColor: COLOR_BRIGHT_OPACITY_80,
      pipHoverColor: COLOR_BRIGHT,
      errorColor: COLOR_BRIGHT
    }
  },
  {
    schemeName: "brightOnOrange",
    scheme: {
      knobColor: COLOR_ORANGE,
      knobHoverColor: COLOR_ORANGE,
      knobBorderColor: COLOR_BRIGHT,
      knobBorderHoverColor: COLOR_BRIGHT,
      barColor: COLOR_BRIGHT_OPACITY_30,
      barActiveColor: COLOR_BRIGHT,
      pipColor: COLOR_BRIGHT_OPACITY_80,
      pipTextColor: COLOR_BRIGHT_OPACITY_80,
      pipHoverColor: COLOR_BRIGHT,
      errorColor: COLOR_BRIGHT
    }
  },
  {
    schemeName: "bright"
  },
  {
    schemeName: "dark"
  }
];
export const SWITCH_TOGGLE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "blue",
    scheme: {
      labelColor: COLOR_DARK,
      uncheckedColor: COLOR_MIDDLE_GREY,
      errorColor: COLOR_RED,
      disabledUncheckedColor: COLOR_LIGHT_GREY,
      disabledLabelColor: COLOR_DARK_OPACITY_60
    }
  },
  {
    schemeName: "inverted",
    scheme: {
      labelColor: COLOR_BRIGHT,
      uncheckedColor: COLOR_BRIGHT,
      uncheckedHoverColor: COLOR_BRIGHT_OPACITY_75,
      focusColor: COLOR_BRIGHT_OPACITY_75,
      checkedColor: COLOR_BRIGHT,
      checkedHoverColor: COLOR_BRIGHT_OPACITY_75,
      errorColor: COLOR_BRIGHT,
      isInverted: true,
      disabledUncheckedColor: COLOR_BRIGHT_OPACITY_60,
      disabledCheckedColor: COLOR_BRIGHT_OPACITY_60,
      disabledLabelColor: COLOR_BRIGHT_OPACITY_60
    }
  },
  {
    schemeName: "dark",
    scheme: {
      labelColor: COLOR_DARK,
      uncheckedColor: COLOR_DARK,
      uncheckedHoverColor: COLOR_DARK_OPACITY_80,
      focusColor: COLOR_DARK_OPACITY_80,
      checkedColor: COLOR_DARK,
      checkedHoverColor: COLOR_DARK_OPACITY_80,
      errorColor: COLOR_RED,
      isInverted: true,
      disabledUncheckedColor: COLOR_DARK_OPACITY_60,
      disabledLabelColor: COLOR_DARK_OPACITY_60
    }
  },
  {
    schemeName: "green",
    scheme: {
      labelColor: COLOR_DARK,
      uncheckedColor: COLOR_MIDDLE_GREY,
      errorColor: COLOR_RED,
      disabledUncheckedColor: COLOR_LIGHT_GREY,
      disabledLabelColor: COLOR_DARK_OPACITY_60
    }
  },
  {
    schemeName: "bright"
  }
];
export const STAGE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "blue",
    scheme: {
      subheadlineColor: COLOR_BLUE,
      headlineScheme: "blue",
      linkScheme: "blue"
    }
  },
  {
    schemeName: "bright",
    scheme: {
      headlineScheme: "bright",
      linkScheme: "bright"
    }
  }
];
export const STATE_PILL_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "active",
    scheme: {
      primaryBackgroundColor: COLOR_SYSTEM_SUCCESS_LIGHT,
      secondaryBackgroundColor: COLOR_SYSTEM_SUCCESS_DARK,
      primaryTextAndIconColor: COLOR_GREY900,
      secondaryTextAndIconColor: COLOR_WHITE
    }
  },
  {
    schemeName: "pending",
    scheme: {
      primaryBackgroundColor: COLOR_SYSTEM_HIGHLIGHT_LIGHT,
      secondaryBackgroundColor: COLOR_SYSTEM_HIGHLIGHT,
      primaryTextAndIconColor: COLOR_GREY900,
      secondaryTextAndIconColor: COLOR_WHITE
    }
  },
  {
    schemeName: "error",
    scheme: {
      primaryBackgroundColor: COLOR_SYSTEM_ERROR_LIGHT,
      secondaryBackgroundColor: COLOR_SYSTEM_ERROR_DARK,
      primaryTextAndIconColor: COLOR_GREY900,
      secondaryTextAndIconColor: COLOR_WHITE
    }
  },
  {
    schemeName: "warning",
    scheme: {
      primaryBackgroundColor: COLOR_SYSTEM_WARNING_LIGHT,
      secondaryBackgroundColor: COLOR_SYSTEM_WARNING,
      primaryTextAndIconColor: COLOR_GREY900,
      secondaryTextAndIconColor: COLOR_GREY900
    }
  },
  {
    schemeName: "inactive",
    scheme: {
      primaryBackgroundColor: COLOR_GREY200,
      secondaryBackgroundColor: COLOR_GREY700,
      primaryTextAndIconColor: COLOR_GREY900,
      secondaryTextAndIconColor: COLOR_WHITE
    }
  }
];
export const STEP_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "green",
    scheme: {
      inactiveStepColor: COLOR_DARK_25,
      activeStepMobileBorder: COLOR_GREEN_OPACITY_30,
      inactiveIconColor: COLOR_BRIGHT,
      activeIconColor: COLOR_BRIGHT,
      doneIconColor: COLOR_BRIGHT,
      activeTextColor: COLOR_DARK,
      inactiveTextColor: COLOR_MIDDLE_GREY,
      doneTextColor: COLOR_MIDDLE_GREY
    }
  },
  {
    schemeName: "blue",
    scheme: {
      inactiveStepColor: COLOR_DARK_25,
      activeStepMobileBorder: COLOR_BLUE_OPACITY_30,
      inactiveIconColor: COLOR_BRIGHT,
      activeIconColor: COLOR_BRIGHT,
      doneIconColor: COLOR_BRIGHT,
      activeTextColor: COLOR_DARK,
      inactiveTextColor: COLOR_MIDDLE_GREY,
      doneTextColor: COLOR_MIDDLE_GREY
    }
  },
  {
    schemeName: "blueOnLightgrey",
    scheme: {
      activeStepColor: COLOR_BLUE,
      inactiveStepColor: COLOR_LIGHT_GREY_25,
      doneStepColor: COLOR_BLUE,
      activeStepMobileBorder: COLOR_BLUE_OPACITY_30,
      inactiveIconColor: COLOR_BLUE_OPACITY_75,
      activeIconColor: COLOR_LIGHT_GREY_25,
      doneIconColor: COLOR_LIGHT_GREY_25,
      activeTextColor: COLOR_DARK,
      inactiveTextColor: COLOR_DARK_OPACITY_75,
      doneTextColor: COLOR_DARK_OPACITY_75
    }
  },
  {
    schemeName: "brightOnBlue",
    scheme: {
      activeStepColor: COLOR_BRIGHT,
      inactiveStepColor: COLOR_BLUE_25,
      doneStepColor: COLOR_BRIGHT,
      activeStepMobileBorder: COLOR_BRIGHT_OPACITY_30,
      inactiveIconColor: COLOR_BLUE,
      activeIconColor: COLOR_BLUE,
      doneIconColor: COLOR_BLUE,
      activeTextColor: COLOR_BRIGHT,
      inactiveTextColor: COLOR_BLUE_25,
      doneTextColor: COLOR_BLUE_25
    }
  },
  {
    schemeName: "brightOnGreen",
    scheme: {
      activeStepColor: COLOR_BRIGHT,
      inactiveStepColor: COLOR_GREEN_25,
      doneStepColor: COLOR_BRIGHT,
      activeStepMobileBorder: COLOR_BRIGHT_OPACITY_30,
      inactiveIconColor: COLOR_GREEN,
      activeIconColor: COLOR_GREEN,
      doneIconColor: COLOR_GREEN,
      activeTextColor: COLOR_BRIGHT,
      inactiveTextColor: COLOR_GREEN_25,
      doneTextColor: COLOR_GREEN_25
    }
  },
  {
    schemeName: "brightOnOrange",
    scheme: {
      activeStepColor: COLOR_BRIGHT,
      inactiveStepColor: COLOR_ORANGE_25,
      doneStepColor: COLOR_BRIGHT,
      activeStepMobileBorder: COLOR_BRIGHT_OPACITY_30,
      inactiveIconColor: COLOR_ORANGE,
      activeIconColor: COLOR_ORANGE,
      doneIconColor: COLOR_ORANGE,
      activeTextColor: COLOR_BRIGHT,
      inactiveTextColor: COLOR_ORANGE_25,
      doneTextColor: COLOR_ORANGE_25
    }
  },
  {
    schemeName: "brightOnTeal",
    scheme: {
      activeStepColor: COLOR_BRIGHT,
      inactiveStepColor: COLOR_TEAL_25,
      doneStepColor: COLOR_BRIGHT,
      activeStepMobileBorder: COLOR_BRIGHT_OPACITY_30,
      inactiveIconColor: COLOR_TEAL,
      activeIconColor: COLOR_TEAL,
      doneIconColor: COLOR_TEAL,
      activeTextColor: COLOR_BRIGHT,
      inactiveTextColor: COLOR_TEAL_25,
      doneTextColor: COLOR_TEAL_25
    }
  },
  {
    schemeName: "bright"
  },
  {
    schemeName: "dark"
  }
];
export const STEPS_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "green",
    scheme: {}
  },
  {
    schemeName: "blue",
    scheme: {}
  },
  {
    schemeName: "brightOnBlue",
    scheme: {}
  },
  {
    schemeName: "brightOnGreen",
    scheme: {}
  },
  {
    schemeName: "brightOnOrange",
    scheme: {}
  },
  {
    schemeName: "brightOnTeal",
    scheme: {}
  },
  {
    schemeName: "blueOnLightGrey",
    scheme: {}
  },
  {
    schemeName: "bright"
  }
];
export const TABLE_RENDERER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "brightBlueHighlighting",
    scheme: {
      paragraphColor: COLOR_DARK,
      tableBorderColor: COLOR_DARK,
      tableHighlightColor: COLOR_BLUE_ACTIVE,
      tableBackgroundColor: COLOR_BRIGHT,
      tableAlternateBackgroundColor: COLOR_LIGHT_GREY
    }
  },
  {
    schemeName: "brightGreenHighlighting",
    scheme: {
      paragraphColor: COLOR_DARK,
      tableBorderColor: COLOR_DARK,
      tableHighlightColor: COLOR_GREEN,
      tableBackgroundColor: COLOR_BRIGHT,
      tableAlternateBackgroundColor: COLOR_LIGHT_GREY
    }
  },
  {
    schemeName: "lightGreyBlueHighlighting",
    scheme: {
      paragraphColor: COLOR_DARK,
      tableBorderColor: COLOR_DARK,
      tableHighlightColor: COLOR_BLUE_ACTIVE,
      tableBackgroundColor: COLOR_BRIGHT,
      tableAlternateBackgroundColor: COLOR_LIGHT_GREY
    }
  },
  {
    schemeName: "lightGreyGreenHighlighting",
    scheme: {
      paragraphColor: COLOR_DARK,
      tableBorderColor: COLOR_DARK,
      tableHighlightColor: COLOR_GREEN,
      tableBackgroundColor: COLOR_BRIGHT,
      tableAlternateBackgroundColor: COLOR_LIGHT_GREY
    }
  },
  {
    schemeName: "green",
    scheme: {
      paragraphColor: COLOR_BRIGHT,
      tableBorderColor: COLOR_BRIGHT,
      tableHighlightColor: COLOR_TEAL,
      tableBackgroundColor: COLOR_GREEN,
      tableAlternateBackgroundColor: COLOR_TEAL_ACTIVE
    }
  },
  {
    schemeName: "blue",
    scheme: {
      paragraphColor: COLOR_BRIGHT,
      tableBorderColor: COLOR_BRIGHT,
      tableHighlightColor: COLOR_ORANGE,
      tableBackgroundColor: COLOR_BLUE,
      tableAlternateBackgroundColor: COLOR_BLUE_ACTIVE
    }
  },
  {
    schemeName: "orange",
    scheme: {
      paragraphColor: COLOR_BRIGHT,
      tableBorderColor: COLOR_BRIGHT,
      tableHighlightColor: COLOR_BLUE_ACTIVE,
      tableBackgroundColor: COLOR_ORANGE,
      tableAlternateBackgroundColor: COLOR_ORANGE_ACTIVE
    }
  },
  {
    schemeName: "teal",
    scheme: {
      paragraphColor: COLOR_BRIGHT,
      tableBorderColor: COLOR_BRIGHT,
      tableHighlightColor: COLOR_ORANGE,
      tableBackgroundColor: COLOR_TEAL,
      tableAlternateBackgroundColor: COLOR_ORANGE_ACTIVE
    }
  }
];
export const TAB_NAVIGATION_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "bright"
  },
  {
    schemeName: "lightGrey"
  },
  {
    schemeName: "blue"
  },
  {
    schemeName: "blueOnLightblue"
  },
  {
    schemeName: "green"
  },
  {
    schemeName: "greenOnLightgreen"
  },
  {
    schemeName: "orange"
  },
  {
    schemeName: "orangeOnLightorange"
  },
  {
    schemeName: "teal"
  }
];
export const TABS_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "bright",
    scheme: {
      textColor: COLOR_DARK,
      tabBorderColor: COLOR_DARK_TABBAR_COLOR,
      tabActiveBorderColor: COLOR_DARK,
      tabHoverColor: COLOR_LIGHT_GREY,
      tabFocusColor: COLOR_LIGHT_GREY
    }
  },
  {
    schemeName: "blue",
    scheme: {
      textColor: COLOR_BRIGHT,
      tabBorderColor: COLOR_BRIGHT_TABBAR_COLOR,
      tabActiveBorderColor: COLOR_BRIGHT,
      tabHoverColor: COLOR_BLUE_ACTIVE,
      tabFocusColor: COLOR_BLUE_ACTIVE
    }
  },
  {
    schemeName: "green",
    scheme: {
      textColor: COLOR_BRIGHT,
      tabBorderColor: COLOR_BRIGHT_TABBAR_COLOR,
      tabActiveBorderColor: COLOR_BRIGHT,
      tabHoverColor: COLOR_GREEN_ACTIVE,
      tabFocusColor: COLOR_GREEN_ACTIVE
    }
  },
  {
    schemeName: "orange",
    scheme: {
      textColor: COLOR_BRIGHT,
      tabBorderColor: COLOR_BRIGHT_TABBAR_COLOR,
      tabActiveBorderColor: COLOR_BRIGHT,
      tabHoverColor: COLOR_ORANGE_ACTIVE,
      tabFocusColor: COLOR_ORANGE_ACTIVE
    }
  },
  {
    schemeName: "teal",
    scheme: {
      textColor: COLOR_BRIGHT,
      tabBorderColor: COLOR_BRIGHT_TABBAR_COLOR,
      tabActiveBorderColor: COLOR_BRIGHT,
      tabHoverColor: COLOR_TEAL_ACTIVE,
      tabFocusColor: COLOR_TEAL_ACTIVE
    }
  }
];
export const TAG_PILL_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "blue",
    scheme: {
      backgroundHoverColor: COLOR_BLUE_25,
      backgroundActiveHoverColor: COLOR_BLUE_ACTIVE,
      textAndIconHoverColor: COLOR_BLUE_ACTIVE,
      textAndIconActiveColor: COLOR_BRIGHT,
      textAndIconActiveHoverColor: COLOR_BRIGHT,
      borderColor: COLOR_BLUE_25
    }
  },
  {
    schemeName: "brightOnBlue",
    scheme: {
      backgroundHoverColor: COLOR_BRIGHT_OPACITY_50,
      backgroundActiveColor: COLOR_BRIGHT,
      backgroundActiveHoverColor: COLOR_BRIGHT_OPACITY_85,
      textAndIconColor: COLOR_BRIGHT,
      textAndIconHoverColor: COLOR_BRIGHT,
      textAndIconActiveColor: COLOR_BLUE,
      textAndIconActiveHoverColor: COLOR_BLUE_ACTIVE,
      borderColor: COLOR_BRIGHT_OPACITY_50,
      focusBorderColor: COLOR_BRIGHT_OPACITY_75
    }
  },
  {
    schemeName: "blueOnLightblue",
    scheme: {
      backgroundHoverColor: COLOR_BLUE,
      backgroundActiveHoverColor: COLOR_BLUE_ACTIVE,
      textAndIconHoverColor: COLOR_BLUE_ACTIVE,
      textAndIconActiveColor: COLOR_BLUE,
      textAndIconActiveHoverColor: COLOR_BLUE,
      borderColor: COLOR_BLUE_ACTIVE
    }
  },
  {
    schemeName: "green",
    scheme: {
      backgroundHoverColor: COLOR_GREEN_25,
      backgroundActiveHoverColor: COLOR_GREEN_ACTIVE,
      textAndIconColor: COLOR_DARK,
      textAndIconHoverColor: COLOR_GREEN_ACTIVE,
      textAndIconActiveColor: COLOR_BRIGHT,
      textAndIconActiveHoverColor: COLOR_BRIGHT,
      borderColor: COLOR_GREEN
    }
  },
  {
    schemeName: "brightOnGreen",
    scheme: {
      backgroundHoverColor: COLOR_BRIGHT_OPACITY_50,
      backgroundActiveColor: COLOR_BRIGHT,
      backgroundActiveHoverColor: COLOR_BRIGHT_OPACITY_85,
      textAndIconColor: COLOR_BRIGHT,
      textAndIconHoverColor: COLOR_BRIGHT,
      textAndIconActiveColor: COLOR_GREEN,
      textAndIconActiveHoverColor: COLOR_GREEN_ACTIVE,
      borderColor: COLOR_BRIGHT_OPACITY_50,
      focusBorderColor: COLOR_BRIGHT_OPACITY_75
    }
  },
  {
    schemeName: "orange",
    scheme: {
      backgroundHoverColor: COLOR_ORANGE_25,
      backgroundActiveHoverColor: COLOR_ORANGE_ACTIVE,
      textAndIconHoverColor: COLOR_ORANGE_ACTIVE,
      textAndIconActiveColor: COLOR_BRIGHT,
      textAndIconActiveHoverColor: COLOR_BRIGHT,
      borderColor: COLOR_ORANGE_25
    }
  },
  {
    schemeName: "brightOnOrange",
    scheme: {
      backgroundHoverColor: COLOR_BRIGHT_OPACITY_50,
      backgroundActiveColor: COLOR_BRIGHT,
      backgroundActiveHoverColor: COLOR_BRIGHT_OPACITY_85,
      textAndIconColor: COLOR_BRIGHT,
      textAndIconHoverColor: COLOR_BRIGHT,
      textAndIconActiveColor: COLOR_ORANGE,
      textAndIconActiveHoverColor: COLOR_ORANGE_ACTIVE,
      borderColor: COLOR_BRIGHT_OPACITY_50,
      focusBorderColor: COLOR_BRIGHT_OPACITY_75
    }
  },
  {
    schemeName: "brightOnTeal",
    scheme: {
      backgroundHoverColor: COLOR_BRIGHT_OPACITY_50,
      backgroundActiveColor: COLOR_BRIGHT,
      backgroundActiveHoverColor: COLOR_BRIGHT_OPACITY_85,
      textAndIconColor: COLOR_BRIGHT,
      textAndIconHoverColor: COLOR_BRIGHT,
      textAndIconActiveColor: COLOR_ORANGE,
      textAndIconActiveHoverColor: COLOR_TEAL_ACTIVE,
      borderColor: COLOR_BRIGHT_OPACITY_50,
      focusBorderColor: COLOR_BRIGHT_OPACITY_75
    }
  },
  {
    schemeName: "dark",
    scheme: {
      backgroundHoverColor: COLOR_DARK_OPACITY_10,
      backgroundActiveHoverColor: COLOR_DARK_OPACITY_80,
      textAndIconHoverColor: COLOR_DARK_OPACITY_80,
      textAndIconActiveColor: COLOR_BRIGHT,
      textAndIconActiveHoverColor: COLOR_BRIGHT,
      borderColor: COLOR_DARK_OPACITY_10
    }
  }
];
export const TEXT_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "bright"
  },
  {
    schemeName: "dark"
  },
  {
    schemeName: "blue"
  }
];
export const TEXT_TEASER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "green",
    scheme: {
      valueTextColor: COLOR_BRIGHT,
      contentColor: COLOR_BRIGHT,
      contentBackgroundColor: COLOR_GREEN
    }
  },
  {
    schemeName: "blue",
    scheme: {
      valueTextColor: COLOR_BRIGHT,
      contentColor: COLOR_BRIGHT,
      contentBackgroundColor: COLOR_BLUE
    }
  },
  {
    schemeName: "orange",
    scheme: {
      valueTextColor: COLOR_BRIGHT,
      contentColor: COLOR_BRIGHT,
      contentBackgroundColor: COLOR_ORANGE
    }
  },
  {
    schemeName: "teal",
    scheme: {
      valueTextColor: COLOR_BRIGHT,
      contentColor: COLOR_BRIGHT,
      contentBackgroundColor: COLOR_TEAL
    }
  },
  {
    schemeName: "turquoise",
    scheme: {
      valueTextColor: COLOR_BRIGHT,
      contentColor: COLOR_BRIGHT,
      contentBackgroundColor: COLOR_TURQUOISE
    }
  },
  {
    schemeName: "bright",
    scheme: {
      valueTextColor: COLOR_DARK,
      contentColor: COLOR_DARK,
      contentBackgroundColor: COLOR_BRIGHT
    }
  },
  {
    schemeName: "lightGrey",
    scheme: {
      valueTextColor: COLOR_DARK,
      contentColor: COLOR_DARK,
      contentBackgroundColor: COLOR_LIGHT_GREY
    }
  }
];
export const THIRD_LEVEL_NAVIGATION_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "green",
    scheme: {
      tabBorderColor: COLOR_BRIGHT_TABBAR_COLOR,
      tabActiveBorderColor: COLOR_BRIGHT
    }
  },
  {
    schemeName: "blue",
    scheme: {
      tabBorderColor: COLOR_BRIGHT_TABBAR_COLOR,
      tabActiveBorderColor: COLOR_BRIGHT
    }
  },
  {
    schemeName: "orange",
    scheme: {
      tabBorderColor: COLOR_BRIGHT_TABBAR_COLOR,
      tabActiveBorderColor: COLOR_BRIGHT
    }
  },
  {
    schemeName: "lightGrey",
    scheme: {
      tabBorderColor: COLOR_MIDDLE_GREY,
      tabActiveBorderColor: COLOR_BLUE
    }
  }
];
export const THIRD_LEVEL_NAVIGATION_ITEM_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "green",
    scheme: {
      tabHoverBorderColor: COLOR_BRIGHT_TABBAR_COLOR,
      tabHoverColor: COLOR_GREEN_ACTIVE
    }
  },
  {
    schemeName: "blue",
    scheme: {
      tabHoverBorderColor: COLOR_BRIGHT_TABBAR_COLOR,
      tabHoverColor: COLOR_BLUE_ACTIVE
    }
  },
  {
    schemeName: "orange",
    scheme: {
      tabHoverBorderColor: COLOR_BRIGHT_TABBAR_COLOR,
      tabHoverColor: COLOR_ORANGE_ACTIVE
    }
  },
  {
    schemeName: "lightGrey",
    scheme: {
      textColor: COLOR_DARK_GREY,
      tabHoverBorderColor: COLOR_MIDDLE_GREY,
      tabHoverColor: COLOR_MIDDLE_GREY
    }
  }
];
export const TILES_TEASER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "green",
    scheme: {
      backgroundColor: COLOR_GREEN,
      hoverBackgroundColor: COLOR_GREEN_ACTIVE
    }
  },
  {
    schemeName: "blue",
    scheme: {
      backgroundColor: COLOR_BLUE,
      hoverBackgroundColor: COLOR_BLUE_ACTIVE
    }
  },
  {
    schemeName: "orange",
    scheme: {
      backgroundColor: COLOR_ORANGE,
      hoverBackgroundColor: COLOR_ORANGE_ACTIVE
    }
  },
  {
    schemeName: "teal",
    scheme: {
      backgroundColor: COLOR_TEAL,
      hoverBackgroundColor: COLOR_TEAL_ACTIVE
    }
  },
  {
    schemeName: "turquoise",
    scheme: {
      backgroundColor: COLOR_TURQUOISE,
      hoverBackgroundColor: COLOR_TURQUOISE_ACTIVE
    }
  },
  {
    schemeName: "bright",
    scheme: {
      backgroundColor: COLOR_BRIGHT,
      hoverBackgroundColor: COLOR_LIGHT_GREY,
      hoverColor: COLOR_BLUE
    }
  }
];
export const TOOLTIP_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white",
    scheme: {
      innerContentColor: COLOR_GREY900
    }
  }
];
export const VIDEOPLAYER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "bright",
    scheme: {
      playButtonColor: COLOR_BLUE
    }
  },
  {
    schemeName: "blue"
  }
];
export const VIOLATOR_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "green"
  },
  {
    schemeName: "blue"
  },
  {
    schemeName: "orange"
  },
  {
    schemeName: "teal"
  },
  {
    schemeName: "turquoise"
  },
  {
    schemeName: "bright"
  },
  {
    schemeName: "dark"
  },
  {
    schemeName: "red"
  }
];

export interface AccordionSchemeConfiguration<T> {
  green?: T;
  teal?: T;
  blue?: T;
  orange?: T;
  bright?: T;
}
export interface AnswerCardSchemeConfiguration<T> {
  bright?: T;
  blue?: T;
  green?: T;
  teal?: T;
  orange?: T;
  lightGrey?: T;
}
export interface BadgeSchemeConfiguration<T> {
  bright?: T;
  dark?: T;
}
export interface BasicTeaserSchemeConfiguration<T> {
  bright?: T;
  green?: T;
  blue?: T;
  orange?: T;
  teal?: T;
  white?: T;
}
export interface BreadcrumbSchemeConfiguration<T> {
  bright?: T;
  baseGrey?: T;
}
export interface BottomDrawerSchemeConfiguration<T> {
  green?: T;
  blue?: T;
  orange?: T;
  bright?: T;
}
export interface BulletListSchemeConfiguration<T> {
  bright?: T;
  dark?: T;
}
export interface BulletListDeprecatedSchemeConfiguration<T> {
  green?: T;
  lightblue?: T;
  blue?: T;
  bright?: T;
  dark?: T;
}
export interface BusinesscardAuthorSchemeConfiguration<T> {
  green?: T;
  blue?: T;
  bright?: T;
  dark?: T;
}
export interface BusinesscardContactSchemeConfiguration<T> {
  green?: T;
  blue?: T;
  orange?: T;
  teal?: T;
  bright?: T;
  dark?: T;
}
export interface BoxSchemeConfiguration<T> {
  lightgreen?: T;
  lightblue?: T;
  lightorange?: T;
  bright?: T;
  transparentGreen?: T;
  transparentRed?: T;
  transparentYellow?: T;
  transparentBlue?: T;
}
export interface ButtonSchemeConfiguration<T> {
  green?: T;
  orange?: T;
  blue?: T;
  teal?: T;
  bright?: T;
  white?: T;
  whiteOutline?: T;
  dark?: T;
}
export interface CaptionSchemeConfiguration<T> {
  green?: T;
  blueActive?: T;
  bright?: T;
  dark?: T;
}
export interface CardTeaserSchemeConfiguration<T> {
  blue?: T;
  green?: T;
  orange?: T;
  teal?: T;
  bright?: T;
  lightGrey?: T;
}
export interface CarouselSchemeConfiguration<T> {
  green?: T;
  greenInverted?: T;
  orange?: T;
  orangeInverted?: T;
  blue?: T;
  blueInverted?: T;
  teal?: T;
  tealInverted?: T;
  bright?: T;
  dark?: T;
}
export interface CheckboxSchemeConfiguration<T> {
  bright?: T;
  blue?: T;
  teal?: T;
  green?: T;
  orange?: T;
  inverted?: T;
}
export interface ChipSchemeConfiguration<T> {
  blue?: T;
  brightOnBlue?: T;
  blueOnLightblue?: T;
  green?: T;
  brightOnGreen?: T;
  orange?: T;
  brightOnOrange?: T;
  brightOnTeal?: T;
  dark?: T;
}
export interface ClickableImageSchemeConfiguration<T> {
  green?: T;
  blue?: T;
  orange?: T;
  teal?: T;
  bright?: T;
}
export interface CompassSchemeConfiguration<T> {
  blue?: T;
}
export interface ContactBarSchemeConfiguration<T> {
  green?: T;
  blue?: T;
  bright?: T;
}
export interface ContactListSchemeConfiguration<T> {
  green?: T;
  lightblue?: T;
  blue?: T;
  bright?: T;
  dark?: T;
}
export interface ContactLayerSchemeConfiguration<T> {
  white?: T;
}
export interface ContentAggregatorSchemeConfiguration<T> {
  green?: T;
  blue?: T;
  orange?: T;
  teal?: T;
  bright?: T;
  dark?: T;
}
export interface ContentAggregatorItemSchemeConfiguration<T> {
  whiteOnGreen?: T;
  whiteOnBlue?: T;
  whiteOnOrange?: T;
  whiteOnTeal?: T;
  blue?: T;
  green?: T;
  bright?: T;
  dark?: T;
}
export interface ContextMenuSchemeConfiguration<T> {
  bright?: T;
}
export interface ContextMenuItemSchemeConfiguration<T> {
  bright?: T;
}
export interface DateEventSchemeConfiguration<T> {
  bright?: T;
  dark?: T;
}
export interface DatePickerSchemeConfiguration<T> {
  blue?: T;
  bright?: T;
  dark?: T;
}
export interface DividerSchemeConfiguration<T> {
  green?: T;
  orange?: T;
  blue?: T;
  teal?: T;
  bright?: T;
  dark?: T;
}
export interface DropdownSchemeConfiguration<T> {
  bright?: T;
  dark?: T;
}
export interface DropdownOptionSchemeConfiguration<T> {
  green?: T;
  lightblue?: T;
  blue?: T;
  bright?: T;
  dark?: T;
}
export interface ErrorMessageSchemeConfiguration<T> {
  red500?: T;
  dark?: T;
  white?: T;
  grey100?: T;
  error?: T;
  warning?: T;
  success?: T;
  info?: T;
  neutral100?: T;
  neutral300?: T;
}
export interface FileUploadSchemeConfiguration<T> {
  green?: T;
  blue?: T;
  whiteOnBlue?: T;
  orange?: T;
  bright?: T;
  dark?: T;
}
export interface FilePreviewSchemeConfiguration<T> {
  blue?: T;
  bright?: T;
}
export interface FormMessageSchemeConfiguration<T> {
  standard?: T;
  bright?: T;
  dark?: T;
}
export interface HeadlineSchemeConfiguration<T> {
  green?: T;
  blue?: T;
  orange?: T;
  teal?: T;
  bright?: T;
  dark?: T;
}
export interface HeadlineBrandSchemeConfiguration<T> {
  blue?: T;
  bright?: T;
}
export interface HeroSectionSchemeConfiguration<T> {
  bright?: T;
}
export interface IconSchemeConfiguration<T> {
  green?: T;
  orange?: T;
  blue?: T;
  teal?: T;
  bright?: T;
  dark?: T;
}
export interface InfoIconSchemeConfiguration<T> {
  bright?: T;
  dark?: T;
  blue?: T;
  orange?: T;
  teal?: T;
  middleGrey?: T;
  green?: T;
}
export interface InputSchemeConfiguration<T> {
  bright?: T;
  dark?: T;
}
export interface LinkSchemeConfiguration<T> {
  blue?: T;
  green?: T;
  orange?: T;
  teal?: T;
  bright?: T;
  white?: T;
  grey?: T;
  dark?: T;
}
export interface LinklistSchemeConfiguration<T> {
  green?: T;
  blue?: T;
  orange?: T;
  teal?: T;
  bright?: T;
  dark?: T;
}
export interface MapInfoLayerSchemeConfiguration<T> {
  green?: T;
  teal?: T;
  orange?: T;
  blue?: T;
  bright?: T;
  dark?: T;
}
export interface MultiContentStageSchemeConfiguration<T> {
  blue?: T;
  green?: T;
  orange?: T;
  teal?: T;
  bright?: T;
  lightGrey?: T;
}
export interface NumberSchemeConfiguration<T> {
  green?: T;
  blue?: T;
  bright?: T;
  orange?: T;
  teal?: T;
  dark?: T;
}
export interface OffsetTeaserSchemeConfiguration<T> {
  bright?: T;
  whiteOnLightGrey?: T;
  lightGrey?: T;
  blue?: T;
  lightblue?: T;
  lightgreen?: T;
  lightorange?: T;
  green?: T;
  orange?: T;
  teal?: T;
  turquoise?: T;
  whiteOnBlue?: T;
}
export interface OffsetTeaser5SchemeConfiguration<T> {
  blue?: T;
  green?: T;
  orange?: T;
  teal?: T;
  turquoise?: T;
  lightblue?: T;
  lightorange?: T;
  lightGrey?: T;
  bright?: T;
  lightgreen?: T;
}
export interface OptionPickerItemSchemeConfiguration<T> {
  green?: T;
  blue?: T;
  orange?: T;
  teal?: T;
  turquoise?: T;
  bright?: T;
  dark?: T;
}
export interface PaginationSchemeConfiguration<T> {
  blue?: T;
}
export interface PreloaderCircleSchemeConfiguration<T> {
  colorful?: T;
  green?: T;
  blue?: T;
  orange?: T;
  bright?: T;
  dark?: T;
}
export interface PreloaderSquaresSchemeConfiguration<T> {
  green?: T;
  blue?: T;
  turquoise?: T;
  orange?: T;
  bright?: T;
  dark?: T;
}
export interface ProgressCircleSchemeConfiguration<T> {
  green?: T;
  orange?: T;
  blue?: T;
  teal?: T;
  bright?: T;
  dark?: T;
  red?: T;
}
export interface PromoFlagSchemeConfiguration<T> {
  green?: T;
  blue?: T;
  orange?: T;
  teal?: T;
  bright?: T;
  lightGrey?: T;
  dark?: T;
}
export interface PageHeaderSchemeConfiguration<T> {
  green?: T;
  blue?: T;
  orange?: T;
  bright?: T;
  lightGrey?: T;
}
export interface PictogramSchemeConfiguration<T> {
  green?: T;
  blue?: T;
  orange?: T;
  teal?: T;
  turquoise?: T;
  bright?: T;
  dark?: T;
}
export interface RadioButtonSchemeConfiguration<T> {
  blue?: T;
  green?: T;
  orange?: T;
  inverted?: T;
  dark?: T;
}
export interface ReadMoreSchemeConfiguration<T> {
  blue?: T;
  darkOnBright?: T;
  darkOnLightGrey?: T;
  brightOnBlue?: T;
  brightOnGreen?: T;
  brightOnOrange?: T;
  brightOnTeal?: T;
}
export interface RteRendererSchemeConfiguration<T> {
  bright?: T;
  blue?: T;
  green?: T;
  orange?: T;
  teal?: T;
  dark?: T;
}
export interface SectionSchemeConfiguration<T> {
  green?: T;
  blue?: T;
  orange?: T;
  teal?: T;
  turquoise?: T;
  lightblue?: T;
  lightgreen?: T;
  lightorange?: T;
  transparent?: T;
  bright?: T;
  lightGrey?: T;
}
export interface SearchResultItemSchemeConfiguration<T> {
  lightGrey?: T;
  brightWithLightGreyDescription?: T;
  bright?: T;
  dark?: T;
}
export interface SegmentedButtonSchemeConfiguration<T> {
  bright?: T;
  dark?: T;
}
export interface SitelinkSchemeConfiguration<T> {
  brightBlue?: T;
  brightBlueOnLightGrey?: T;
  brightGreen?: T;
  brightGreenOnLightGrey?: T;
  blue?: T;
  green?: T;
  orange?: T;
  teal?: T;
  bright?: T;
}
export interface SliderSchemeConfiguration<T> {
  green?: T;
  blue?: T;
  orange?: T;
  teal?: T;
  brightOnGreen?: T;
  brightOnBlue?: T;
  brightOnOrange?: T;
  bright?: T;
  dark?: T;
}
export interface SwitchToggleSchemeConfiguration<T> {
  blue?: T;
  inverted?: T;
  dark?: T;
  green?: T;
  bright?: T;
}
export interface StageSchemeConfiguration<T> {
  blue?: T;
  bright?: T;
}
export interface StatePillSchemeConfiguration<T> {
  active?: T;
  pending?: T;
  error?: T;
  warning?: T;
  inactive?: T;
}
export interface StepSchemeConfiguration<T> {
  green?: T;
  blue?: T;
  blueOnLightgrey?: T;
  brightOnBlue?: T;
  brightOnGreen?: T;
  brightOnOrange?: T;
  brightOnTeal?: T;
  bright?: T;
  dark?: T;
}
export interface StepsSchemeConfiguration<T> {
  green?: T;
  blue?: T;
  brightOnBlue?: T;
  brightOnGreen?: T;
  brightOnOrange?: T;
  brightOnTeal?: T;
  blueOnLightGrey?: T;
  bright?: T;
}
export interface TableRendererSchemeConfiguration<T> {
  brightBlueHighlighting?: T;
  brightGreenHighlighting?: T;
  lightGreyBlueHighlighting?: T;
  lightGreyGreenHighlighting?: T;
  green?: T;
  blue?: T;
  orange?: T;
  teal?: T;
}
export interface TabNavigationSchemeConfiguration<T> {
  bright?: T;
  lightGrey?: T;
  blue?: T;
  blueOnLightblue?: T;
  green?: T;
  greenOnLightgreen?: T;
  orange?: T;
  orangeOnLightorange?: T;
  teal?: T;
}
export interface TabsSchemeConfiguration<T> {
  bright?: T;
  blue?: T;
  green?: T;
  orange?: T;
  teal?: T;
}
export interface TagPillSchemeConfiguration<T> {
  blue?: T;
  brightOnBlue?: T;
  blueOnLightblue?: T;
  green?: T;
  brightOnGreen?: T;
  orange?: T;
  brightOnOrange?: T;
  brightOnTeal?: T;
  dark?: T;
}
export interface TextSchemeConfiguration<T> {
  bright?: T;
  dark?: T;
  blue?: T;
}
export interface TextTeaserSchemeConfiguration<T> {
  green?: T;
  blue?: T;
  orange?: T;
  teal?: T;
  turquoise?: T;
  bright?: T;
  lightGrey?: T;
}
export interface ThirdLevelNavigationSchemeConfiguration<T> {
  green?: T;
  blue?: T;
  orange?: T;
  lightGrey?: T;
}
export interface ThirdLevelNavigationItemSchemeConfiguration<T> {
  green?: T;
  blue?: T;
  orange?: T;
  lightGrey?: T;
}
export interface TilesTeaserSchemeConfiguration<T> {
  green?: T;
  blue?: T;
  orange?: T;
  teal?: T;
  turquoise?: T;
  bright?: T;
}
export interface TooltipSchemeConfiguration<T> {
  white?: T;
}
export interface VideoplayerSchemeConfiguration<T> {
  bright?: T;
  blue?: T;
}
export interface ViolatorSchemeConfiguration<T> {
  green?: T;
  blue?: T;
  orange?: T;
  teal?: T;
  turquoise?: T;
  bright?: T;
  dark?: T;
  red?: T;
}
//add Components Color-Variables from colorDefinitions
export const ANCHOR_NAVIGATION_BACKGROUND_COLOR = "eon-anchor-navigation-background-color" as const;
export const ANCHOR_NAVIGATION_BACKGROUND_HOVER_COLOR = "eon-anchor-navigation-background-hover-color" as const;
export const ANCHOR_NAVIGATION_ICON_COLOR = "eon-anchor-navigation-icon-color" as const;
export const ANCHOR_NAVIGATION_ICON_HOVER_COLOR = "eon-anchor-navigation-icon-hover-color" as const;
export const ANCHOR_NAVIGATION_ICON_HIGHLIGHT_COLOR = "eon-anchor-navigation-icon-highlight-color" as const;
export const ANCHOR_NAVIGATION_ITEM_BACKGROUND_COLOR = "eon-anchor-navigation-item-background-color" as const;
export const ANCHOR_NAVIGATION_ITEM_HOVER_COLOR = "eon-anchor-navigation-item-hover-color" as const;
export const ANCHOR_NAVIGATION_LINK_COLOR = "eon-anchor-navigation-link-color" as const;
export const ANCHOR_NAVIGATION_LINK_HOVER_COLOR = "eon-anchor-navigation-link-hover-color" as const;
export const ANCHOR_NAVIGATION_LINK_HIGHLIGHT_COLOR = "eon-anchor-navigation-link-highlight-color" as const;
export const CAROUSEL_CONTROL_COLOR_BRIGHT = "eon-carousel-control-color-bright" as const;
export const CAROUSEL_CONTROL_COLOR_DARK = "eon-carousel-control-color-dark" as const;
export const CAROUSEL_CONTROL_ICON_COLOR_BRIGHT = "eon-carousel-control-icon-color-bright" as const;
export const CAROUSEL_CONTROL_ICON_COLOR_DARK = "eon-carousel-control-icon-color-dark" as const;
export const COLOR_SEPARATOR_FIRST_COLOR = "eon-color-separator-first-color" as const;
export const COLOR_SEPARATOR_SECOND_COLOR = "eon-color-separator-second-color" as const;
export const COLOR_SEPARATOR_THIRD_COLOR = "eon-color-separator-third-color" as const;
export const CONTACT_BAR_MODAL_BACKGROUND_COLOR = "eon-contact-bar-modal-background-color" as const;
export const CONTEXT_MENU_ITEM_BACKGROUND_HOVER_COLOR = "eon-context-menu-item-background-hover-color" as const;
export const CONTEXT_MENU_ITEM_BACKGROUND_ACTIVE_COLOR = "eon-context-menu-item-background-active-color" as const;
export const DATA_TABLE_HEAD_CELL_COLOR = "eon-data-table-head-cell-color" as const;
export const DATA_TABLE_HEAD_CELL_ICON_COLOR = "eon-data-table-head-cell-icon-color" as const;
export const DATA_TABLE_HEAD_CELL_BACKGROUND = "eon-data-table-head-cell-background" as const;
export const DATA_TABLE_HEAD_CELL_BACKGROUND_HOVER = "eon-data-table-head-cell-background-hover" as const;
export const DATA_TABLE_HEAD_CELL_BACKGROUND_ACT = "eon-data-table-head-cell-background-act" as const;
export const DATA_TABLE_HEAD_CELL_BACKGROUND_ACT_HOVER = "eon-data-table-head-cell-background-act-hover" as const;
export const DATA_TABLE_HEAD_CELL_BORDER = "eon-data-table-head-cell-border" as const;
export const DATA_TABLE_HEAD_CELL_BORDER_HOVER = "eon-data-table-head-cell-border-hover" as const;
export const DATA_TABLE_HEAD_CELL_BORDER_ACT = "eon-data-table-head-cell-border-act" as const;
export const DATA_TABLE_HEAD_CELL_BORDER_ACT_HOVER = "eon-data-table-head-cell-border-act-hover" as const;
export const DATA_TABLE_CELL_COLOR = "eon-data-table-cell-color" as const;
export const DATA_TABLE_CELL_ICON_COLOR = "eon-data-table-cell-icon-color" as const;
export const DATA_TABLE_CELL_BACKGROUND = "eon-data-table-cell-background" as const;
export const DATA_TABLE_CELL_BACKGROUND_HOVER = "eon-data-table-cell-background-hover" as const;
export const DATA_TABLE_CELL_BACKGROUND_SELECTED = "eon-data-table-cell-background-selected" as const;
export const DATA_TABLE_CELL_BACKGROUND_SELECTED_HOVER = "eon-data-table-cell-background-selected-hover" as const;
export const DATA_TABLE_CELL_BACKGROUND_ODD = "eon-data-table-cell-background-odd" as const;
export const DATA_TABLE_CELL_BACKGROUND_ODD_HOVER = "eon-data-table-cell-background-odd-hover" as const;
export const DATA_TABLE_CELL_BACKGROUND_EVEN = "eon-data-table-cell-background-even" as const;
export const DATA_TABLE_CELL_BACKGROUND_EVEN_HOVER = "eon-data-table-cell-background-even-hover" as const;
export const DATA_TABLE_CELL_BORDER = "eon-data-table-cell-border" as const;
export const DATA_TABLE_CELL_BORDER_HOVER = "eon-data-table-cell-border-hover" as const;
export const DATA_TABLE_CELL_BORDER_SELECTED = "eon-data-table-cell-border-selected" as const;
export const DATA_TABLE_CELL_BORDER_SELECTED_HOVER = "eon-data-table-cell-border-selected-hover" as const;
export const DATA_TABLE_CELL_BORDER_ODD = "eon-data-table-cell-border-odd" as const;
export const DATA_TABLE_CELL_BORDER_ODD_HOVER = "eon-data-table-cell-border-odd-hover" as const;
export const DATA_TABLE_CELL_BORDER_EVEN = "eon-data-table-cell-border-even" as const;
export const DATA_TABLE_CELL_BORDER_EVEN_HOVER = "eon-data-table-cell-border-even-hover" as const;
export const DATA_TABLE_TOOLBAR_BACKGROUND = "eon-data-table-toolbar-background" as const;
export const DATA_TABLE_TOOLBAR_COLOR = "eon-data-table-toolbar-color" as const;
export const DATA_TABLE_TOOLBAR_SELECTED_BACKGROUND = "eon-data-table-toolbar-selected-background" as const;
export const DATA_TABLE_TOOLBAR_SELECTED_COLOR = "eon-data-table-toolbar-selected-color" as const;
export const DATA_TABLE_FOCUS_BORDER = "eon-data-table-focus-border" as const;
export const DATE_PICKER_FONT_COLOR = "eon-date-picker-font-color" as const;
export const DATE_PICKER_FONT_SECONDARY_COLOR = "eon-date-picker-font-secondary-color" as const;
export const DATE_PICKER_FONT_HIGHLIGHT_COLOR = "eon-date-picker-font-highlight-color" as const;
export const DATE_PICKER_FONT_DISABLED_COLOR = "eon-date-picker-font-disabled-color" as const;
export const DATE_PICKER_FONT_COLOR_HEAD = "eon-date-picker-font-color-head" as const;
export const DATE_PICKER_FONT_COLOR_OTHER_MONTH = "eon-date-picker-font-color-other-month" as const;
export const DATE_PICKER_CONTENT_BACKGROUND_COLOR = "eon-date-picker-content-background-color" as const;
export const DATE_PICKER_CALENDAR_DAY_TODAY_COLOR = "eon-date-picker-calendar-day-today-color" as const;
export const DATE_PICKER_CALENDAR_HEAD_COLOR = "eon-date-picker-calendar-head-color" as const;
export const FOOTER_BAR_COPYRIGHT_COLOR = "eon-footer-bar-copyright-color" as const;
export const FOOTER_BAR_BACKGROUND_COLOR = "eon-footer-bar-background-color" as const;
export const FOOTER_BAR_LINK_COLOR = "eon-footer-bar-link-color" as const;
export const FOOTER_BAR_LINK_HOVER_COLOR = "eon-footer-bar-link-hover-color" as const;
export const MAP_SVG_COLOR = "eon-map-svg-color" as const;
export const MODAL_BACKGROUND_COLOR = "eon-modal-background-color" as const;
export const MODAL_BORDER_BOTTOM_COLOR = "eon-modal-border-bottom-color" as const;
export const MODAL_WRAPPER_BACKGROUND_COLOR = "eon-modal-wrapper-background-color" as const;
export const MODAL_FULL_WIDTH_BACKGROUND_COLOR = "eon-modal-full-width-background-color" as const;
export const MODAL_FULL_WIDTH_ON_FILTER_BLUR_BACKGROUND_COLOR = "eon-modal-full-width-on-filter-blur-background-color" as const;
export const NAVIGATION_BOX_SHADOW = "eon-navigation-box-shadow" as const;
export const NAVIGATION_META_BG_COLOR = "eon-navigation-meta-bg-color" as const;
export const NAVIGATION_META_BORDER_COLOR = "eon-navigation-meta-border-color" as const;
export const NAVIGATION_META_LINK_FONT_COLOR = "eon-navigation-meta-link-font-color" as const;
export const NAVIGATION_META_LINK_FONT_COLOR_HOVER = "eon-navigation-meta-link-font-color-hover" as const;
export const NAVIGATION_META_LINK_FONT_COLOR_FOCUS = "eon-navigation-meta-link-font-color-focus" as const;
export const NAVIGATION_META_LINK_FONT_COLOR_CURRENT = "eon-navigation-meta-link-font-color-current" as const;
export const NAVIGATION_META_LINK_FONT_COLOR_CURRENT_HOVER = "eon-navigation-meta-link-font-color-current-hover" as const;
export const NAVIGATION_META_LINK_FONT_COLOR_CURRENT_FOCUS = "eon-navigation-meta-link-font-color-current-focus" as const;
export const NAVIGATION_META_LINK_BG_COLOR = "eon-navigation-meta-link-bg-color" as const;
export const NAVIGATION_META_LINK_BG_COLOR_HOVER = "eon-navigation-meta-link-bg-color-hover" as const;
export const NAVIGATION_META_LINK_BG_COLOR_FOCUS = "eon-navigation-meta-link-bg-color-focus" as const;
export const NAVIGATION_META_LINK_BG_COLOR_CURRENT = "eon-navigation-meta-link-bg-color-current" as const;
export const NAVIGATION_META_LINK_BG_COLOR_CURRENT_HOVER = "eon-navigation-meta-link-bg-color-current-hover" as const;
export const NAVIGATION_META_LINK_BG_COLOR_CURRENT_FOCUS = "eon-navigation-meta-link-bg-color-current-focus" as const;
export const NAVIGATION_META_LINK_BORDER_COLOR = "eon-navigation-meta-link-border-color" as const;
export const NAVIGATION_META_LINK_BORDER_COLOR_HOVER = "eon-navigation-meta-link-border-color-hover" as const;
export const NAVIGATION_META_LINK_BORDER_COLOR_FOCUS = "eon-navigation-meta-link-border-color-focus" as const;
export const NAVIGATION_META_LINK_BORDER_COLOR_CURRENT = "eon-navigation-meta-link-border-color-current" as const;
export const NAVIGATION_META_LINK_BORDER_COLOR_CURRENT_HOVER = "eon-navigation-meta-link-border-color-current-hover" as const;
export const NAVIGATION_META_LINK_BORDER_COLOR_CURRENT_FOCUS = "eon-navigation-meta-link-border-color-current-focus" as const;
export const NAVIGATION_TOOLBAR_BG_COLOR = "eon-navigation-toolbar-bg-color" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR = "eon-navigation-toolbar-icon-link-font-color" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_HOVER = "eon-navigation-toolbar-icon-link-font-color-hover" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_FOCUS = "eon-navigation-toolbar-icon-link-font-color-focus" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_CURRENT = "eon-navigation-toolbar-icon-link-font-color-current" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_CURRENT_HOVER = "eon-navigation-toolbar-icon-link-font-color-current-hover" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_CURRENT_FOCUS = "eon-navigation-toolbar-icon-link-font-color-current-focus" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_ACTIVE = "eon-navigation-toolbar-icon-link-font-color-active" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_ACTIVE_HOVER = "eon-navigation-toolbar-icon-link-font-color-active-hover" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_ACTIVE_FOCUS = "eon-navigation-toolbar-icon-link-font-color-active-focus" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR = "eon-navigation-toolbar-icon-link-bg-color" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_HOVER = "eon-navigation-toolbar-icon-link-bg-color-hover" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_FOCUS = "eon-navigation-toolbar-icon-link-bg-color-focus" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_CURRENT = "eon-navigation-toolbar-icon-link-bg-color-current" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_CURRENT_HOVER = "eon-navigation-toolbar-icon-link-bg-color-current-hover" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_CURRENT_FOCUS = "eon-navigation-toolbar-icon-link-bg-color-current-focus" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_ACTIVE = "eon-navigation-toolbar-icon-link-bg-color-active" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_ACTIVE_HOVER = "eon-navigation-toolbar-icon-link-bg-color-active-hover" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_ACTIVE_FOCUS = "eon-navigation-toolbar-icon-link-bg-color-active-focus" as const;
export const NAVIGATION_TOOLBAR_SUB_BG_COLOR = "eon-navigation-toolbar-sub-bg-color" as const;
export const NAVIGATION_MAIN_BG_COLOR = "eon-navigation-main-bg-color" as const;
export const NAVIGATION_MAIN_BORDER_COLOR = "eon-navigation-main-border-color" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR = "eon-navigation-main-link-font-color" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_HOVER = "eon-navigation-main-link-font-color-hover" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_FOCUS = "eon-navigation-main-link-font-color-focus" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_CURRENT = "eon-navigation-main-link-font-color-current" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_CURRENT_HOVER = "eon-navigation-main-link-font-color-current-hover" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_CURRENT_FOCUS = "eon-navigation-main-link-font-color-current-focus" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_ACTIVE = "eon-navigation-main-link-font-color-active" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_ACTIVE_HOVER = "eon-navigation-main-link-font-color-active-hover" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_ACTIVE_FOCUS = "eon-navigation-main-link-font-color-active-focus" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR = "eon-navigation-main-link-bg-color" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_HOVER = "eon-navigation-main-link-bg-color-hover" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_FOCUS = "eon-navigation-main-link-bg-color-focus" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_CURRENT = "eon-navigation-main-link-bg-color-current" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_CURRENT_HOVER = "eon-navigation-main-link-bg-color-current-hover" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_CURRENT_FOCUS = "eon-navigation-main-link-bg-color-current-focus" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_ACTIVE = "eon-navigation-main-link-bg-color-active" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_ACTIVE_HOVER = "eon-navigation-main-link-bg-color-active-hover" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_ACTIVE_FOCUS = "eon-navigation-main-link-bg-color-active-focus" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR = "eon-navigation-main-link-border-color" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_HOVER = "eon-navigation-main-link-border-color-hover" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_FOCUS = "eon-navigation-main-link-border-color-focus" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_CURRENT = "eon-navigation-main-link-border-color-current" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_CURRENT_HOVER = "eon-navigation-main-link-border-color-current-hover" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_CURRENT_FOCUS = "eon-navigation-main-link-border-color-current-focus" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_ACTIVE = "eon-navigation-main-link-border-color-active" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_ACTIVE_HOVER = "eon-navigation-main-link-border-color-active-hover" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_ACTIVE_FOCUS = "eon-navigation-main-link-border-color-active-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR = "eon-navigation-main-icon-link-font-color" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_HOVER = "eon-navigation-main-icon-link-font-color-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_FOCUS = "eon-navigation-main-icon-link-font-color-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_CURRENT = "eon-navigation-main-icon-link-font-color-current" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_CURRENT_HOVER = "eon-navigation-main-icon-link-font-color-current-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_CURRENT_FOCUS = "eon-navigation-main-icon-link-font-color-current-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_ACTIVE = "eon-navigation-main-icon-link-font-color-active" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_ACTIVE_HOVER = "eon-navigation-main-icon-link-font-color-active-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_ACTIVE_FOCUS = "eon-navigation-main-icon-link-font-color-active-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR = "eon-navigation-main-icon-link-bg-color" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_HOVER = "eon-navigation-main-icon-link-bg-color-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_FOCUS = "eon-navigation-main-icon-link-bg-color-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_CURRENT = "eon-navigation-main-icon-link-bg-color-current" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_CURRENT_HOVER = "eon-navigation-main-icon-link-bg-color-current-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_CURRENT_FOCUS = "eon-navigation-main-icon-link-bg-color-current-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_ACTIVE = "eon-navigation-main-icon-link-bg-color-active" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_ACTIVE_HOVER = "eon-navigation-main-icon-link-bg-color-active-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_ACTIVE_FOCUS = "eon-navigation-main-icon-link-bg-color-active-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR = "eon-navigation-main-icon-link-border-color" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_HOVER = "eon-navigation-main-icon-link-border-color-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_FOCUS = "eon-navigation-main-icon-link-border-color-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_CURRENT = "eon-navigation-main-icon-link-border-color-current" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_CURRENT_HOVER = "eon-navigation-main-icon-link-border-color-current-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_CURRENT_FOCUS = "eon-navigation-main-icon-link-border-color-current-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_ACTIVE = "eon-navigation-main-icon-link-border-color-active" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_ACTIVE_HOVER = "eon-navigation-main-icon-link-border-color-active-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_ACTIVE_FOCUS = "eon-navigation-main-icon-link-border-color-active-focus" as const;
export const NAVIGATION_MAIN_SUB_BG_COLOR = "eon-navigation-main-sub-bg-color" as const;
export const NAVIGATION_MAIN_SUB_BOX_SHADOW = "eon-navigation-main-sub-box-shadow" as const;
export const NAVIGATION_FLYOUT_DIVIDER_BG_COLOR = "eon-navigation-flyout-divider-bg-color" as const;
export const NAVIGATION_FLYOUT_LINK_FONT_COLOR = "eon-navigation-flyout-link-font-color" as const;
export const NAVIGATION_FLYOUT_LINK_FONT_COLOR_HOVER = "eon-navigation-flyout-link-font-color-hover" as const;
export const NAVIGATION_FLYOUT_LINK_FONT_COLOR_FOCUS = "eon-navigation-flyout-link-font-color-focus" as const;
export const NAVIGATION_FLYOUT_LINK_FONT_COLOR_CURRENT = "eon-navigation-flyout-link-font-color-current" as const;
export const NAVIGATION_FLYOUT_LINK_BORDER_COLOR_CURRENT = "eon-navigation-flyout-link-border-color-current" as const;
export const NAVIGATION_FLYOUT_LINK_LARGE_FONT_COLOR = "eon-navigation-flyout-link-large-font-color" as const;
export const NAVIGATION_FLYOUT_LINK_LARGE_FONT_COLOR_HOVER = "eon-navigation-flyout-link-large-font-color-hover" as const;
export const NAVIGATION_FLYOUT_LINK_LARGE_FONT_COLOR_FOCUS = "eon-navigation-flyout-link-large-font-color-focus" as const;
export const NAVIGATION_FLYOUT_LINK_LARGE_FONT_COLOR_CURRENT = "eon-navigation-flyout-link-large-font-color-current" as const;
export const NAVIGATION_FLYOUT_LINK_LARGE_BORDER_COLOR_CURRENT = "eon-navigation-flyout-link-large-border-color-current" as const;
export const NAVIGATION_MOBILE_BG_COLOR = "eon-navigation-mobile-bg-color" as const;
export const NAVIGATION_MOBILE_LINK_FONT_COLOR = "eon-navigation-mobile-link-font-color" as const;
export const NAVIGATION_MOBILE_LINK_HIGHLIGHT_BORDER_COLOR = "eon-navigation-mobile-link-highlight-border-color" as const;
export const NAVIGATION_MOBILE_LINK_BORDER_COLOR = "eon-navigation-mobile-link-border-color" as const;
export const NAVIGATION_FOCUS_BORDER_COLOR = "eon-navigation-focus-border-color" as const;
export const NAVIGATION_MAIN_BORDER_COLOR_FOCUS_VISIBLE = "eon-navigation-main-border-color-focus-visible" as const;
export const NAVIGATION_LOGO_FOCUS_COLOR = "eon-navigation-logo-focus-color" as const;
export const OFFSET_TEASER_COLOR_BAR_BLUE = "eon-offset-teaser-color-bar-blue" as const;
export const OFFSET_TEASER_COLOR_BAR_GREEN = "eon-offset-teaser-color-bar-green" as const;
export const OFFSET_TEASER_COLOR_BAR_ORANGE = "eon-offset-teaser-color-bar-orange" as const;
export const OFFSET_TEASER_COLOR_BAR_TEAL = "eon-offset-teaser-color-bar-teal" as const;
export const PRELOADER_CIRCLE_THEME_COLOR1 = "eon-preloader-circle-theme-color1" as const;
export const PRELOADER_CIRCLE_THEME_COLOR2 = "eon-preloader-circle-theme-color2" as const;
export const PRELOADER_CIRCLE_THEME_COLOR3 = "eon-preloader-circle-theme-color3" as const;
export const PRELOADER_CIRCLE_THEME_COLOR4 = "eon-preloader-circle-theme-color4" as const;
export const PRELOADER_SQUARES_THEME_COLOR1 = "eon-preloader-squares-theme-color1" as const;
export const PRELOADER_SQUARES_THEME_COLOR2 = "eon-preloader-squares-theme-color2" as const;
export const PRELOADER_SQUARES_THEME_COLOR3 = "eon-preloader-squares-theme-color3" as const;
export const PRELOADER_SQUARES_THEME_COLOR4 = "eon-preloader-squares-theme-color4" as const;
export const PAGE_HEADER_COLOR_BAR_TURQUOISE = "eon-page-header-color-bar-turquoise" as const;
export const PAGE_HEADER_COLOR_BAR_BLUE = "eon-page-header-color-bar-blue" as const;
export const PAGE_HEADER_COLOR_BAR_GREEN = "eon-page-header-color-bar-green" as const;
export const PAGE_HEADER_COLOR_BAR_TEAL = "eon-page-header-color-bar-teal" as const;
export const PAGE_HEADER_COLOR_BAR_ORANGE = "eon-page-header-color-bar-orange" as const;
export const SECTION_VIDEO_CONTROL_COLOR_LIGHT = "eon-section-video-control-color-light" as const;
export const SECTION_VIDEO_CONTROL_COLOR_DARK = "eon-section-video-control-color-dark" as const;
export const SEARCH_RESULT_ITEM_MARK_COLOR = "eon-search-result-item-mark-color" as const;
export const SEARCH_RESULT_ITEM_VISITED_COLOR = "eon-search-result-item-visited-color" as const;
export const STAGE_BLURRED_BACKGROUND = "eon-stage-blurred-background" as const;
export const STAGE_INDICATOR_COLOR_LIGHT = "eon-stage-indicator-color-light" as const;
export const STAGE_INDICATOR_COLOR_DARK = "eon-stage-indicator-color-dark" as const;
export const STAGE_VIDEO_CONTROL_COLOR_LIGHT = "eon-stage-video-control-color-light" as const;
export const STAGE_VIDEO_CONTROL_COLOR_DARK = "eon-stage-video-control-color-dark" as const;
export const VIDEOPLAYER_FOCUS_OUTLINE_COLOR = "eon-videoplayer-focus-outline-color" as const;
export const VIDEOPLAYER_ERROR_COLOR = "eon-videoplayer-error-color" as const;
export const VIDEOPLAYER_ERROR_BACKGROUND_COLOR = "eon-videoplayer-error-background-color" as const;
export const VIDEOPLAYER_CONTROLS_BACKGROUND = "eon-videoplayer-controls-background" as const;
export const VIDEOPLAYER_PROGRESS_BACKGROUND = "eon-videoplayer-progress-background" as const;
export const VIDEOPLAYER_PROGRESS_COLOR = "eon-videoplayer-progress-color" as const;
export const VIDEOPLAYER_PROGRESS_BAR_BACKGROUND = "eon-videoplayer-progress-bar-background" as const;
export const VIDEOPLAYER_PROGRESS_BAR_TIME_COLOR = "eon-videoplayer-progress-bar-time-color" as const;
export const VIDEOPLAYER_PROGRESS_BAR_VALUE_BACKGROUND = "eon-videoplayer-progress-bar-value-background" as const;
export const VIDEOPLAYER_PROGRESS_BAR_ICON_COLOR = "eon-videoplayer-progress-bar-icon-color" as const;
export const VIDEOPLAYER_PROGRESS_BAR_BUTTON_COLOR = "eon-videoplayer-progress-bar-button-color" as const;
export const VIDEOPLAYER_PROGRESS_BAR_BUTTON_FOCUS = "eon-videoplayer-progress-bar-button-focus" as const;
export const VIDEOPLAYER_PROGRESS_BAR_BUTTON_BACKGROUND = "eon-videoplayer-progress-bar-button-background" as const;
export const VIDEOPLAYER_PROGRESS_BAR_BUTTON_HOVER_BACKGROUND = "eon-videoplayer-progress-bar-button-hover-background" as const;
export const WEBSITE_NAVIGATION_BOX_SHADOW = "eon-website-navigation-box-shadow" as const;
export const WEBSITE_NAVIGATION_META_BG_COLOR = "eon-website-navigation-meta-bg-color" as const;
export const WEBSITE_NAVIGATION_META_BORDER_COLOR = "eon-website-navigation-meta-border-color" as const;
export const WEBSITE_NAVIGATION_META_LINK_FONT_COLOR = "eon-website-navigation-meta-link-font-color" as const;
export const WEBSITE_NAVIGATION_META_LINK_FONT_COLOR_HOVER = "eon-website-navigation-meta-link-font-color-hover" as const;
export const WEBSITE_NAVIGATION_META_LINK_FONT_COLOR_FOCUS = "eon-website-navigation-meta-link-font-color-focus" as const;
export const WEBSITE_NAVIGATION_META_LINK_FONT_COLOR_CURRENT = "eon-website-navigation-meta-link-font-color-current" as const;
export const WEBSITE_NAVIGATION_META_LINK_FONT_COLOR_CURRENT_HOVER = "eon-website-navigation-meta-link-font-color-current-hover" as const;
export const WEBSITE_NAVIGATION_META_LINK_FONT_COLOR_CURRENT_FOCUS = "eon-website-navigation-meta-link-font-color-current-focus" as const;
export const WEBSITE_NAVIGATION_META_LINK_BG_COLOR = "eon-website-navigation-meta-link-bg-color" as const;
export const WEBSITE_NAVIGATION_META_LINK_BG_COLOR_HOVER = "eon-website-navigation-meta-link-bg-color-hover" as const;
export const WEBSITE_NAVIGATION_META_LINK_BG_COLOR_FOCUS = "eon-website-navigation-meta-link-bg-color-focus" as const;
export const WEBSITE_NAVIGATION_META_LINK_BG_COLOR_CURRENT = "eon-website-navigation-meta-link-bg-color-current" as const;
export const WEBSITE_NAVIGATION_META_LINK_BG_COLOR_CURRENT_HOVER = "eon-website-navigation-meta-link-bg-color-current-hover" as const;
export const WEBSITE_NAVIGATION_META_LINK_BG_COLOR_CURRENT_FOCUS = "eon-website-navigation-meta-link-bg-color-current-focus" as const;
export const WEBSITE_NAVIGATION_META_LINK_BORDER_COLOR = "eon-website-navigation-meta-link-border-color" as const;
export const WEBSITE_NAVIGATION_META_LINK_BORDER_COLOR_HOVER = "eon-website-navigation-meta-link-border-color-hover" as const;
export const WEBSITE_NAVIGATION_META_LINK_BORDER_COLOR_FOCUS = "eon-website-navigation-meta-link-border-color-focus" as const;
export const WEBSITE_NAVIGATION_META_LINK_BORDER_COLOR_CURRENT = "eon-website-navigation-meta-link-border-color-current" as const;
export const WEBSITE_NAVIGATION_META_LINK_BORDER_COLOR_CURRENT_HOVER = "eon-website-navigation-meta-link-border-color-current-hover" as const;
export const WEBSITE_NAVIGATION_META_LINK_BORDER_COLOR_CURRENT_FOCUS = "eon-website-navigation-meta-link-border-color-current-focus" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_BG_COLOR = "eon-website-navigation-toolbar-bg-color" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_FONT_COLOR = "eon-website-navigation-toolbar-link-font-color" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_FONT_COLOR_HOVER = "eon-website-navigation-toolbar-link-font-color-hover" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_FONT_COLOR_FOCUS = "eon-website-navigation-toolbar-link-font-color-focus" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_FONT_COLOR_CURRENT = "eon-website-navigation-toolbar-link-font-color-current" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_FONT_COLOR_CURRENT_HOVER = "eon-website-navigation-toolbar-link-font-color-current-hover" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_FONT_COLOR_CURRENT_FOCUS = "eon-website-navigation-toolbar-link-font-color-current-focus" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_FONT_COLOR_ACTIVE = "eon-website-navigation-toolbar-link-font-color-active" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_FONT_COLOR_ACTIVE_HOVER = "eon-website-navigation-toolbar-link-font-color-active-hover" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_FONT_COLOR_ACTIVE_FOCUS = "eon-website-navigation-toolbar-link-font-color-active-focus" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_BG_COLOR = "eon-website-navigation-toolbar-link-bg-color" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_BG_COLOR_HOVER = "eon-website-navigation-toolbar-link-bg-color-hover" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_BG_COLOR_FOCUS = "eon-website-navigation-toolbar-link-bg-color-focus" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_BG_COLOR_CURRENT = "eon-website-navigation-toolbar-link-bg-color-current" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_BG_COLOR_CURRENT_HOVER = "eon-website-navigation-toolbar-link-bg-color-current-hover" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_BG_COLOR_CURRENT_FOCUS = "eon-website-navigation-toolbar-link-bg-color-current-focus" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_BG_COLOR_ACTIVE = "eon-website-navigation-toolbar-link-bg-color-active" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_BG_COLOR_ACTIVE_HOVER = "eon-website-navigation-toolbar-link-bg-color-active-hover" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_BG_COLOR_ACTIVE_FOCUS = "eon-website-navigation-toolbar-link-bg-color-active-focus" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_SUB_BG_COLOR = "eon-website-navigation-toolbar-sub-bg-color" as const;
export const WEBSITE_NAVIGATION_MAIN_BG_COLOR = "eon-website-navigation-main-bg-color" as const;
export const WEBSITE_NAVIGATION_MAIN_BORDER_COLOR = "eon-website-navigation-main-border-color" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_FONT_COLOR = "eon-website-navigation-main-link-font-color" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_FONT_COLOR_HOVER = "eon-website-navigation-main-link-font-color-hover" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_FONT_COLOR_FOCUS = "eon-website-navigation-main-link-font-color-focus" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_FONT_COLOR_CURRENT = "eon-website-navigation-main-link-font-color-current" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_FONT_COLOR_CURRENT_HOVER = "eon-website-navigation-main-link-font-color-current-hover" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_FONT_COLOR_CURRENT_FOCUS = "eon-website-navigation-main-link-font-color-current-focus" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_FONT_COLOR_ACTIVE = "eon-website-navigation-main-link-font-color-active" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_FONT_COLOR_ACTIVE_HOVER = "eon-website-navigation-main-link-font-color-active-hover" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_FONT_COLOR_ACTIVE_FOCUS = "eon-website-navigation-main-link-font-color-active-focus" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BG_COLOR = "eon-website-navigation-main-link-bg-color" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BG_COLOR_HOVER = "eon-website-navigation-main-link-bg-color-hover" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BG_COLOR_FOCUS = "eon-website-navigation-main-link-bg-color-focus" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BG_COLOR_CURRENT = "eon-website-navigation-main-link-bg-color-current" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BG_COLOR_CURRENT_HOVER = "eon-website-navigation-main-link-bg-color-current-hover" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BG_COLOR_CURRENT_FOCUS = "eon-website-navigation-main-link-bg-color-current-focus" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BG_COLOR_ACTIVE = "eon-website-navigation-main-link-bg-color-active" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BG_COLOR_ACTIVE_HOVER = "eon-website-navigation-main-link-bg-color-active-hover" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BG_COLOR_ACTIVE_FOCUS = "eon-website-navigation-main-link-bg-color-active-focus" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BORDER_COLOR = "eon-website-navigation-main-link-border-color" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BORDER_COLOR_HOVER = "eon-website-navigation-main-link-border-color-hover" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BORDER_COLOR_FOCUS = "eon-website-navigation-main-link-border-color-focus" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BORDER_COLOR_CURRENT = "eon-website-navigation-main-link-border-color-current" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BORDER_COLOR_CURRENT_HOVER = "eon-website-navigation-main-link-border-color-current-hover" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BORDER_COLOR_CURRENT_FOCUS = "eon-website-navigation-main-link-border-color-current-focus" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BORDER_COLOR_ACTIVE = "eon-website-navigation-main-link-border-color-active" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BORDER_COLOR_ACTIVE_HOVER = "eon-website-navigation-main-link-border-color-active-hover" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BORDER_COLOR_ACTIVE_FOCUS = "eon-website-navigation-main-link-border-color-active-focus" as const;
export const WEBSITE_NAVIGATION_MAIN_SUB_BG_COLOR = "eon-website-navigation-main-sub-bg-color" as const;
export const WEBSITE_NAVIGATION_MAIN_SUB_BOX_SHADOW = "eon-website-navigation-main-sub-box-shadow" as const;
export const WEBSITE_NAVIGATION_FLYOUT_DIVIDER_BG_COLOR = "eon-website-navigation-flyout-divider-bg-color" as const;
export const WEBSITE_NAVIGATION_FLYOUT_LINK_FONT_COLOR = "eon-website-navigation-flyout-link-font-color" as const;
export const WEBSITE_NAVIGATION_FLYOUT_LINK_FONT_COLOR_HOVER = "eon-website-navigation-flyout-link-font-color-hover" as const;
export const WEBSITE_NAVIGATION_FLYOUT_LINK_FONT_COLOR_FOCUS = "eon-website-navigation-flyout-link-font-color-focus" as const;
export const WEBSITE_NAVIGATION_FLYOUT_LINK_FONT_COLOR_CURRENT = "eon-website-navigation-flyout-link-font-color-current" as const;
export const WEBSITE_NAVIGATION_FLYOUT_LINK_BORDER_COLOR_CURRENT = "eon-website-navigation-flyout-link-border-color-current" as const;
export const WEBSITE_NAVIGATION_FLYOUT_LINK_LARGE_FONT_COLOR = "eon-website-navigation-flyout-link-large-font-color" as const;
export const WEBSITE_NAVIGATION_FLYOUT_LINK_LARGE_FONT_COLOR_HOVER = "eon-website-navigation-flyout-link-large-font-color-hover" as const;
export const WEBSITE_NAVIGATION_FLYOUT_LINK_LARGE_FONT_COLOR_FOCUS = "eon-website-navigation-flyout-link-large-font-color-focus" as const;
export const WEBSITE_NAVIGATION_FLYOUT_LINK_LARGE_FONT_COLOR_CURRENT = "eon-website-navigation-flyout-link-large-font-color-current" as const;
export const WEBSITE_NAVIGATION_FLYOUT_LINK_LARGE_BORDER_COLOR_CURRENT = "eon-website-navigation-flyout-link-large-border-color-current" as const;
export const WEBSITE_NAVIGATION_MOBILE_BG_COLOR = "eon-website-navigation-mobile-bg-color" as const;
export const WEBSITE_NAVIGATION_MOBILE_LINK_FONT_COLOR = "eon-website-navigation-mobile-link-font-color" as const;
export const WEBSITE_NAVIGATION_MOBILE_LINK_HIGHLIGHT_BORDER_COLOR = "eon-website-navigation-mobile-link-highlight-border-color" as const;
export const WEBSITE_NAVIGATION_MOBILE_LINK_BORDER_COLOR = "eon-website-navigation-mobile-link-border-color" as const;

export const SCHEME_ALIAS_CONFIG = {
  ACCORDION: {},
  ANCHOR_NAVIGATION: {},
  ANSWER_CARD: {},
  BADGE: {},
  BASIC_TEASER: {},
  BREADCRUMB: {},
  BOTTOM_DRAWER: {},
  BULLET_LIST: {},
  BULLET_LIST_DEPRECATED: {},
  BUSINESSCARD_AUTHOR: {},
  BUSINESSCARD_CONTACT: {},
  BOX: {},
  BUTTON: {},
  CAPTION: {},
  CARD_TEASER: {},
  CAROUSEL: {},
  CHECKBOX: {},
  CHIP: {},
  CLICKABLE_IMAGE: {},
  COLOR_SEPARATOR: {},
  COMPASS: {},
  CONTACT_BAR: {},
  CONTACT_LIST: {},
  CONTACT_LAYER: {},
  CONTENT_AGGREGATOR: {},
  CONTENT_AGGREGATOR_ITEM: {},
  CONTEXT_MENU: {},
  CONTEXT_MENU_ITEM: {},
  DATA_TABLE: {},
  DATE_EVENT: {},
  DATE_PICKER: {},
  DIVIDER: {},
  DROPDOWN: {},
  DROPDOWN_OPTION: {},
  ERROR_MESSAGE: {},
  FILE_UPLOAD: {},
  FILE_PREVIEW: {},
  FOOTER_BAR: {},
  FORM_MESSAGE: {},
  HEADLINE: {},
  HEADLINE_BRAND: {},
  HERO_SECTION: {},
  ICON: {},
  IMAGE: {},
  INFO_ICON: {},
  INPUT: {},
  LINK: {},
  LINKLIST: {},
  MAP: {},
  MAP_INFO_LAYER: {},
  MODAL: {},
  MULTI_CONTENT_STAGE: {},
  NAVIGATION: {},
  NUMBER: {},
  OFFSET_TEASER: {},
  OFFSET_TEASER5: {},
  OPTION_PICKER_ITEM: {},
  PAGINATION: {},
  PRELOADER_CIRCLE: {},
  PRELOADER_SQUARES: {},
  PROGRESS_CIRCLE: {},
  PROMO_FLAG: {},
  PAGE_HEADER: {},
  PICTOGRAM: {},
  RADIO_BUTTON: {},
  READ_MORE: {},
  RTE_RENDERER: {},
  SECTION: {},
  SEARCH_RESULT_ITEM: {},
  SEGMENTED_BUTTON: {},
  SITELINK: {},
  SLIDER: {},
  SWITCH_TOGGLE: {},
  SPACER: {},
  STAGE: {},
  STATE_PILL: {},
  STEP: {},
  STEPS: {},
  TABLE_RENDERER: {},
  TAB_NAVIGATION: {},
  TABS: {},
  TAG_PILL: {},
  TEXT: {},
  TEXT_TEASER: {},
  THIRD_LEVEL_NAVIGATION: {},
  THIRD_LEVEL_NAVIGATION_ITEM: {},
  TILES_TEASER: {},
  TOOLTIP: {},
  VIDEOPLAYER: {},
  VIOLATOR: {},
  WEBSITE_NAVIGATION: {}
};

export const BACKGROUND_COLORS = [
  // COLOR_ULTRALIGHTGREY,
  // COLOR_WHITE,
  // COLOR_LIGHTGREY,

  COLOR_BLUE,
  COLOR_DARKBLUE,
  COLOR_BLUE_ACTIVE,
  COLOR_GREEN,
  COLOR_ORANGE,
  COLOR_ORANGE_ACTIVE,
  COLOR_TEAL,
  COLOR_TEAL_ACTIVE,
  COLOR_TURQUOISE,
  COLOR_TURQUOISE_ACTIVE,
  COLOR_LIGHTTEAL,
  COLOR_MIDDLETEAL,
  COLOR_LIGHTBLUE,
  COLOR_MIDDLEBLUE,
  COLOR_BLUE_BORDER,
  COLOR_RED,
  COLOR_YELLOW,
  COLOR_LIGHTTURQUOISE,
  COLOR_MIDDLETURQUOISE,
  COLOR_GREEN_BORDER,
  COLOR_GREEN_ACTIVE,
  COLOR_LIGHTGREEN,
  COLOR_MIDDLEGREEN,
  COLOR_LIGHTORANGE,
  COLOR_MIDDLEORANGE,
  COLOR_BRIGHT,
  COLOR_DARK,
  COLOR_LIGHT_GREY,
  COLOR_TRANSPARENT_GREEN,
  COLOR_TRANSPARENT_RED,
  COLOR_TRANSPARENT_YELLOW,
  COLOR_TRANSPARENT_BLUE,
  COLOR_WHITE,
  COLOR_BLACK
];

export interface BackgroundSchemeConfiguration<T> {
  // white?: T;
  // lightgrey?: T;
  // ultralightgrey?: T;

  blue?: T;
  darkblue?: T;
  blueActive?: T;
  green?: T;
  orange?: T;
  orangeActive?: T;
  teal?: T;
  tealActive?: T;
  turquoise?: T;
  turquoiseActive?: T;
  lightteal?: T;
  middleteal?: T;
  lightblue?: T;
  middleblue?: T;
  blueBorder?: T;
  red?: T;
  yellow?: T;
  lightturquoise?: T;
  middleturquoise?: T;
  greenBorder?: T;
  greenActive?: T;
  lightgreen?: T;
  middlegreen?: T;
  lightorange?: T;
  middleorange?: T;
  bright?: T;
  dark?: T;
  lightGrey?: T;
  transparentGreen?: T;
  transparentRed?: T;
  transparentYellow?: T;
  transparentBlue?: T;
  white?: T;
  black?: T;
}

interface ColorMap {
  [name: string]: string | boolean | number;
}

export interface SchemeConfig {
  schemeName: string;
  scheme?: ColorMap;
}

export type EonColor = typeof EON_COLORS[number];

/* PLOP_INJECT_ALIGNMENT */
